/* tslint:disable */
/* eslint-disable */
/**
 * Lifestack Science API (staging)
 * powered by Flasgger
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Comprehensive adjustments object that allows the AI to modify user\'s schedule, meals, sleep, tasks, and routines. This structure is returned as part of the unified_chat_responses array in UnifiedChatResponseV2 format. 
 * @export
 * @interface Adjustments
 */
export interface Adjustments {
    /**
     * Meal timing adjustments (add, update, or remove meal times)
     * @type {Array<MealAdjustment>}
     * @memberof Adjustments
     */
    'meals'?: Array<MealAdjustment> | null;
    /**
     * Routine activity adjustments for permanent changes to recurring routines. Unlike schedule/meal adjustments which affect specific dates, routine_adjustments modify the user\'s recurring routines that affect all future days. 
     * @type {Array<RoutineAdjustment>}
     * @memberof Adjustments
     */
    'routine_adjustments'?: Array<RoutineAdjustment> | null;
    /**
     * Calendar event adjustments (add, update, or remove events)
     * @type {Array<ScheduleAdjustment>}
     * @memberof Adjustments
     */
    'schedule'?: Array<ScheduleAdjustment> | null;
    /**
     * 
     * @type {SleepSchedule}
     * @memberof Adjustments
     */
    'sleep'?: SleepSchedule;
    /**
     * Task adjustments (add, update, or remove tasks from todo list)
     * @type {Array<TodoAdjustment>}
     * @memberof Adjustments
     */
    'todo_list'?: Array<TodoAdjustment> | null;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesCreatePost201Response
 */
export interface ApiV1SchedulerRulesCreatePost201Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'message'?: string;
    /**
     * Unique identifier for the created rule (UUID)
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'rule_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost201Response
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesCreatePost400Response
 */
export interface ApiV1SchedulerRulesCreatePost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesCreatePost500Response
 */
export interface ApiV1SchedulerRulesCreatePost500Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePost500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesCreatePostRequest
 */
export interface ApiV1SchedulerRulesCreatePostRequest {
    /**
     * Additional tags beyond \'scheduler_rule\' (optional)
     * @type {Array<string>}
     * @memberof ApiV1SchedulerRulesCreatePostRequest
     */
    'additional_tags'?: Array<string>;
    /**
     * The rule content/description
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePostRequest
     */
    'content': string;
    /**
     * Source of the rule (optional, defaults to \'user_input\')
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePostRequest
     */
    'source'?: string;
    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof ApiV1SchedulerRulesCreatePostRequest
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesDeletePost200Response
 */
export interface ApiV1SchedulerRulesDeletePost200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost200Response
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost200Response
     */
    'message'?: string;
    /**
     * The unique identifier for the deleted rule
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost200Response
     */
    'rule_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiV1SchedulerRulesDeletePost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost200Response
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesDeletePost400Response
 */
export interface ApiV1SchedulerRulesDeletePost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesDeletePost404Response
 */
export interface ApiV1SchedulerRulesDeletePost404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost404Response
     */
    'error'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiV1SchedulerRulesDeletePost404Response
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesDeletePost500Response
 */
export interface ApiV1SchedulerRulesDeletePost500Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePost500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesDeletePostRequest
 */
export interface ApiV1SchedulerRulesDeletePostRequest {
    /**
     * The unique identifier for the rule to delete
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePostRequest
     */
    'rule_id': string;
    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof ApiV1SchedulerRulesDeletePostRequest
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesListGet200Response
 */
export interface ApiV1SchedulerRulesListGet200Response {
    /**
     * Number of rules returned
     * @type {number}
     * @memberof ApiV1SchedulerRulesListGet200Response
     */
    'count'?: number;
    /**
     * Array of scheduler rules
     * @type {Array<ApiV1SchedulerRulesListGet200ResponseRulesInner>}
     * @memberof ApiV1SchedulerRulesListGet200Response
     */
    'rules'?: Array<ApiV1SchedulerRulesListGet200ResponseRulesInner>;
    /**
     * The user identifier
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet200Response
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesListGet200ResponseRulesInner
 */
export interface ApiV1SchedulerRulesListGet200ResponseRulesInner {
    /**
     * The rule content/description
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'content'?: string;
    /**
     * Human-readable creation date
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'created_at'?: string;
    /**
     * Unique identifier for the rule (UUID)
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'id'?: string;
    /**
     * Source of the rule
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'source'?: string;
    /**
     * Tags associated with the rule
     * @type {Array<string>}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'tags'?: Array<string>;
    /**
     * Unix timestamp when the rule was created
     * @type {number}
     * @memberof ApiV1SchedulerRulesListGet200ResponseRulesInner
     */
    'timestamp'?: number;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesListGet500Response
 */
export interface ApiV1SchedulerRulesListGet500Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesListGet500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesUpdatePost200Response
 */
export interface ApiV1SchedulerRulesUpdatePost200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost200Response
     */
    'new_content'?: string;
    /**
     * The unique identifier for the updated rule
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost200Response
     */
    'rule_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiV1SchedulerRulesUpdatePost200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost200Response
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesUpdatePost404Response
 */
export interface ApiV1SchedulerRulesUpdatePost404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost404Response
     */
    'error'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiV1SchedulerRulesUpdatePost404Response
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesUpdatePost500Response
 */
export interface ApiV1SchedulerRulesUpdatePost500Response {
    /**
     * 
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePost500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1SchedulerRulesUpdatePostRequest
 */
export interface ApiV1SchedulerRulesUpdatePostRequest {
    /**
     * Additional tags beyond \'scheduler_rule\' (optional)
     * @type {Array<string>}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'additional_tags'?: Array<string>;
    /**
     * The new rule content
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'new_content'?: string;
    /**
     * Complete new tags list (replaces existing tags)
     * @type {Array<string>}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'new_tags'?: Array<string>;
    /**
     * The unique identifier for the rule to update
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'rule_id': string;
    /**
     * Source of the update (optional, defaults to \'user_update\')
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'source'?: string;
    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof ApiV1SchedulerRulesUpdatePostRequest
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface AudioPlayerPayload
 */
export interface AudioPlayerPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof AudioPlayerPayload
     */
    'category'?: string;
    /**
     * 
     * @type {number}
     * @memberof AudioPlayerPayload
     */
    'duration_min'?: number;
    /**
     * 
     * @type {string}
     * @memberof AudioPlayerPayload
     */
    'stream_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AudioPlayerPayload
     */
    'track_name'?: string;
}
/**
 * 
 * @export
 * @interface CalcSleepScoreRequest
 */
export interface CalcSleepScoreRequest {
    /**
     * The duration of awake time in minutes.
     * @type {number}
     * @memberof CalcSleepScoreRequest
     */
    'awake_min'?: number;
    /**
     * The duration of deep sleep in minutes.
     * @type {number}
     * @memberof CalcSleepScoreRequest
     */
    'deep_min'?: number;
    /**
     * The duration of light sleep in minutes.
     * @type {number}
     * @memberof CalcSleepScoreRequest
     */
    'light_min'?: number;
    /**
     * The duration of REM sleep in minutes.
     * @type {number}
     * @memberof CalcSleepScoreRequest
     */
    'rem_min'?: number;
    /**
     * The array of sleep times in datetime format.
     * @type {Array<string>}
     * @memberof CalcSleepScoreRequest
     */
    'sleep_time_array'?: Array<string>;
    /**
     * The array of wake times in datetime format.
     * @type {Array<string>}
     * @memberof CalcSleepScoreRequest
     */
    'wake_time_array'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CalcSleepScoreSimpleRequest
 */
export interface CalcSleepScoreSimpleRequest {
    /**
     * Array of sleep times
     * @type {Array<string>}
     * @memberof CalcSleepScoreSimpleRequest
     */
    'sleep_time_array': Array<string>;
    /**
     * Time spent in bed in minutes
     * @type {number}
     * @memberof CalcSleepScoreSimpleRequest
     */
    'time_in_bed'?: number;
    /**
     * Total sleep time in minutes
     * @type {number}
     * @memberof CalcSleepScoreSimpleRequest
     */
    'total_sleep'?: number;
    /**
     * Array of wake times
     * @type {Array<string>}
     * @memberof CalcSleepScoreSimpleRequest
     */
    'wake_time_array': Array<string>;
}
/**
 * Attendee information for a calendar event
 * @export
 * @interface CalendarEventAttendee
 */
export interface CalendarEventAttendee {
    /**
     * Attendee display name
     * @type {string}
     * @memberof CalendarEventAttendee
     */
    'displayName'?: string | null;
    /**
     * Attendee email address
     * @type {string}
     * @memberof CalendarEventAttendee
     */
    'email'?: string | null;
    /**
     * True if the attendee is optional
     * @type {boolean}
     * @memberof CalendarEventAttendee
     */
    'optional'?: boolean | null;
    /**
     * True if the attendee is the organizer
     * @type {boolean}
     * @memberof CalendarEventAttendee
     */
    'organizer'?: boolean | null;
    /**
     * The attendee\'s response status
     * @type {string}
     * @memberof CalendarEventAttendee
     */
    'responseStatus'?: string | null;
    /**
     * True if the attendee is the authenticated user
     * @type {boolean}
     * @memberof CalendarEventAttendee
     */
    'self'?: boolean | null;
}
/**
 * Comprehensive calendar event model matching the Python CalendarEventModel structure. This model includes all fields for calendar events including attendees, metrics, and scheduling actions. 
 * @export
 * @interface CalendarEventModel
 */
export interface CalendarEventModel {
    /**
     * Unique identifier for tracking this action across scheduler sessions. Auto-generated UUID that persists through adjustments to detect moved, deleted, or duplicated events. 
     * @type {string}
     * @memberof CalendarEventModel
     */
    'action_id'?: string | null;
    /**
     * The attendees of the event, if applicable
     * @type {Array<CalendarEventAttendee>}
     * @memberof CalendarEventModel
     */
    'attendees'?: Array<CalendarEventAttendee> | null;
    /**
     * Event category
     * @type {string}
     * @memberof CalendarEventModel
     */
    'category'?: string | null;
    /**
     * A brief description of the event, if applicable
     * @type {string}
     * @memberof CalendarEventModel
     */
    'description'?: string | null;
    /**
     * Optional duration in minutes; include when known to aid downstream displays
     * @type {number}
     * @memberof CalendarEventModel
     */
    'duration'?: number | null;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof CalendarEventModel
     */
    'end_date'?: string;
    /**
     * Day offset for the event end relative to the response date. Use 0 for same-day end, 1 when the event ends on the next day. 
     * @type {number}
     * @memberof CalendarEventModel
     */
    'end_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof CalendarEventModel
     */
    'end_time'?: string;
    /**
     * Source of the event
     * @type {string}
     * @memberof CalendarEventModel
     */
    'event_from'?: CalendarEventModelEventFromEnum | null;
    /**
     * Unique identifier for this event. For events with event_id, this must preserve the original event_id. 
     * @type {string}
     * @memberof CalendarEventModel
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {EventMetrics}
     * @memberof CalendarEventModel
     */
    'event_metrics'?: EventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof CalendarEventModel
     */
    'event_type'?: CalendarEventModelEventTypeEnum | null;
    /**
     * A brief explanation of why this event is scheduled at this time, referencing energy levels, conflicts, or optimization principles. 
     * @type {string}
     * @memberof CalendarEventModel
     */
    'explanation'?: string | null;
    /**
     * The location of the event, if applicable
     * @type {string}
     * @memberof CalendarEventModel
     */
    'location'?: string | null;
    /**
     * The link to the meeting, if applicable
     * @type {string}
     * @memberof CalendarEventModel
     */
    'meeting_link'?: string | null;
    /**
     * Event name shown to the user
     * @type {string}
     * @memberof CalendarEventModel
     */
    'name': string;
    /**
     * Original routine activity ID if event was created from a routine
     * @type {string}
     * @memberof CalendarEventModel
     */
    'origin_routine_activity_id'?: string | null;
    /**
     * Original todo ID if event was created from a todo
     * @type {string}
     * @memberof CalendarEventModel
     */
    'origin_todo_id'?: string | null;
    /**
     * Action to perform on the event when returned in adjustments: - \"add\": Create a new calendar event (requires start_time, end_time, and other event details) - \"update\": Modify an existing event (requires event_id or action_id, start_time, end_time, and updated fields) - \"remove\": Delete an existing event (requires event_id or action_id, name; start_time and end_time are optional) Only include changed events in adjustments - unchanged events should not be included. 
     * @type {string}
     * @memberof CalendarEventModel
     */
    'schedule_action'?: CalendarEventModelScheduleActionEnum | null;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof CalendarEventModel
     */
    'start_date'?: string;
    /**
     * Day offset for the event start relative to the response date. Use 0 for same-day start, 1 when the event starts on the next day. 
     * @type {number}
     * @memberof CalendarEventModel
     */
    'start_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof CalendarEventModel
     */
    'start_time'?: string;
    /**
     * The status of the event
     * @type {string}
     * @memberof CalendarEventModel
     */
    'status'?: CalendarEventModelStatusEnum | null;
}

export const CalendarEventModelEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Activity: 'activity',
    Todo: 'todo',
    Meal: 'meal',
    Sleep: 'sleep',
    Routine: 'routine',
    Workout: 'workout'
} as const;

export type CalendarEventModelEventFromEnum = typeof CalendarEventModelEventFromEnum[keyof typeof CalendarEventModelEventFromEnum];
export const CalendarEventModelEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type CalendarEventModelEventTypeEnum = typeof CalendarEventModelEventTypeEnum[keyof typeof CalendarEventModelEventTypeEnum];
export const CalendarEventModelScheduleActionEnum = {
    Add: 'add',
    Update: 'update',
    Remove: 'remove'
} as const;

export type CalendarEventModelScheduleActionEnum = typeof CalendarEventModelScheduleActionEnum[keyof typeof CalendarEventModelScheduleActionEnum];
export const CalendarEventModelStatusEnum = {
    Confirmed: 'confirmed',
    Tentative: 'tentative',
    Cancelled: 'cancelled'
} as const;

export type CalendarEventModelStatusEnum = typeof CalendarEventModelStatusEnum[keyof typeof CalendarEventModelStatusEnum];

/**
 * 
 * @export
 * @interface CardioPlanItem
 */
export interface CardioPlanItem {
    /**
     * 
     * @type {string}
     * @memberof CardioPlanItem
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CardioPlanItem
     */
    'estimated_calories'?: number;
    /**
     * 
     * @type {string}
     * @memberof CardioPlanItem
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CardioPlanItem
     */
    'rounds'?: number;
    /**
     * 
     * @type {Array<CardioSegment>}
     * @memberof CardioPlanItem
     */
    'segments'?: Array<CardioSegment>;
    /**
     * 
     * @type {string}
     * @memberof CardioPlanItem
     */
    'type': CardioPlanItemTypeEnum;
}

export const CardioPlanItemTypeEnum = {
    CardioPlan: 'cardio_plan'
} as const;

export type CardioPlanItemTypeEnum = typeof CardioPlanItemTypeEnum[keyof typeof CardioPlanItemTypeEnum];

/**
 * 
 * @export
 * @interface CardioSegment
 */
export interface CardioSegment {
    /**
     * 
     * @type {number}
     * @memberof CardioSegment
     */
    'distance_km'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CardioSegment
     */
    'duration_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CardioSegment
     */
    'duration_sec'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CardioSegment
     */
    'pace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardioSegment
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ChecklistItem
 */
export interface ChecklistItem {
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistItem
     */
    'done': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface ChecklistPayload
 */
export interface ChecklistPayload {
    [key: string]: any;

    /**
     * 
     * @type {Array<ChecklistItem>}
     * @memberof ChecklistPayload
     */
    'items'?: Array<ChecklistItem>;
    /**
     * 
     * @type {string}
     * @memberof ChecklistPayload
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface CombineEnergyEMA200Response
 */
export interface CombineEnergyEMA200Response {
    /**
     * The combined circadian sine wave as a list of floats
     * @type {Array<number>}
     * @memberof CombineEnergyEMA200Response
     */
    'combined_energy'?: Array<number>;
    /**
     * The curve of ema energy
     * @type {Array<number>}
     * @memberof CombineEnergyEMA200Response
     */
    'ema_generated_energy'?: Array<number>;
    /**
     * The array of ema timestamps
     * @type {Array<number>}
     * @memberof CombineEnergyEMA200Response
     */
    'ema_timestamps'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CombineEnergyEMARequest
 */
export interface CombineEnergyEMARequest {
    /**
     * EMADatePhaseScoreSet
     * @type {object}
     * @memberof CombineEnergyEMARequest
     * @deprecated
     */
    'ema'?: object;
    /**
     * Original energy
     * @type {Array<number>}
     * @memberof CombineEnergyEMARequest
     */
    'energy'?: Array<number>;
    /**
     * 
     * @type {Array<object>}
     * @memberof CombineEnergyEMARequest
     */
    'new_ema'?: Array<object>;
}
/**
 * 
 * @export
 * @interface CommuteSignalData
 */
export interface CommuteSignalData {
    /**
     * 
     * @type {string}
     * @memberof CommuteSignalData
     */
    'destination'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommuteSignalData
     */
    'duration_min'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommuteSignalData
     */
    'mode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommuteSignalData
     */
    'origin'?: string | null;
}
/**
 * @type ContentPayload
 * Domain-specific content card payload. Shape depends on `content.type`: - `meal_suggestion`: type, title, description, food_items, macros, micros, start_time, end_time - `find_location`: query, dish_tags, nearby_places - `workout_plan`: plan_title, workout_type (WorkoutType), difficulty (DifficultyLevel), duration_min, exercises[ExerciseItem], nearby_places? - `transit_route`: origin, destination, depart_by - `sleep_summary`: duration_h, quality_score, stages{<stage>.duration_min}, efficiency, sleep_source, sleep_time, awake_time, temperature_delta, history, suggested_sleep, ideal_sleep_time_tonight, heart_rate_summary - `hr_summary`: date, max_hr_bpm, min_hr_bpm, avg_hr_bpm, timeline[{timestamp, value}] - `energy_summary`: current_zone, zones[{label, start, end, level}], current_window{start,end,level}, next_zone{label,start,end,level}, minutes_to_next_zone - `checklist`: label, items[{text, done}] - `journal_prompts`: label, prompts[] - `audio_player`: track_name, category, duration_min, stream_url - `metric_bar`: label, value, unit, min, max, baseline, color_ramp 
 * @export
 */
export type ContentPayload = AudioPlayerPayload | ChecklistPayload | EnergySummaryPayload | FindLocationPayload | HRSummaryPayload | JournalPromptsPayload | MealSuggestionPayload | MetricBarPayload | SleepSummaryPayload | TransitRoutePayload | WorkoutPlanPayload;

/**
 * 
 * @export
 * @interface DiagnoseChronotype200Response
 */
export interface DiagnoseChronotype200Response {
    /**
     * Average mid-sleep time in HH:MM format (24-hour)
     * @type {string}
     * @memberof DiagnoseChronotype200Response
     */
    'average_midpoint': string;
    /**
     * Average mid-sleep time in minutes from midnight (0-1439)
     * @type {number}
     * @memberof DiagnoseChronotype200Response
     */
    'average_midpoint_minutes': number;
    /**
     * Diagnosed chronotype based on mid-sleep timing. Morning: 12:00-02:24, Hybrid: 02:24-04:15, Night: 04:15-12:00
     * @type {string}
     * @memberof DiagnoseChronotype200Response
     */
    'chronotype': DiagnoseChronotype200ResponseChronotypeEnum;
    /**
     * Source of data used for calculation. \"weekend\" if weekend data available, \"all\" if using all available data
     * @type {string}
     * @memberof DiagnoseChronotype200Response
     */
    'midpoint_source': DiagnoseChronotype200ResponseMidpointSourceEnum;
    /**
     * Number of sleep entries used in the calculation (up to 4 most recent)
     * @type {number}
     * @memberof DiagnoseChronotype200Response
     */
    'midpoints_used': number;
}

export const DiagnoseChronotype200ResponseChronotypeEnum = {
    Morning: 'morning',
    Hybrid: 'hybrid',
    Night: 'night'
} as const;

export type DiagnoseChronotype200ResponseChronotypeEnum = typeof DiagnoseChronotype200ResponseChronotypeEnum[keyof typeof DiagnoseChronotype200ResponseChronotypeEnum];
export const DiagnoseChronotype200ResponseMidpointSourceEnum = {
    Weekend: 'weekend',
    All: 'all'
} as const;

export type DiagnoseChronotype200ResponseMidpointSourceEnum = typeof DiagnoseChronotype200ResponseMidpointSourceEnum[keyof typeof DiagnoseChronotype200ResponseMidpointSourceEnum];

/**
 * 
 * @export
 * @interface DiagnoseChronotype400Response
 */
export interface DiagnoseChronotype400Response {
    /**
     * Error message describing the validation failure
     * @type {string}
     * @memberof DiagnoseChronotype400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DiagnoseChronotype500Response
 */
export interface DiagnoseChronotype500Response {
    /**
     * Error message describing the internal error
     * @type {string}
     * @memberof DiagnoseChronotype500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DiagnoseChronotypeRequest
 */
export interface DiagnoseChronotypeRequest {
    /**
     * Array of sleep history entries from the past 2 weeks. Each entry should contain sleep and wake times, and optionally date or day information.
     * @type {Array<DiagnoseChronotypeRequestSleepHistoryInner>}
     * @memberof DiagnoseChronotypeRequest
     */
    'sleep_history': Array<DiagnoseChronotypeRequestSleepHistoryInner>;
}
/**
 * 
 * @export
 * @interface DiagnoseChronotypeRequestSleepHistoryInner
 */
export interface DiagnoseChronotypeRequestSleepHistoryInner {
    /**
     * Date of the sleep entry in ISO-8601 format (YYYY-MM-DD). Used for weekend detection and chronological sorting.
     * @type {string}
     * @memberof DiagnoseChronotypeRequestSleepHistoryInner
     */
    'date'?: string;
    /**
     * Day of the week label (case-insensitive). Used as fallback when date is not available. Alternative key: weekday
     * @type {string}
     * @memberof DiagnoseChronotypeRequestSleepHistoryInner
     */
    'day_of_week'?: string;
    /**
     * Sleep time in HH:MM format (24-hour). Alternative keys accepted: sleeptime, sleepTime
     * @type {string}
     * @memberof DiagnoseChronotypeRequestSleepHistoryInner
     */
    'sleep_time': string;
    /**
     * Wake time in HH:MM format (24-hour). Alternative keys accepted: waketime, wakeTime, awake_time
     * @type {string}
     * @memberof DiagnoseChronotypeRequestSleepHistoryInner
     */
    'wake_time': string;
}
/**
 * 
 * @export
 * @interface EndToEndStreaming400Response
 */
export interface EndToEndStreaming400Response {
    /**
     * Detailed error message describing the validation issue
     * @type {string}
     * @memberof EndToEndStreaming400Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface EndToEndStreaming500Response
 */
export interface EndToEndStreaming500Response {
    /**
     * Internal error message
     * @type {string}
     * @memberof EndToEndStreaming500Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface EndToEndStreamingRequest
 */
export interface EndToEndStreamingRequest {
    /**
     * Optional trace ID for tracking requests across services
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'chat_id'?: string;
    /**
     * Current date in YYYY-MM-DD format (today\'s date, used for context)
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'current_date': string;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'current_time': string;
    /**
     * Scheduled date in YYYY-MM-DD format (required for scheduler_chat session_type). Specifies which scheduled date to chat about. Must match the date used when generating the schedule. For scheduler_chat, this is used to look up the scheduler session. 
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'date'?: string;
    /**
     * Optional flag to include timing information in debug logs
     * @type {boolean}
     * @memberof EndToEndStreamingRequest
     */
    'debug_timing'?: boolean;
    /**
     * Unique metric identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'metric_id': string;
    /**
     * Unique preference identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'preference_id': string;
    /**
     * Optional flag to return routing decision in response (not applicable for streaming endpoint)
     * @type {boolean}
     * @memberof EndToEndStreamingRequest
     */
    'return_routing_decision'?: boolean;
    /**
     * Unique routine identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'routine_id': string;
    /**
     * Type of streaming chat session. - \"freeText\": General lifestyle optimization chat - \"scheduler_chat\": Chat about a previously generated schedule (requires \'date\' parameter) 
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'session_type': EndToEndStreamingRequestSessionTypeEnum;
    /**
     * Unique user identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'user_id': string;
    /**
     * Initial user message or question to start the conversation
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'user_message': string;
    /**
     * User\'s time format (\'ampm\' or \'24h\')
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'user_time_format': string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\'). Used to convert timestamps between user\'s local time and UTC for database operations.
     * @type {string}
     * @memberof EndToEndStreamingRequest
     */
    'user_tz': string;
}

export const EndToEndStreamingRequestSessionTypeEnum = {
    FreeText: 'freeText',
    SchedulerChat: 'scheduler_chat'
} as const;

export type EndToEndStreamingRequestSessionTypeEnum = typeof EndToEndStreamingRequestSessionTypeEnum[keyof typeof EndToEndStreamingRequestSessionTypeEnum];

/**
 * 
 * @export
 * @interface EndToEndStreamingV2500Response
 */
export interface EndToEndStreamingV2500Response {
    /**
     * 
     * @type {string}
     * @memberof EndToEndStreamingV2500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface EndToEndStreamingV2Request
 */
export interface EndToEndStreamingV2Request {
    /**
     * Optional trace ID for tracking requests across services
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'chat_id'?: string;
    /**
     * Current date in YYYY-MM-DD format (today\'s date, used for context)
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'current_date': string;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'current_time': string;
    /**
     * Scheduled date in YYYY-MM-DD format (required for scheduler_chat session_type). Specifies which scheduled date to chat about. Must match the date used when generating the schedule. For scheduler_chat, this is used to look up the scheduler session. 
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'date'?: string;
    /**
     * Optional flag to include timing information in debug logs
     * @type {boolean}
     * @memberof EndToEndStreamingV2Request
     */
    'debug_timing'?: boolean;
    /**
     * 
     * @type {EndToEndStreamingV2RequestHiddenContext}
     * @memberof EndToEndStreamingV2Request
     */
    'hidden_context'?: EndToEndStreamingV2RequestHiddenContext;
    /**
     * Unique metric identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'metric_id': string;
    /**
     * Unique preference identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'preference_id': string;
    /**
     * Optional flag to return routing decision in response (not applicable for streaming endpoint)
     * @type {boolean}
     * @memberof EndToEndStreamingV2Request
     */
    'return_routing_decision'?: boolean;
    /**
     * Unique routine identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'routine_id': string;
    /**
     * Type of streaming chat session. - \"freeText\": General lifestyle optimization chat - \"scheduler_chat\": Chat about a previously generated schedule (requires \'date\') - \"recommendationNow\": Instant recommendation mode - \"sleep\": Sleep advisor (uses MCP-fetched context) - \"meal\": Meal timing advisor (uses MCP-fetched context) - \"task\": Task timing advisor (uses MCP-fetched context, runs scheduler) 
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'session_type': EndToEndStreamingV2RequestSessionTypeEnum;
    /**
     * Unique user identifier for session management and personalization
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'user_id': string;
    /**
     * Initial user message or question to start the conversation
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'user_message': string;
    /**
     * User\'s time format (\'ampm\' or \'24h\')
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'user_time_format': string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\').
     * @type {string}
     * @memberof EndToEndStreamingV2Request
     */
    'user_tz': string;
}

export const EndToEndStreamingV2RequestSessionTypeEnum = {
    FreeText: 'freeText',
    SchedulerChat: 'scheduler_chat',
    RecommendationNow: 'recommendationNow',
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task'
} as const;

export type EndToEndStreamingV2RequestSessionTypeEnum = typeof EndToEndStreamingV2RequestSessionTypeEnum[keyof typeof EndToEndStreamingV2RequestSessionTypeEnum];

/**
 * Optional CTA resolution payload. When the user taps a CTA option from a `question` event, send the selected action + payload to resolve the conflict. 
 * @export
 * @interface EndToEndStreamingV2RequestHiddenContext
 */
export interface EndToEndStreamingV2RequestHiddenContext {
    /**
     * Selected CTA action
     * @type {string}
     * @memberof EndToEndStreamingV2RequestHiddenContext
     */
    'action'?: EndToEndStreamingV2RequestHiddenContextActionEnum;
    /**
     * Action-specific payload (event_id, requested_time, text, etc.)
     * @type {{ [key: string]: any; }}
     * @memberof EndToEndStreamingV2RequestHiddenContext
     */
    'payload'?: { [key: string]: any; };
}

export const EndToEndStreamingV2RequestHiddenContextActionEnum = {
    RescheduleEvent: 'reschedule_event',
    ModifyEvent: 'modify_event',
    DeleteEvent: 'delete_event',
    SkipItem: 'skip_item',
    ProceedAnyway: 'proceed_anyway',
    FreeTextReply: 'free_text_reply',
    SwitchTime: 'switch_time',
    DeferToTomorrow: 'defer_to_tomorrow'
} as const;

export type EndToEndStreamingV2RequestHiddenContextActionEnum = typeof EndToEndStreamingV2RequestHiddenContextActionEnum[keyof typeof EndToEndStreamingV2RequestHiddenContextActionEnum];

/**
 * 
 * @export
 * @interface EndToEndStreamingV3500Response
 */
export interface EndToEndStreamingV3500Response {
    /**
     * 
     * @type {string}
     * @memberof EndToEndStreamingV3500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface EndToEndStreamingV3Request
 */
export interface EndToEndStreamingV3Request {
    /**
     * Optional trace ID for tracking requests across services
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'chat_id'?: string;
    /**
     * Current date in YYYY-MM-DD format
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'current_date': string;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'current_time': string;
    /**
     * Scheduled date in YYYY-MM-DD format (required for `scheduler_chat` only). 
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'date'?: string;
    /**
     * 
     * @type {EndToEndStreamingV3RequestHiddenContext}
     * @memberof EndToEndStreamingV3Request
     */
    'hidden_context'?: EndToEndStreamingV3RequestHiddenContext;
    /**
     * Unique metric identifier
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'metric_id': string;
    /**
     * Unique preference identifier
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'preference_id': string;
    /**
     * Unique routine identifier
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'routine_id': string;
    /**
     * Optional session ID for prefetching
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'session_id'?: string;
    /**
     * Type of streaming chat session. - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date`) - `recommendationNow`: Instant recommendation mode - `sleep`: Sleep advisor (context from MCP) - `meal`: Meal timing advisor (context from MCP) - `task`: Task timing advisor (context from MCP, runs scheduler) 
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'session_type': EndToEndStreamingV3RequestSessionTypeEnum;
    /**
     * Unique user identifier
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'user_id': string;
    /**
     * User message or question
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'user_message': string;
    /**
     * User\'s time display format (\'ampm\' or \'24h\')
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'user_time_format': string;
    /**
     * User\'s timezone (e.g. \'America/New_York\', \'UTC\')
     * @type {string}
     * @memberof EndToEndStreamingV3Request
     */
    'user_tz': string;
}

export const EndToEndStreamingV3RequestSessionTypeEnum = {
    FreeText: 'freeText',
    SchedulerChat: 'scheduler_chat',
    RecommendationNow: 'recommendationNow',
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task'
} as const;

export type EndToEndStreamingV3RequestSessionTypeEnum = typeof EndToEndStreamingV3RequestSessionTypeEnum[keyof typeof EndToEndStreamingV3RequestSessionTypeEnum];

/**
 * Optional CTA resolution payload. When the user taps a CTA option from a `question` event, send the selected action + payload to resolve the conflict. 
 * @export
 * @interface EndToEndStreamingV3RequestHiddenContext
 */
export interface EndToEndStreamingV3RequestHiddenContext {
    /**
     * Selected CTA action
     * @type {string}
     * @memberof EndToEndStreamingV3RequestHiddenContext
     */
    'action'?: EndToEndStreamingV3RequestHiddenContextActionEnum;
    /**
     * Action-specific payload (event_id, requested_time, text, etc.)
     * @type {{ [key: string]: any; }}
     * @memberof EndToEndStreamingV3RequestHiddenContext
     */
    'payload'?: { [key: string]: any; };
}

export const EndToEndStreamingV3RequestHiddenContextActionEnum = {
    RescheduleEvent: 'reschedule_event',
    ModifyEvent: 'modify_event',
    DeleteEvent: 'delete_event',
    SkipItem: 'skip_item',
    ProceedAnyway: 'proceed_anyway',
    FreeTextReply: 'free_text_reply',
    SwitchTime: 'switch_time',
    DeferToTomorrow: 'defer_to_tomorrow'
} as const;

export type EndToEndStreamingV3RequestHiddenContextActionEnum = typeof EndToEndStreamingV3RequestHiddenContextActionEnum[keyof typeof EndToEndStreamingV3RequestHiddenContextActionEnum];

/**
 * 
 * @export
 * @interface EnergySignalData
 */
export interface EnergySignalData {
    /**
     * 
     * @type {number}
     * @memberof EnergySignalData
     */
    'hrv'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnergySignalData
     */
    'readiness_score'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnergySignalData
     */
    'sleep_score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnergySignalData
     */
    'zone'?: string | null;
    /**
     * 
     * @type {Array<RichContextEnergyZone>}
     * @memberof EnergySignalData
     */
    'zones'?: Array<RichContextEnergyZone>;
}
/**
 * 
 * @export
 * @interface EnergySummaryPayload
 */
export interface EnergySummaryPayload {
    [key: string]: any;

    /**
     * 
     * @type {EnergyWindow}
     * @memberof EnergySummaryPayload
     */
    'current_window'?: EnergyWindow;
    /**
     * 
     * @type {string}
     * @memberof EnergySummaryPayload
     */
    'current_zone'?: string;
    /**
     * 
     * @type {number}
     * @memberof EnergySummaryPayload
     */
    'minutes_to_next_zone'?: number;
    /**
     * 
     * @type {NextEnergyZone}
     * @memberof EnergySummaryPayload
     */
    'next_zone'?: NextEnergyZone;
    /**
     * 
     * @type {Array<RichContextEnergyZone>}
     * @memberof EnergySummaryPayload
     */
    'zones'?: Array<RichContextEnergyZone>;
}
/**
 * 
 * @export
 * @interface EnergyWindow
 */
export interface EnergyWindow {
    [key: string]: any;

    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EnergyWindow
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnergyWindow
     */
    'level'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EnergyWindow
     */
    'start'?: string;
}
/**
 * User\'s energy level zone
 * @export
 * @interface EnergyZone
 */
export interface EnergyZone {
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EnergyZone
     */
    'end_time': string;
    /**
     * Energy level (0-1 scale)
     * @type {number}
     * @memberof EnergyZone
     */
    'energy_level'?: number | null;
    /**
     * Zone category (peak or dip)
     * @type {string}
     * @memberof EnergyZone
     */
    'phase_category': EnergyZonePhaseCategoryEnum;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof EnergyZone
     */
    'start_time': string;
}

export const EnergyZonePhaseCategoryEnum = {
    Peak: 'peak',
    Dip: 'dip'
} as const;

export type EnergyZonePhaseCategoryEnum = typeof EnergyZonePhaseCategoryEnum[keyof typeof EnergyZonePhaseCategoryEnum];

/**
 * SSE payload for `event: enrichment_patch`. `field` is a dotpath rooted at the response item identified by `suggestion_id`. 
 * @export
 * @interface EnrichmentPatchEvent
 */
export interface EnrichmentPatchEvent {
    /**
     * Dotpath to the patched field (e.g. `query.rich_context.content.payload`).
     * @type {string}
     * @memberof EnrichmentPatchEvent
     */
    'field': string;
    /**
     * Human-readable status for progressive UI updates.
     * @type {string}
     * @memberof EnrichmentPatchEvent
     */
    'status_text': string;
    /**
     * Response entry identifier. For unified responses this is usually the date (`YYYY-MM-DD`); for flat responses it may be `flat`. 
     * @type {string}
     * @memberof EnrichmentPatchEvent
     */
    'suggestion_id': string;
    /**
     * 
     * @type {EnrichmentPatchValue}
     * @memberof EnrichmentPatchEvent
     */
    'value': EnrichmentPatchValue;
}
/**
 * @type EnrichmentPatchValue
 * Value payload for `enrichment_patch` SSE event. Depends on the patched field: - `*.enrichment_pending` -> boolean - `*.content.payload.nearby_places` -> NearbyPlace[] - `*.content.payload` -> one of typed content payloads - `adjustments.meals.{i}.content` -> MealSuggestionPayload 
 * @export
 */
export type EnrichmentPatchValue = Array<NearbyPlace> | AudioPlayerPayload | ChecklistPayload | EnergySummaryPayload | FindLocationPayload | HRSummaryPayload | JournalPromptsPayload | MealSuggestionPayload | MetricBarPayload | SleepSummaryPayload | TransitRoutePayload | WorkoutPlanPayload | boolean;

/**
 * Metrics for a calendar event
 * @export
 * @interface EventMetrics
 */
export interface EventMetrics {
    /**
     * Energy level feedback for the event
     * @type {string}
     * @memberof EventMetrics
     */
    'energy'?: EventMetricsEnergyEnum | null;
    /**
     * 
     * @type {HeartRate}
     * @memberof EventMetrics
     */
    'heart_rate'?: HeartRate | null;
    /**
     * Stress level feedback for the event (0-100 scale)
     * @type {number}
     * @memberof EventMetrics
     */
    'stress'?: number | null;
}

export const EventMetricsEnergyEnum = {
    Low: 'low',
    Mild: 'mild',
    Medium: 'medium',
    Strong: 'strong',
    High: 'high'
} as const;

export type EventMetricsEnergyEnum = typeof EventMetricsEnergyEnum[keyof typeof EventMetricsEnergyEnum];

/**
 * @type ExerciseItem
 * @export
 */
export type ExerciseItem = CardioPlanItem | GymExercise | MetaExerciseItem | NoteExerciseItem;

/**
 * 
 * @export
 * @interface FindLocationPayload
 */
export interface FindLocationPayload {
    [key: string]: any;

    /**
     * 
     * @type {Array<string>}
     * @memberof FindLocationPayload
     */
    'dish_tags'?: Array<string>;
    /**
     * 
     * @type {Array<NearbyPlace>}
     * @memberof FindLocationPayload
     */
    'nearby_places'?: Array<NearbyPlace> | null;
    /**
     * 
     * @type {string}
     * @memberof FindLocationPayload
     */
    'query'?: string;
}
/**
 * 
 * @export
 * @interface GeneralChat200Response
 */
export interface GeneralChat200Response {
    /**
     * Chat identifier for tracking
     * @type {string}
     * @memberof GeneralChat200Response
     */
    'chat_id': string;
    /**
     * The assistant\'s response to the user\'s message
     * @type {string}
     * @memberof GeneralChat200Response
     */
    'response': string;
    /**
     * Classification of the response type
     * @type {string}
     * @memberof GeneralChat200Response
     */
    'response_type': GeneralChat200ResponseResponseTypeEnum;
    /**
     * When the response was generated
     * @type {string}
     * @memberof GeneralChat200Response
     */
    'timestamp': string;
}

export const GeneralChat200ResponseResponseTypeEnum = {
    General: 'general',
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task'
} as const;

export type GeneralChat200ResponseResponseTypeEnum = typeof GeneralChat200ResponseResponseTypeEnum[keyof typeof GeneralChat200ResponseResponseTypeEnum];

/**
 * 
 * @export
 * @interface GeneralChat400Response
 */
export interface GeneralChat400Response {
    /**
     * Error message describing the validation failure
     * @type {string}
     * @memberof GeneralChat400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GeneralChat500Response
 */
export interface GeneralChat500Response {
    /**
     * Error message
     * @type {string}
     * @memberof GeneralChat500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GeneralChatRequest
 */
export interface GeneralChatRequest {
    /**
     * List of calendar events for context
     * @type {Array<GeneralChatRequestCalendarEventsInner>}
     * @memberof GeneralChatRequest
     */
    'calendar_events'?: Array<GeneralChatRequestCalendarEventsInner>;
    /**
     * Explicit context type to focus the conversation on specific lifestack domain. If not provided, defaults to \"general\"
     * @type {string}
     * @memberof GeneralChatRequest
     */
    'chat_context'?: GeneralChatRequestChatContextEnum;
    /**
     * Previous conversation history for context
     * @type {Array<GeneralChatRequestChatHistoryInner>}
     * @memberof GeneralChatRequest
     */
    'chat_history'?: Array<GeneralChatRequestChatHistoryInner>;
    /**
     * Optional chat identifier for tracking
     * @type {string}
     * @memberof GeneralChatRequest
     */
    'chat_id'?: string;
    /**
     * Optional current time in HH:MM format (24-hour) for time-aware responses
     * @type {string}
     * @memberof GeneralChatRequest
     */
    'current_time'?: string;
    /**
     * User\'s energy zones for context
     * @type {Array<GeneralChatRequestEnergyZonesInner>}
     * @memberof GeneralChatRequest
     */
    'energy_zones'?: Array<GeneralChatRequestEnergyZonesInner>;
    /**
     * List of todos for context
     * @type {Array<GeneralChatRequestTodoListInner>}
     * @memberof GeneralChatRequest
     */
    'todo_list'?: Array<GeneralChatRequestTodoListInner>;
    /**
     * 
     * @type {GeneralChatRequestUserContext}
     * @memberof GeneralChatRequest
     */
    'user_context'?: GeneralChatRequestUserContext;
    /**
     * The user\'s message or question
     * @type {string}
     * @memberof GeneralChatRequest
     */
    'user_message': string;
}

export const GeneralChatRequestChatContextEnum = {
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task',
    General: 'general'
} as const;

export type GeneralChatRequestChatContextEnum = typeof GeneralChatRequestChatContextEnum[keyof typeof GeneralChatRequestChatContextEnum];

/**
 * 
 * @export
 * @interface GeneralChatRequestCalendarEventsInner
 */
export interface GeneralChatRequestCalendarEventsInner {
    /**
     * Category of the event
     * @type {string}
     * @memberof GeneralChatRequestCalendarEventsInner
     */
    'category'?: string;
    /**
     * End time of the event (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestCalendarEventsInner
     */
    'end_time'?: string;
    /**
     * Name of the event
     * @type {string}
     * @memberof GeneralChatRequestCalendarEventsInner
     */
    'name'?: string;
    /**
     * Start time of the event (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestCalendarEventsInner
     */
    'start_time'?: string;
}
/**
 * 
 * @export
 * @interface GeneralChatRequestChatHistoryInner
 */
export interface GeneralChatRequestChatHistoryInner {
    /**
     * The message content
     * @type {string}
     * @memberof GeneralChatRequestChatHistoryInner
     */
    'content': string;
    /**
     * Who sent the message
     * @type {string}
     * @memberof GeneralChatRequestChatHistoryInner
     */
    'role': GeneralChatRequestChatHistoryInnerRoleEnum;
    /**
     * When the message was sent
     * @type {string}
     * @memberof GeneralChatRequestChatHistoryInner
     */
    'timestamp'?: string;
}

export const GeneralChatRequestChatHistoryInnerRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type GeneralChatRequestChatHistoryInnerRoleEnum = typeof GeneralChatRequestChatHistoryInnerRoleEnum[keyof typeof GeneralChatRequestChatHistoryInnerRoleEnum];

/**
 * 
 * @export
 * @interface GeneralChatRequestEnergyZonesInner
 */
export interface GeneralChatRequestEnergyZonesInner {
    /**
     * End time of the zone (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestEnergyZonesInner
     */
    'end_time'?: string;
    /**
     * zone category (peak or dip)
     * @type {string}
     * @memberof GeneralChatRequestEnergyZonesInner
     */
    'phase_category'?: GeneralChatRequestEnergyZonesInnerPhaseCategoryEnum;
    /**
     * Start time of the zone (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestEnergyZonesInner
     */
    'start_time'?: string;
}

export const GeneralChatRequestEnergyZonesInnerPhaseCategoryEnum = {
    Peak: 'peak',
    Dip: 'dip'
} as const;

export type GeneralChatRequestEnergyZonesInnerPhaseCategoryEnum = typeof GeneralChatRequestEnergyZonesInnerPhaseCategoryEnum[keyof typeof GeneralChatRequestEnergyZonesInnerPhaseCategoryEnum];

/**
 * 
 * @export
 * @interface GeneralChatRequestTodoListInner
 */
export interface GeneralChatRequestTodoListInner {
    /**
     * Whether the todo item is completed
     * @type {boolean}
     * @memberof GeneralChatRequestTodoListInner
     */
    'completed'?: boolean;
    /**
     * Duration of the todo in minutes
     * @type {number}
     * @memberof GeneralChatRequestTodoListInner
     */
    'duration'?: number;
    /**
     * Earliest time to start the todo (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestTodoListInner
     */
    'earliest_start'?: string;
    /**
     * List of labels for categorizing the todo
     * @type {Array<string>}
     * @memberof GeneralChatRequestTodoListInner
     */
    'labels'?: Array<string>;
    /**
     * Latest time to start the todo (HH:mm)
     * @type {string}
     * @memberof GeneralChatRequestTodoListInner
     */
    'latest_finish'?: string;
    /**
     * Whether the todo can be moved
     * @type {boolean}
     * @memberof GeneralChatRequestTodoListInner
     */
    'movable'?: boolean;
    /**
     * Name of the todo
     * @type {string}
     * @memberof GeneralChatRequestTodoListInner
     */
    'name'?: string;
    /**
     * relation to other todos (other event, time difference)
     * @type {Array<string>}
     * @memberof GeneralChatRequestTodoListInner
     */
    'relation'?: Array<string>;
    /**
     * Id of the todo
     * @type {string}
     * @memberof GeneralChatRequestTodoListInner
     */
    'todo_id'?: string;
}
/**
 * Optional context from user\'s current lifestack recommendations
 * @export
 * @interface GeneralChatRequestUserContext
 */
export interface GeneralChatRequestUserContext {
    /**
     * Detailed meal analysis from meal recommendation endpoint
     * @type {string}
     * @memberof GeneralChatRequestUserContext
     */
    'meals_detailed_explanation'?: string;
    /**
     * Detailed sleep analysis from sleep recommendation endpoint
     * @type {string}
     * @memberof GeneralChatRequestUserContext
     */
    'sleep_detailed_explanation'?: string;
    /**
     * Detailed task analysis from task recommendation endpoint
     * @type {string}
     * @memberof GeneralChatRequestUserContext
     */
    'task_detailed_explanation'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgent200Response
 */
export interface GenerateAISchedulerAgent200Response {
    /**
     * The difference between the input and output schedule (added, removed, changed events).
     * @type {Array<GenerateAISchedulerAgent200ResponseDeltaOutputInner>}
     * @memberof GenerateAISchedulerAgent200Response
     */
    'delta_output'?: Array<GenerateAISchedulerAgent200ResponseDeltaOutputInner>;
    /**
     * 
     * @type {Array<GenerateAISchedulerAgent200ResponseSchedulesInner>}
     * @memberof GenerateAISchedulerAgent200Response
     */
    'schedules'?: Array<GenerateAISchedulerAgent200ResponseSchedulesInner>;
    /**
     * A summary of what was changed or suggested by the agent.
     * @type {string}
     * @memberof GenerateAISchedulerAgent200Response
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgent200ResponseDeltaOutputInner
 */
export interface GenerateAISchedulerAgent200ResponseDeltaOutputInner {
    /**
     * The action that was taken (add, remove, modify)
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseDeltaOutputInner
     */
    'action'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgent200ResponseSchedulesInner
 */
export interface GenerateAISchedulerAgent200ResponseSchedulesInner {
    /**
     * Category of the scheduled event
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'category'?: string;
    /**
     * Duration of the scheduled event in minutes
     * @type {number}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'duration'?: number;
    /**
     * End time of the scheduled event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'end_time'?: string;
    /**
     * Source of the event - \'activity\' for AI-scheduled events, \'todo\' for todo-originated events
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'event_from'?: GenerateAISchedulerAgent200ResponseSchedulesInnerEventFromEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'name'?: string;
    /**
     * ID of the todo item that originiates the scheduled event
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'origin_todo_id'?: string;
    /**
     * Start time of the scheduled event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgent200ResponseSchedulesInner
     */
    'start_time'?: string;
}

export const GenerateAISchedulerAgent200ResponseSchedulesInnerEventFromEnum = {
    Activity: 'activity',
    Todo: 'todo',
    ExistingCalendar: 'existing_calendar'
} as const;

export type GenerateAISchedulerAgent200ResponseSchedulesInnerEventFromEnum = typeof GenerateAISchedulerAgent200ResponseSchedulesInnerEventFromEnum[keyof typeof GenerateAISchedulerAgent200ResponseSchedulesInnerEventFromEnum];

/**
 * 
 * @export
 * @interface GenerateAISchedulerAgent500Response
 */
export interface GenerateAISchedulerAgent500Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateAISchedulerAgent500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequest
 */
export interface GenerateAISchedulerAgentRequest {
    /**
     * List of activities
     * @type {Array<GenerateAISchedulerAgentRequestActivitiesInner>}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'activities'?: Array<GenerateAISchedulerAgentRequestActivitiesInner>;
    /**
     * Average wake time of the user (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'avg_wake_time'?: string;
    /**
     * the chat history from firestore to give scheduler context.
     * @type {Array<GenerateAISchedulerAgentRequestChatHistoryInner>}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'chat_history'?: Array<GenerateAISchedulerAgentRequestChatHistoryInner>;
    /**
     * Current time (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'current_time'?: string;
    /**
     * User\'s energy zones
     * @type {Array<GenerateAISchedulerAgentRequestEnergyZonesInner>}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'energy_zones'?: Array<GenerateAISchedulerAgentRequestEnergyZonesInner>;
    /**
     * Duration of the pomodoro in minutes. Minimum 30 min. Default 90 min
     * @type {number}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'pomodoro_duration'?: number;
    /**
     * List of events
     * @type {Array<GenerateAISchedulerAgentRequestPrescheduledEventsInner>}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'prescheduled_events'?: Array<GenerateAISchedulerAgentRequestPrescheduledEventsInner>;
    /**
     * 
     * @type {Array<GenerateAISchedulerAgentRequestSchedulesInner>}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'schedules'?: Array<GenerateAISchedulerAgentRequestSchedulesInner>;
    /**
     * the user input into the chat field to be sent to LLM.
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'user_input'?: string;
    /**
     * Wake time of the user if scheduling the day of (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'wake_time'?: string;
    /**
     * End time for work (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'work_end'?: string;
    /**
     * Start time for work (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequest
     */
    'work_start'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequestActivitiesInner
 */
export interface GenerateAISchedulerAgentRequestActivitiesInner {
    /**
     * Effect of the activity on the user (peak, neutral)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'activity_effect'?: GenerateAISchedulerAgentRequestActivitiesInnerActivityEffectEnum;
    /**
     * Category of the activity. Same as event category
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'category'?: string;
    /**
     * Duration of the activity in minutes
     * @type {number}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'duration'?: number;
    /**
     * Earliest time to start the activity (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'earliest'?: string;
    /**
     * Latest time to start the activity (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'latest'?: string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'name'?: string;
    /**
     * Scheduling method for the activity (fixed, flexible)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestActivitiesInner
     */
    'scheduling_method'?: GenerateAISchedulerAgentRequestActivitiesInnerSchedulingMethodEnum;
}

export const GenerateAISchedulerAgentRequestActivitiesInnerActivityEffectEnum = {
    Peak: 'peak',
    Neutral: 'neutral'
} as const;

export type GenerateAISchedulerAgentRequestActivitiesInnerActivityEffectEnum = typeof GenerateAISchedulerAgentRequestActivitiesInnerActivityEffectEnum[keyof typeof GenerateAISchedulerAgentRequestActivitiesInnerActivityEffectEnum];
export const GenerateAISchedulerAgentRequestActivitiesInnerSchedulingMethodEnum = {
    Fixed: 'fixed',
    Flexible: 'flexible'
} as const;

export type GenerateAISchedulerAgentRequestActivitiesInnerSchedulingMethodEnum = typeof GenerateAISchedulerAgentRequestActivitiesInnerSchedulingMethodEnum[keyof typeof GenerateAISchedulerAgentRequestActivitiesInnerSchedulingMethodEnum];

/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequestChatHistoryInner
 */
export interface GenerateAISchedulerAgentRequestChatHistoryInner {
    /**
     * The text content of the message (if applicable).
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInner
     */
    'content'?: string;
    /**
     * The role of the message sender (e.g., \'user\', \'assistant\', \'tool\').
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInner
     */
    'role': GenerateAISchedulerAgentRequestChatHistoryInnerRoleEnum;
    /**
     * The time the message was sent.
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInner
     */
    'timestamp'?: string;
    /**
     * 
     * @type {GenerateAISchedulerAgentRequestChatHistoryInnerToolCall}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInner
     */
    'tool_call'?: GenerateAISchedulerAgentRequestChatHistoryInnerToolCall;
}

export const GenerateAISchedulerAgentRequestChatHistoryInnerRoleEnum = {
    User: 'user',
    Assistant: 'assistant',
    Tool: 'tool'
} as const;

export type GenerateAISchedulerAgentRequestChatHistoryInnerRoleEnum = typeof GenerateAISchedulerAgentRequestChatHistoryInnerRoleEnum[keyof typeof GenerateAISchedulerAgentRequestChatHistoryInnerRoleEnum];

/**
 * The tool call details (if this message is a tool call).
 * @export
 * @interface GenerateAISchedulerAgentRequestChatHistoryInnerToolCall
 */
export interface GenerateAISchedulerAgentRequestChatHistoryInnerToolCall {
    /**
     * The arguments passed to the tool.
     * @type {object}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInnerToolCall
     */
    'arguments': object;
    /**
     * The name of the tool called.
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestChatHistoryInnerToolCall
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequestEnergyZonesInner
 */
export interface GenerateAISchedulerAgentRequestEnergyZonesInner {
    /**
     * End time of the zone (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestEnergyZonesInner
     */
    'end_time'?: string;
    /**
     * zone category (peak or dip)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestEnergyZonesInner
     */
    'phase_category'?: GenerateAISchedulerAgentRequestEnergyZonesInnerPhaseCategoryEnum;
    /**
     * Start time of the zone (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestEnergyZonesInner
     */
    'start_time'?: string;
}

export const GenerateAISchedulerAgentRequestEnergyZonesInnerPhaseCategoryEnum = {
    Peak: 'peak',
    Dip: 'dip'
} as const;

export type GenerateAISchedulerAgentRequestEnergyZonesInnerPhaseCategoryEnum = typeof GenerateAISchedulerAgentRequestEnergyZonesInnerPhaseCategoryEnum[keyof typeof GenerateAISchedulerAgentRequestEnergyZonesInnerPhaseCategoryEnum];

/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequestPrescheduledEventsInner
 */
export interface GenerateAISchedulerAgentRequestPrescheduledEventsInner {
    /**
     * Category of the event
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestPrescheduledEventsInner
     */
    'category'?: string;
    /**
     * End time of the event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestPrescheduledEventsInner
     */
    'end_time'?: string;
    /**
     * Name of the event
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestPrescheduledEventsInner
     */
    'name'?: string;
    /**
     * Start time of the event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestPrescheduledEventsInner
     */
    'start_time'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAISchedulerAgentRequestSchedulesInner
 */
export interface GenerateAISchedulerAgentRequestSchedulesInner {
    /**
     * Category of the scheduled event
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'category'?: string;
    /**
     * Duration of the scheduled event in minutes
     * @type {number}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'duration'?: number;
    /**
     * End time of the scheduled event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'end_time'?: string;
    /**
     * Source of the event - \'activity\' for AI-scheduled events, \'todo\' for todo-originated events
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'event_from'?: GenerateAISchedulerAgentRequestSchedulesInnerEventFromEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'name'?: string;
    /**
     * ID of the todo item that originiates the scheduled event
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'origin_todo_id'?: string;
    /**
     * Start time of the scheduled event (HH:mm)
     * @type {string}
     * @memberof GenerateAISchedulerAgentRequestSchedulesInner
     */
    'start_time'?: string;
}

export const GenerateAISchedulerAgentRequestSchedulesInnerEventFromEnum = {
    Activity: 'activity',
    Todo: 'todo',
    ExistingCalendar: 'existing_calendar'
} as const;

export type GenerateAISchedulerAgentRequestSchedulesInnerEventFromEnum = typeof GenerateAISchedulerAgentRequestSchedulesInnerEventFromEnum[keyof typeof GenerateAISchedulerAgentRequestSchedulesInnerEventFromEnum];

/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgent200Response
 */
export interface GenerateDailyPlanClaudeAgent200Response {
    /**
     * Error message if generation failed
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent200Response
     */
    'error'?: string | null;
    /**
     * Existing calendar events that were loaded from the context
     * @type {Array<CalendarEventModel>}
     * @memberof GenerateDailyPlanClaudeAgent200Response
     */
    'existing_schedule'?: Array<CalendarEventModel>;
    /**
     * 
     * @type {GenerateDailyPlanClaudeAgent200ResponseRoutingDecision}
     * @memberof GenerateDailyPlanClaudeAgent200Response
     */
    'routing_decision'?: GenerateDailyPlanClaudeAgent200ResponseRoutingDecision;
    /**
     * 
     * @type {Array<ScheduleEvent>}
     * @memberof GenerateDailyPlanClaudeAgent200Response
     */
    'schedules'?: Array<ScheduleEvent>;
    /**
     * A conversational summary of the generated plan
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent200Response
     */
    'summary'?: string;
}
/**
 * Routing decision information indicating which scheduler was used
 * @export
 * @interface GenerateDailyPlanClaudeAgent200ResponseRoutingDecision
 */
export interface GenerateDailyPlanClaudeAgent200ResponseRoutingDecision {
    /**
     * Complexity score used for routing decision (higher = more complex)
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgent200ResponseRoutingDecision
     */
    'complexity_score'?: number;
    /**
     * Explanation of why this routing decision was made
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent200ResponseRoutingDecision
     */
    'reasoning'?: string;
    /**
     * The selected route
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent200ResponseRoutingDecision
     */
    'route'?: string;
    /**
     * Whether Claude Agent SDK was used (true) or simple scheduler (false)
     * @type {boolean}
     * @memberof GenerateDailyPlanClaudeAgent200ResponseRoutingDecision
     */
    'use_claude_agent'?: boolean;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgent500Response
 */
export interface GenerateDailyPlanClaudeAgent500Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent500Response
     */
    'error'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof GenerateDailyPlanClaudeAgent500Response
     */
    'schedules'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgent500Response
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgentRequest
 */
export interface GenerateDailyPlanClaudeAgentRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'current_date'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'current_time'?: string;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'date'?: string;
    /**
     * Metric identifier for context loading (optional, defaults to \"primary\")
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'metric_id'?: string;
    /**
     * Preference identifier for user preferences (optional)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'preference_id'?: string | null;
    /**
     * Routine identifier for meal context (optional)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'routine_id'?: string | null;
    /**
     * List of routine activities to schedule (flat array of activities). Note: The API also accepts \'durationMin\' (alias for duration), \'start_time\', and \'end_time\' (legacy fields) for backward compatibility.
     * @type {Array<GenerateDailyPlanClaudeAgentRequestRoutinesInner>}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'routines'?: Array<GenerateDailyPlanClaudeAgentRequestRoutinesInner>;
    /**
     * List of tasks to schedule (from frontend selection). All fields are optional. Note: The API also accepts \'id\' (alias for todo_id), \'title\' (alias for name), and \'duration_minutes\' (alias for duration) for backward compatibility.
     * @type {Array<GenerateDailyPlanClaudeAgentRequestTasksInner>}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'tasks'?: Array<GenerateDailyPlanClaudeAgentRequestTasksInner>;
    /**
     * Unique user identifier (required)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'user_id': string;
    /**
     * Optional user instructions for schedule generation (optional)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'user_input'?: string | null;
    /**
     * User timezone (optional, used for context loading)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequest
     */
    'user_tz'?: string | null;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgentRequestRoutinesInner
 */
export interface GenerateDailyPlanClaudeAgentRequestRoutinesInner {
    /**
     * Effect on energy levels
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'activity_effect'?: GenerateDailyPlanClaudeAgentRequestRoutinesInnerActivityEffectEnum | null;
    /**
     * Category of the activity
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'category'?: string | null;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'duration': number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'earliest'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'latest'?: string;
    /**
     * Name of the routine activity
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'name': string;
    /**
     * Unique identifier for the routine activity
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'routine_activity_id'?: string | null;
    /**
     * How the activity should be scheduled
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'scheduling_method'?: GenerateDailyPlanClaudeAgentRequestRoutinesInnerSchedulingMethodEnum | null;
    /**
     * Duration in minutes (deprecated alias for duration)
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'durationMin'?: number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'end_time'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestRoutinesInner
     */
    'start_time'?: string;
}

export const GenerateDailyPlanClaudeAgentRequestRoutinesInnerActivityEffectEnum = {
    Peak: 'peak',
    Neutral: 'neutral',
    Dip: 'dip'
} as const;

export type GenerateDailyPlanClaudeAgentRequestRoutinesInnerActivityEffectEnum = typeof GenerateDailyPlanClaudeAgentRequestRoutinesInnerActivityEffectEnum[keyof typeof GenerateDailyPlanClaudeAgentRequestRoutinesInnerActivityEffectEnum];
export const GenerateDailyPlanClaudeAgentRequestRoutinesInnerSchedulingMethodEnum = {
    Fixed: 'fixed',
    Flexible: 'flexible'
} as const;

export type GenerateDailyPlanClaudeAgentRequestRoutinesInnerSchedulingMethodEnum = typeof GenerateDailyPlanClaudeAgentRequestRoutinesInnerSchedulingMethodEnum[keyof typeof GenerateDailyPlanClaudeAgentRequestRoutinesInnerSchedulingMethodEnum];

/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgentRequestTasksInner
 */
export interface GenerateDailyPlanClaudeAgentRequestTasksInner {
    /**
     * Task category
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'category'?: string | null;
    /**
     * Whether the task is completed
     * @type {boolean}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'completed'?: boolean | null;
    /**
     * Whether the task should be deleted
     * @type {boolean}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'deleted'?: boolean | null;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'duration'?: number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'earliest_start'?: string;
    /**
     * Brief explanation of why this task adjustment was made
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'explanation'?: string | null;
    /**
     * Labels associated with the task (used for category inference)
     * @type {Array<string>}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'labels'?: Array<string> | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'latest_finish'?: string;
    /**
     * Whether the task can be rescheduled
     * @type {boolean}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'movable'?: boolean | null;
    /**
     * Task name
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'name': string;
    /**
     * Priority level (lower = higher priority)
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'priority'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'suggested_end_time'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'suggested_start_time'?: string;
    /**
     * Unique identifier for the todo item
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'todo_id'?: string | null;
    /**
     * Duration in minutes (deprecated - use \'duration\' instead. Both fields contain the same value.)
     * @type {number}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'duration_minutes'?: number;
    /**
     * Alternative identifier for the task (optional, alias for todo_id)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'id'?: string;
    /**
     * Alternative name field for the task (optional, alias for \'name\')
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentRequestTasksInner
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanClaudeAgentStreamingRequest
 */
export interface GenerateDailyPlanClaudeAgentStreamingRequest {
    /**
     * Current date in YYYY-MM-DD format (deprecated, use \'date\' instead)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'current_date'?: string;
    /**
     * Current time in HH:MM format (deprecated, use \'date\' instead)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'current_time'?: string;
    /**
     * Date to plan for in YYYY-MM-DD format (required)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'date'?: string;
    /**
     * Metric identifier for context loading
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'metric_id'?: string;
    /**
     * Preference identifier for user preferences
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'preference_id'?: string;
    /**
     * Routine identifier for meal context
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'routine_id'?: string;
    /**
     * List of routine activities to schedule (flat array of activities)
     * @type {Array<RoutineActivity>}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'routines'?: Array<RoutineActivity>;
    /**
     * List of tasks to schedule (from frontend selection)
     * @type {Array<TodoItem>}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'tasks'?: Array<TodoItem>;
    /**
     * Unique user identifier (required)
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'user_id': string;
    /**
     * Optional user instructions for schedule generation
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'user_input'?: string;
    /**
     * User timezone
     * @type {string}
     * @memberof GenerateDailyPlanClaudeAgentStreamingRequest
     */
    'user_tz'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanV2200Response
 */
export interface GenerateDailyPlanV2200Response {
    /**
     * Error message if generation failed
     * @type {string}
     * @memberof GenerateDailyPlanV2200Response
     */
    'error'?: string | null;
    /**
     * Existing calendar events that were loaded from the context
     * @type {Array<CalendarEventModel>}
     * @memberof GenerateDailyPlanV2200Response
     */
    'existing_schedule'?: Array<CalendarEventModel>;
    /**
     * 
     * @type {Array<ScheduleEvent>}
     * @memberof GenerateDailyPlanV2200Response
     */
    'schedules'?: Array<ScheduleEvent>;
    /**
     * A conversational summary of the generated plan
     * @type {string}
     * @memberof GenerateDailyPlanV2200Response
     */
    'summary'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanV2Request
 */
export interface GenerateDailyPlanV2Request {
    /**
     * Current date in YYYY-MM-DD format (deprecated, use \'date\')
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'current_date'?: string;
    /**
     * Current time in HH:MM format
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'current_time'?: string;
    /**
     * Date to plan for in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'date'?: string;
    /**
     * Metric identifier for context loading
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'metric_id'?: string;
    /**
     * Preference identifier for user preferences
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'preference_id'?: string;
    /**
     * Routine identifier for meal context
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'routine_id'?: string;
    /**
     * List of routine activities to schedule
     * @type {Array<RoutineActivity>}
     * @memberof GenerateDailyPlanV2Request
     */
    'routines'?: Array<RoutineActivity>;
    /**
     * If true, returns an SSE stream. If false or omitted, returns JSON.
     * @type {boolean}
     * @memberof GenerateDailyPlanV2Request
     */
    'streaming'?: boolean;
    /**
     * List of tasks to schedule (from frontend selection)
     * @type {Array<TodoItem>}
     * @memberof GenerateDailyPlanV2Request
     */
    'tasks'?: Array<TodoItem>;
    /**
     * Unique user identifier (required)
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'user_id': string;
    /**
     * Optional user instructions for schedule generation
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'user_input'?: string;
    /**
     * User timezone
     * @type {string}
     * @memberof GenerateDailyPlanV2Request
     */
    'user_tz'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanV3200Response
 */
export interface GenerateDailyPlanV3200Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateDailyPlanV3200Response
     */
    'error'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof GenerateDailyPlanV3200Response
     */
    'existing_schedule'?: any | null;
    /**
     * Scheduled events for the day. Each event includes `end_day_offset` when the work window crosses midnight (overnight planning): 0 = ends on source date, 1 = ends on next calendar day. 
     * @type {Array<object>}
     * @memberof GenerateDailyPlanV3200Response
     */
    'schedules'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GenerateDailyPlanV3200Response
     */
    'summary'?: string | null;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanV3400Response
 */
export interface GenerateDailyPlanV3400Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateDailyPlanV3400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateDailyPlanV3MockRequest
 */
export interface GenerateDailyPlanV3MockRequest {
    /**
     * Current date in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'current_date'?: string;
    /**
     * Current time in HH:MM format
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'current_time'?: string;
    /**
     * Date to plan for in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'date'?: string;
    /**
     * Metric identifier for context loading
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'metric_id'?: string;
    /**
     * Optional planner type filter. Defaults to all types when omitted.
     * @type {Array<string>}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'plan_types'?: Array<GenerateDailyPlanV3MockRequestPlanTypesEnum>;
    /**
     * Preference identifier
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'preference_id'?: string;
    /**
     * Routine identifier
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'routine_id'?: string;
    /**
     * Must be true for this endpoint.
     * @type {boolean}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'streaming': boolean;
    /**
     * Unique user identifier (required)
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'user_id': string;
    /**
     * Optional onboarding prompt context
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'user_input'?: string;
    /**
     * User timezone (IANA format)
     * @type {string}
     * @memberof GenerateDailyPlanV3MockRequest
     */
    'user_tz'?: string;
}

export const GenerateDailyPlanV3MockRequestPlanTypesEnum = {
    Meal: 'meal',
    Sleep: 'sleep',
    Workout: 'workout',
    Todo: 'todo',
    Routine: 'routine'
} as const;

export type GenerateDailyPlanV3MockRequestPlanTypesEnum = typeof GenerateDailyPlanV3MockRequestPlanTypesEnum[keyof typeof GenerateDailyPlanV3MockRequestPlanTypesEnum];

/**
 * 
 * @export
 * @interface GenerateDailyPlanV3Request
 */
export interface GenerateDailyPlanV3Request {
    /**
     * Current date in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'current_date'?: string;
    /**
     * Current time in HH:MM format
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'current_time'?: string;
    /**
     * Date to plan for in YYYY-MM-DD format
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'date'?: string;
    /**
     * Metric identifier for context loading
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'metric_id'?: string;
    /**
     * Optional planner type filter. Defaults to all types when omitted.
     * @type {Array<string>}
     * @memberof GenerateDailyPlanV3Request
     */
    'plan_types'?: Array<GenerateDailyPlanV3RequestPlanTypesEnum>;
    /**
     * Preference identifier for user preferences
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'preference_id'?: string;
    /**
     * Routine identifier for meal/preference context
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'routine_id'?: string;
    /**
     * When true, returns an SSE stream (text/event-stream). When false or omitted, returns a normal JSON response. 
     * @type {boolean}
     * @memberof GenerateDailyPlanV3Request
     */
    'streaming'?: boolean;
    /**
     * Unique user identifier (required)
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'user_id': string;
    /**
     * Optional natural language instructions (informational only in v3)
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'user_input'?: string;
    /**
     * User timezone (IANA format)
     * @type {string}
     * @memberof GenerateDailyPlanV3Request
     */
    'user_tz'?: string;
}

export const GenerateDailyPlanV3RequestPlanTypesEnum = {
    Meal: 'meal',
    Sleep: 'sleep',
    Workout: 'workout',
    Todo: 'todo',
    Routine: 'routine'
} as const;

export type GenerateDailyPlanV3RequestPlanTypesEnum = typeof GenerateDailyPlanV3RequestPlanTypesEnum[keyof typeof GenerateDailyPlanV3RequestPlanTypesEnum];

/**
 * 
 * @export
 * @interface GenerateIdealMeals200Response
 */
export interface GenerateIdealMeals200Response {
    /**
     * Detailed explanation with emojis and formatting for comprehensive meal timing strategy
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'chat_detailed_explanation': string;
    /**
     * Brief user-facing explanation about meal timing decisions
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'chat_response': string;
    /**
     * Ideal meal content suggestion for breakfast (only returned when v3=true). Null if no meaningful suggestion is possible.
     * @type {MealSuggestionPayload}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_breakfast_content'?: MealSuggestionPayload | null;
    /**
     * Recommended breakfast end time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_breakfast_end_time': string;
    /**
     * Recommended breakfast start time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_breakfast_start_time': string;
    /**
     * Ideal meal content suggestion for dinner (only returned when v3=true). Null if no meaningful suggestion is possible.
     * @type {MealSuggestionPayload}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_dinner_content'?: MealSuggestionPayload | null;
    /**
     * Recommended dinner end time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_dinner_end_time': string;
    /**
     * Recommended dinner start time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_dinner_start_time': string;
    /**
     * Ideal meal content suggestion for lunch (only returned when v3=true). Null if no meaningful suggestion is possible.
     * @type {MealSuggestionPayload}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_lunch_content'?: MealSuggestionPayload | null;
    /**
     * Recommended lunch end time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_lunch_end_time': string;
    /**
     * Recommended lunch start time in HH:MM format (null if skipped)
     * @type {string}
     * @memberof GenerateIdealMeals200Response
     */
    'ideal_lunch_start_time': string;
    /**
     * List of warnings about potential issues or suboptimal timing
     * @type {Array<string>}
     * @memberof GenerateIdealMeals200Response
     */
    'warnings': Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateIdealMeals400Response
 */
export interface GenerateIdealMeals400Response {
    /**
     * Description of the validation error
     * @type {string}
     * @memberof GenerateIdealMeals400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateIdealMeals500Response
 */
export interface GenerateIdealMeals500Response {
    /**
     * Error message describing the server error
     * @type {string}
     * @memberof GenerateIdealMeals500Response
     */
    'error'?: string;
}
/**
 * Request for meal timing recommendations. Provide sleep_wake_times as a list where length determines behavior.
 * @export
 * @interface GenerateIdealMealsRequest
 */
export interface GenerateIdealMealsRequest {
    /**
     * List of calendar events for today that might conflict with meal times
     * @type {Array<GenerateIdealMealsRequestCalendarEventsInner>}
     * @memberof GenerateIdealMealsRequest
     */
    'calendar_events'?: Array<GenerateIdealMealsRequestCalendarEventsInner>;
    /**
     * 
     * @type {GenerateIdealMealsRequestContextInput}
     * @memberof GenerateIdealMealsRequest
     */
    'context_input'?: GenerateIdealMealsRequestContextInput | null;
    /**
     * Current time in HH:MM format (24-hour). Used for context in meal timing recommendations.
     * @type {string}
     * @memberof GenerateIdealMealsRequest
     */
    'current_time'?: string;
    /**
     * Desired eating window duration in hours. Optional - defaults to 12 hours if not specified.
     * @type {number}
     * @memberof GenerateIdealMealsRequest
     */
    'eating_window_hours'?: number;
    /**
     * Enable unified context input system. When true, allows using context_input for enhanced prompt generation with structured context sections.
     * @type {boolean}
     * @memberof GenerateIdealMealsRequest
     */
    'enable_unified_input'?: boolean;
    /**
     * Recommended sleep time for tonight in HH:MM format. Used to ensure dinner is 3 hours before bedtime.
     * @type {string}
     * @memberof GenerateIdealMealsRequest
     */
    'ideal_sleep_time_tonight'?: string;
    /**
     * 
     * @type {GenerateIdealMealsRequestMealPreferences}
     * @memberof GenerateIdealMealsRequest
     */
    'meal_preferences'?: GenerateIdealMealsRequestMealPreferences;
    /**
     * List of [sleep_time, wake_time] pairs in \"HH:MM\" format. Behavior based on length: - Empty list or not provided: Uses defaults (23:30, 07:30) - Single entry: That entry becomes the median sleep/wake times - Multiple entries: Calculates median from historical data  Examples: - [] → Uses defaults - [[\"23:30\", \"07:30\"]] → Single preference entry - [[\"23:30\", \"07:00\"], [\"23:45\", \"07:15\"], [\"00:00\", \"07:30\"]] → Historical data 
     * @type {Array<Array<string>>}
     * @memberof GenerateIdealMealsRequest
     */
    'sleep_wake_times'?: Array<Array<string>>;
    /**
     * Enable Redis-based chat history for conversation continuity and personalized recommendations (defaults to true)
     * @type {boolean}
     * @memberof GenerateIdealMealsRequest
     */
    'use_redis_history'?: boolean;
    /**
     * Optional user identifier for Redis-based chat history and cross-session memory. Enables conversation continuity and personalized meal recommendations by accessing stored user preferences, dietary patterns, and meal timing history.
     * @type {string}
     * @memberof GenerateIdealMealsRequest
     */
    'user_id'?: string;
    /**
     * When true, also returns per-meal content suggestions (ideal_*_content fields).
     * @type {boolean}
     * @memberof GenerateIdealMealsRequest
     */
    'v3'?: boolean;
}
/**
 * 
 * @export
 * @interface GenerateIdealMealsRequestCalendarEventsInner
 */
export interface GenerateIdealMealsRequestCalendarEventsInner {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'duration'?: number;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'end_date'?: string | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'end_time': string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'event_from'?: string;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {GenerateIdealMealsRequestCalendarEventsInnerEventMetrics}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'event_metrics'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'event_type'?: GenerateIdealMealsRequestCalendarEventsInnerEventTypeEnum | null;
    /**
     * A brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'name': string;
    /**
     * Original todo ID if event was created from a todo
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'origin_todo_id'?: string | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'start_date'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'start_time': string;
    /**
     * The status of the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInner
     */
    'status'?: GenerateIdealMealsRequestCalendarEventsInnerStatusEnum | null;
}

export const GenerateIdealMealsRequestCalendarEventsInnerEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type GenerateIdealMealsRequestCalendarEventsInnerEventTypeEnum = typeof GenerateIdealMealsRequestCalendarEventsInnerEventTypeEnum[keyof typeof GenerateIdealMealsRequestCalendarEventsInnerEventTypeEnum];
export const GenerateIdealMealsRequestCalendarEventsInnerStatusEnum = {
    Confirmed: 'confirmed',
    Tentative: 'tentative',
    Cancelled: 'cancelled'
} as const;

export type GenerateIdealMealsRequestCalendarEventsInnerStatusEnum = typeof GenerateIdealMealsRequestCalendarEventsInnerStatusEnum[keyof typeof GenerateIdealMealsRequestCalendarEventsInnerStatusEnum];

/**
 * Metrics for the event
 * @export
 * @interface GenerateIdealMealsRequestCalendarEventsInnerEventMetrics
 */
export interface GenerateIdealMealsRequestCalendarEventsInnerEventMetrics {
    /**
     * The energy feedback for the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestCalendarEventsInnerEventMetrics
     */
    'energy'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetricsEnergyEnum | null;
    /**
     * 
     * @type {GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate}
     * @memberof GenerateIdealMealsRequestCalendarEventsInnerEventMetrics
     */
    'heart_rate'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate | null;
    /**
     * The stress feedback for the event
     * @type {number}
     * @memberof GenerateIdealMealsRequestCalendarEventsInnerEventMetrics
     */
    'stress'?: number | null;
}

export const GenerateIdealMealsRequestCalendarEventsInnerEventMetricsEnergyEnum = {
    Low: 'low',
    Mild: 'mild',
    Medium: 'medium',
    Strong: 'strong',
    High: 'high'
} as const;

export type GenerateIdealMealsRequestCalendarEventsInnerEventMetricsEnergyEnum = typeof GenerateIdealMealsRequestCalendarEventsInnerEventMetricsEnergyEnum[keyof typeof GenerateIdealMealsRequestCalendarEventsInnerEventMetricsEnergyEnum];

/**
 * The heart rate feedback for the event
 * @export
 * @interface GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate
 */
export interface GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate {
    /**
     * The heart rate at the end of the event
     * @type {number}
     * @memberof GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate
     */
    'endHRbpm'?: number | null;
    /**
     * The heart rate at the start of the event
     * @type {number}
     * @memberof GenerateIdealMealsRequestCalendarEventsInnerEventMetricsHeartRate
     */
    'startHRbpm'?: number | null;
}
/**
 * Unified context input object containing all context data. Used when enable_unified_input=true for enhanced context generation with CalendarEventModel fields and structured prompt sections.
 * @export
 * @interface GenerateIdealMealsRequestContextInput
 */
export interface GenerateIdealMealsRequestContextInput {
    /**
     * Calendar events (maps to calendar_events parameter)
     * @type {Array<GenerateIdealMealsRequestContextInputCurrentScheduleInner>}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'current_schedule'?: Array<GenerateIdealMealsRequestContextInputCurrentScheduleInner>;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'current_time'?: string;
    /**
     * Desired eating window duration in hours
     * @type {number}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'eating_window_hours'?: number;
    /**
     * Tonight\'s recommended sleep time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'ideal_sleep_time_tonight'?: string;
    /**
     * 
     * @type {GenerateIdealMealsRequestContextInputMealPreferences}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'meal_preferences'?: GenerateIdealMealsRequestContextInputMealPreferences;
    /**
     * Array of sleep/wake time pairs
     * @type {Array<Array<string>>}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'sleep_wake_times'?: Array<Array<string>>;
    /**
     * Enable Redis-based chat history
     * @type {boolean}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based memory and chat history
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'user_id'?: string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\')
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInput
     */
    'user_tz'?: string;
}
/**
 * 
 * @export
 * @interface GenerateIdealMealsRequestContextInputCurrentScheduleInner
 */
export interface GenerateIdealMealsRequestContextInputCurrentScheduleInner {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'duration'?: number | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'end_time'?: string;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'event_id'?: string | null;
    /**
     * Event metrics data from lifestack-core
     * @type {object}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'event_metrics'?: object | null;
    /**
     * Type of event
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'event_type'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'name'?: string;
    /**
     * Event start date
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'start_date'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'start_time'?: string;
    /**
     * Event status (confirmed, tentative, etc.)
     * @type {string}
     * @memberof GenerateIdealMealsRequestContextInputCurrentScheduleInner
     */
    'status'?: string | null;
}
/**
 * User\'s meal preferences
 * @export
 * @interface GenerateIdealMealsRequestContextInputMealPreferences
 */
export interface GenerateIdealMealsRequestContextInputMealPreferences {
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesBreakfast}
     * @memberof GenerateIdealMealsRequestContextInputMealPreferences
     */
    'breakfast'?: StartChatSessionRequestContextInputMealPreferencesBreakfast;
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesDinner}
     * @memberof GenerateIdealMealsRequestContextInputMealPreferences
     */
    'dinner'?: StartChatSessionRequestContextInputMealPreferencesDinner;
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesLunch}
     * @memberof GenerateIdealMealsRequestContextInputMealPreferences
     */
    'lunch'?: StartChatSessionRequestContextInputMealPreferencesLunch;
}
/**
 * Granular preferences for each meal including skip flags, timing, and individual durations
 * @export
 * @interface GenerateIdealMealsRequestMealPreferences
 */
export interface GenerateIdealMealsRequestMealPreferences {
    /**
     * 
     * @type {GenerateIdealMealsRequestMealPreferencesBreakfast}
     * @memberof GenerateIdealMealsRequestMealPreferences
     */
    'breakfast'?: GenerateIdealMealsRequestMealPreferencesBreakfast;
    /**
     * 
     * @type {GenerateIdealMealsRequestMealPreferencesDinner}
     * @memberof GenerateIdealMealsRequestMealPreferences
     */
    'dinner'?: GenerateIdealMealsRequestMealPreferencesDinner;
    /**
     * 
     * @type {GenerateIdealMealsRequestMealPreferencesLunch}
     * @memberof GenerateIdealMealsRequestMealPreferences
     */
    'lunch'?: GenerateIdealMealsRequestMealPreferencesLunch;
}
/**
 * Breakfast preferences
 * @export
 * @interface GenerateIdealMealsRequestMealPreferencesBreakfast
 */
export interface GenerateIdealMealsRequestMealPreferencesBreakfast {
    /**
     * Duration for breakfast in minutes
     * @type {number}
     * @memberof GenerateIdealMealsRequestMealPreferencesBreakfast
     */
    'duration_min'?: number;
    /**
     * Preferred breakfast end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesBreakfast
     */
    'end_time'?: string;
    /**
     * Whether to skip breakfast recommendation
     * @type {boolean}
     * @memberof GenerateIdealMealsRequestMealPreferencesBreakfast
     */
    'skip'?: boolean;
    /**
     * Preferred breakfast start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesBreakfast
     */
    'start_time'?: string;
}
/**
 * Dinner preferences
 * @export
 * @interface GenerateIdealMealsRequestMealPreferencesDinner
 */
export interface GenerateIdealMealsRequestMealPreferencesDinner {
    /**
     * Duration for dinner in minutes
     * @type {number}
     * @memberof GenerateIdealMealsRequestMealPreferencesDinner
     */
    'duration_min'?: number;
    /**
     * Preferred dinner end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesDinner
     */
    'end_time'?: string;
    /**
     * Whether to skip dinner recommendation
     * @type {boolean}
     * @memberof GenerateIdealMealsRequestMealPreferencesDinner
     */
    'skip'?: boolean;
    /**
     * Preferred dinner start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesDinner
     */
    'start_time'?: string;
}
/**
 * Lunch preferences
 * @export
 * @interface GenerateIdealMealsRequestMealPreferencesLunch
 */
export interface GenerateIdealMealsRequestMealPreferencesLunch {
    /**
     * Duration for lunch in minutes
     * @type {number}
     * @memberof GenerateIdealMealsRequestMealPreferencesLunch
     */
    'duration_min'?: number;
    /**
     * Preferred lunch end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesLunch
     */
    'end_time'?: string;
    /**
     * Whether to skip lunch recommendation
     * @type {boolean}
     * @memberof GenerateIdealMealsRequestMealPreferencesLunch
     */
    'skip'?: boolean;
    /**
     * Preferred lunch start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealMealsRequestMealPreferencesLunch
     */
    'start_time'?: string;
}
/**
 * 
 * @export
 * @interface GenerateIdealSleep200Response
 */
export interface GenerateIdealSleep200Response {
    /**
     * Detailed explanation with Huberman principles, formatted for calendar event descriptions with emojis and clear sections
     * @type {string}
     * @memberof GenerateIdealSleep200Response
     */
    'chat_detailed_explanation': string;
    /**
     * Brief contextual statement that will be completed by the UI with \", let\'s aim to sleep from around XX:XXpm to XX:XXam.\" Should reference sleep data and calendar constraints but NOT include specific sleep times.
     * @type {string}
     * @memberof GenerateIdealSleep200Response
     */
    'chat_response': string;
    /**
     * Recommended sleep time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleep200Response
     */
    'ideal_sleep_time': string;
    /**
     * Recommended wake time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleep200Response
     */
    'ideal_wake_time': string;
    /**
     * List of warnings about sleep patterns, data quality, or recommendations
     * @type {Array<string>}
     * @memberof GenerateIdealSleep200Response
     */
    'warnings': Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateIdealSleep400Response
 */
export interface GenerateIdealSleep400Response {
    /**
     * Error message describing the validation failure
     * @type {string}
     * @memberof GenerateIdealSleep400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateIdealSleep500Response
 */
export interface GenerateIdealSleep500Response {
    /**
     * Error message. Note that the system has multiple fallback layers (Redis → Stateless → Rule-based) so 500 errors are rare.
     * @type {string}
     * @memberof GenerateIdealSleep500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateIdealSleepRequest
 */
export interface GenerateIdealSleepRequest {
    /**
     * 
     * @type {GenerateIdealSleepRequestContextInput}
     * @memberof GenerateIdealSleepRequest
     */
    'context_input'?: GenerateIdealSleepRequestContextInput | null;
    /**
     * Current time in HH:MM format (24-hour). Used for context in recommendations.
     * @type {string}
     * @memberof GenerateIdealSleepRequest
     */
    'current_time'?: string;
    /**
     * Enable unified context input system. When true, allows using context_input for enhanced prompt generation with structured context sections.
     * @type {boolean}
     * @memberof GenerateIdealSleepRequest
     */
    'enable_unified_input'?: boolean;
    /**
     * 
     * @type {GenerateIdealSleepRequestFirstCalendarEvent}
     * @memberof GenerateIdealSleepRequest
     */
    'first_calendar_event'?: GenerateIdealSleepRequestFirstCalendarEvent;
    /**
     * 
     * @type {GenerateIdealSleepRequestLastCalendarEvent}
     * @memberof GenerateIdealSleepRequest
     */
    'last_calendar_event'?: GenerateIdealSleepRequestLastCalendarEvent;
    /**
     * Array of sleep/wake time pairs from past 14 days. Each pair is [sleep_time, wake_time] in \"HH:MM\" format. Optional - uses defaults (23:30, 07:30) if empty or not provided.
     * @type {Array<Array<string>>}
     * @memberof GenerateIdealSleepRequest
     */
    'sleep_wake_times'?: Array<Array<string>>;
    /**
     * Whether to use Redis for persistent chat history. Only applies when user_id is provided. Defaults to true.
     * @type {boolean}
     * @memberof GenerateIdealSleepRequest
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based session management. When provided, enables persistent chat history across requests. Optional - omit for stateless mode.
     * @type {string}
     * @memberof GenerateIdealSleepRequest
     */
    'user_id'?: string;
}
/**
 * Unified context input object containing all context data. Used when enable_unified_input=true for enhanced context generation with CalendarEventModel fields and structured prompt sections.
 * @export
 * @interface GenerateIdealSleepRequestContextInput
 */
export interface GenerateIdealSleepRequestContextInput {
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'current_time'?: string;
    /**
     * 
     * @type {GenerateIdealSleepRequestContextInputFirstCalendarEvent}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'first_calendar_event'?: GenerateIdealSleepRequestContextInputFirstCalendarEvent;
    /**
     * 
     * @type {GenerateIdealSleepRequestContextInputLastCalendarEvent}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'last_calendar_event'?: GenerateIdealSleepRequestContextInputLastCalendarEvent;
    /**
     * Array of sleep/wake time pairs from past 14 days
     * @type {Array<Array<string>>}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'sleep_wake_times'?: Array<Array<string>>;
    /**
     * Enable Redis-based chat history
     * @type {boolean}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based memory and chat history
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'user_id'?: string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\')
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInput
     */
    'user_tz'?: string;
}
/**
 * First calendar event of tomorrow
 * @export
 * @interface GenerateIdealSleepRequestContextInputFirstCalendarEvent
 */
export interface GenerateIdealSleepRequestContextInputFirstCalendarEvent {
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'category'?: string;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'duration'?: number | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'end_time'?: string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'event_from'?: GenerateIdealSleepRequestContextInputFirstCalendarEventEventFromEnum;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'name': string;
    /**
     * ID of originating todo item if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'origin_todo_id'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputFirstCalendarEvent
     */
    'start_time': string;
}

export const GenerateIdealSleepRequestContextInputFirstCalendarEventEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Activity: 'activity',
    Todo: 'todo'
} as const;

export type GenerateIdealSleepRequestContextInputFirstCalendarEventEventFromEnum = typeof GenerateIdealSleepRequestContextInputFirstCalendarEventEventFromEnum[keyof typeof GenerateIdealSleepRequestContextInputFirstCalendarEventEventFromEnum];

/**
 * Last calendar event of the day
 * @export
 * @interface GenerateIdealSleepRequestContextInputLastCalendarEvent
 */
export interface GenerateIdealSleepRequestContextInputLastCalendarEvent {
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'category'?: string;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'duration'?: number | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'end_time': string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'event_from'?: GenerateIdealSleepRequestContextInputLastCalendarEventEventFromEnum;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'name': string;
    /**
     * ID of originating todo item if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'origin_todo_id'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestContextInputLastCalendarEvent
     */
    'start_time'?: string;
}

export const GenerateIdealSleepRequestContextInputLastCalendarEventEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Activity: 'activity',
    Todo: 'todo'
} as const;

export type GenerateIdealSleepRequestContextInputLastCalendarEventEventFromEnum = typeof GenerateIdealSleepRequestContextInputLastCalendarEventEventFromEnum[keyof typeof GenerateIdealSleepRequestContextInputLastCalendarEventEventFromEnum];

/**
 * First calendar event of tomorrow (optional)
 * @export
 * @interface GenerateIdealSleepRequestFirstCalendarEvent
 */
export interface GenerateIdealSleepRequestFirstCalendarEvent {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'duration'?: number | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'end_date'?: string | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'end_time'?: string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'event_from'?: GenerateIdealSleepRequestFirstCalendarEventEventFromEnum;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {GenerateIdealMealsRequestCalendarEventsInnerEventMetrics}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'event_metrics'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'event_type'?: GenerateIdealSleepRequestFirstCalendarEventEventTypeEnum | null;
    /**
     * A brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'name': string;
    /**
     * ID of originating todo item if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'origin_todo_id'?: string | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'start_date'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'start_time': string;
    /**
     * The status of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestFirstCalendarEvent
     */
    'status'?: string | null;
}

export const GenerateIdealSleepRequestFirstCalendarEventEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Activity: 'activity',
    Todo: 'todo'
} as const;

export type GenerateIdealSleepRequestFirstCalendarEventEventFromEnum = typeof GenerateIdealSleepRequestFirstCalendarEventEventFromEnum[keyof typeof GenerateIdealSleepRequestFirstCalendarEventEventFromEnum];
export const GenerateIdealSleepRequestFirstCalendarEventEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type GenerateIdealSleepRequestFirstCalendarEventEventTypeEnum = typeof GenerateIdealSleepRequestFirstCalendarEventEventTypeEnum[keyof typeof GenerateIdealSleepRequestFirstCalendarEventEventTypeEnum];

/**
 * Last calendar event of the day (optional)
 * @export
 * @interface GenerateIdealSleepRequestLastCalendarEvent
 */
export interface GenerateIdealSleepRequestLastCalendarEvent {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'duration'?: number | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'end_date'?: string | null;
    /**
     * Event end time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'end_time': string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'event_from'?: GenerateIdealSleepRequestLastCalendarEventEventFromEnum;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {GenerateIdealMealsRequestCalendarEventsInnerEventMetrics}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'event_metrics'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'event_type'?: GenerateIdealSleepRequestLastCalendarEventEventTypeEnum | null;
    /**
     * A brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'name': string;
    /**
     * ID of originating todo item if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'origin_todo_id'?: string | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'start_date'?: string | null;
    /**
     * Event start time in HH:MM format
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'start_time'?: string;
    /**
     * The status of the event
     * @type {string}
     * @memberof GenerateIdealSleepRequestLastCalendarEvent
     */
    'status'?: string | null;
}

export const GenerateIdealSleepRequestLastCalendarEventEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Activity: 'activity',
    Todo: 'todo'
} as const;

export type GenerateIdealSleepRequestLastCalendarEventEventFromEnum = typeof GenerateIdealSleepRequestLastCalendarEventEventFromEnum[keyof typeof GenerateIdealSleepRequestLastCalendarEventEventFromEnum];
export const GenerateIdealSleepRequestLastCalendarEventEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type GenerateIdealSleepRequestLastCalendarEventEventTypeEnum = typeof GenerateIdealSleepRequestLastCalendarEventEventTypeEnum[keyof typeof GenerateIdealSleepRequestLastCalendarEventEventTypeEnum];

/**
 * 
 * @export
 * @interface GenerateRoutineTiming200Response
 */
export interface GenerateRoutineTiming200Response {
    /**
     * Successfully scheduled routine instances (max 1)
     * @type {Array<GenerateRoutineTiming200ResponseScheduledRoutinesInner>}
     * @memberof GenerateRoutineTiming200Response
     */
    'scheduled_routines'?: Array<GenerateRoutineTiming200ResponseScheduledRoutinesInner>;
    /**
     * Routines that could not be scheduled
     * @type {Array<GenerateRoutineTiming200ResponseUnscheduledRoutinesInner>}
     * @memberof GenerateRoutineTiming200Response
     */
    'unscheduled_routines'?: Array<GenerateRoutineTiming200ResponseUnscheduledRoutinesInner>;
}
/**
 * 
 * @export
 * @interface GenerateRoutineTiming200ResponseScheduledRoutinesInner
 */
export interface GenerateRoutineTiming200ResponseScheduledRoutinesInner {
    /**
     * 
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'activity_effect'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'category'?: string | null;
    /**
     * Final scheduled duration in minutes (may be shortened to fit window)
     * @type {number}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'duration'?: number;
    /**
     * Whether the duration was shortened to fit the available gap
     * @type {boolean}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'duration_adjusted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'name'?: string;
    /**
     * Explanation of placement
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'reasoning'?: string;
    /**
     * ID of the routine activity, if provided
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'routine_activity_id'?: string | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'suggested_end_time'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseScheduledRoutinesInner
     */
    'suggested_start_time'?: string;
}
/**
 * 
 * @export
 * @interface GenerateRoutineTiming200ResponseUnscheduledRoutinesInner
 */
export interface GenerateRoutineTiming200ResponseUnscheduledRoutinesInner {
    /**
     * 
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseUnscheduledRoutinesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateRoutineTiming200ResponseUnscheduledRoutinesInner
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface GenerateRoutineTimingRequest
 */
export interface GenerateRoutineTimingRequest {
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTimingRequest
     */
    'current_time'?: string;
    /**
     * Energy patterns to align with the routine
     * @type {Array<EnergyZone>}
     * @memberof GenerateRoutineTimingRequest
     */
    'energy_zones'?: Array<EnergyZone>;
    /**
     * Calendar events to avoid
     * @type {Array<GenerateRoutineTimingRequestPrescheduledEventsInner>}
     * @memberof GenerateRoutineTimingRequest
     */
    'prescheduled_events'?: Array<GenerateRoutineTimingRequestPrescheduledEventsInner>;
    /**
     * Routine activities to schedule
     * @type {Array<RoutineActivity>}
     * @memberof GenerateRoutineTimingRequest
     */
    'routine_activities'?: Array<RoutineActivity>;
    /**
     * Output time format for responses
     * @type {string}
     * @memberof GenerateRoutineTimingRequest
     */
    'user_time_format'?: GenerateRoutineTimingRequestUserTimeFormatEnum;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTimingRequest
     */
    'work_end'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTimingRequest
     */
    'work_start'?: string;
}

export const GenerateRoutineTimingRequestUserTimeFormatEnum = {
    Ampm: 'ampm',
    _24h: '24h'
} as const;

export type GenerateRoutineTimingRequestUserTimeFormatEnum = typeof GenerateRoutineTimingRequestUserTimeFormatEnum[keyof typeof GenerateRoutineTimingRequestUserTimeFormatEnum];

/**
 * 
 * @export
 * @interface GenerateRoutineTimingRequestPrescheduledEventsInner
 */
export interface GenerateRoutineTimingRequestPrescheduledEventsInner {
    /**
     * Category for the event
     * @type {string}
     * @memberof GenerateRoutineTimingRequestPrescheduledEventsInner
     */
    'category'?: string | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTimingRequestPrescheduledEventsInner
     */
    'end_time': string;
    /**
     * Event title
     * @type {string}
     * @memberof GenerateRoutineTimingRequestPrescheduledEventsInner
     */
    'name': string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateRoutineTimingRequestPrescheduledEventsInner
     */
    'start_time': string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTiming200Response
 */
export interface GenerateTaskTiming200Response {
    /**
     * Detailed explanation of the scheduling decisions and recommendations
     * @type {string}
     * @memberof GenerateTaskTiming200Response
     */
    'chat_detailed_explanation': string;
    /**
     * Brief, friendly summary of the scheduling results
     * @type {string}
     * @memberof GenerateTaskTiming200Response
     */
    'chat_response': string;
    /**
     * Short descriptive title summarizing the scheduling result
     * @type {string}
     * @memberof GenerateTaskTiming200Response
     */
    'chat_title': string;
    /**
     * Successfully scheduled todos with timing recommendations
     * @type {Array<GenerateTaskTiming200ResponseScheduledTodosInner>}
     * @memberof GenerateTaskTiming200Response
     */
    'scheduled_todos': Array<GenerateTaskTiming200ResponseScheduledTodosInner>;
    /**
     * Todos that couldn\'t be scheduled
     * @type {Array<GenerateTaskTiming200ResponseUnscheduledTodosInner>}
     * @memberof GenerateTaskTiming200Response
     */
    'unscheduled_todos': Array<GenerateTaskTiming200ResponseUnscheduledTodosInner>;
}
/**
 * 
 * @export
 * @interface GenerateTaskTiming200ResponseScheduledTodosInner
 */
export interface GenerateTaskTiming200ResponseScheduledTodosInner {
    /**
     * Task category
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'category'?: string;
    /**
     * Task duration in minutes
     * @type {number}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'duration'?: number;
    /**
     * Task name
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'name'?: string;
    /**
     * Priority level
     * @type {number}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'priority'?: number;
    /**
     * Natural language explanation for why this timing was chosen
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'reasoning'?: string;
    /**
     * Day offset of the suggested end time
     * @type {number}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'suggested_end_day_offset'?: number;
    /**
     * Recommended end time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'suggested_end_time'?: string;
    /**
     * Day offset of the suggested start time
     * @type {number}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'suggested_start_day_offset'?: number;
    /**
     * Recommended start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'suggested_start_time'?: string;
    /**
     * Original todo ID
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseScheduledTodosInner
     */
    'todo_id'?: string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTiming200ResponseUnscheduledTodosInner
 */
export interface GenerateTaskTiming200ResponseUnscheduledTodosInner {
    /**
     * Task name
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseUnscheduledTodosInner
     */
    'name'?: string;
    /**
     * Reason why it couldn\'t be scheduled
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseUnscheduledTodosInner
     */
    'reason'?: string;
    /**
     * Todo ID
     * @type {string}
     * @memberof GenerateTaskTiming200ResponseUnscheduledTodosInner
     */
    'todo_id'?: string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTiming400Response
 */
export interface GenerateTaskTiming400Response {
    /**
     * Error message describing the validation failure
     * @type {string}
     * @memberof GenerateTaskTiming400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTiming500Response
 */
export interface GenerateTaskTiming500Response {
    /**
     * Error message
     * @type {string}
     * @memberof GenerateTaskTiming500Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTimingRequest
 */
export interface GenerateTaskTimingRequest {
    /**
     * 
     * @type {GenerateTaskTimingRequestContextInput}
     * @memberof GenerateTaskTimingRequest
     */
    'context_input'?: GenerateTaskTimingRequestContextInput | null;
    /**
     * Current time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'current_time'?: string;
    /**
     * Enable unified context input system. When true, allows using context_input for enhanced prompt generation with structured context sections.
     * @type {boolean}
     * @memberof GenerateTaskTimingRequest
     */
    'enable_unified_input'?: boolean;
    /**
     * Set to 1 when work_end is on the next calendar day (overnight work window).
     * @type {number}
     * @memberof GenerateTaskTimingRequest
     */
    'end_day_offset'?: GenerateTaskTimingRequestEndDayOffsetEnum;
    /**
     * User\'s energy zones throughout the day
     * @type {Array<GenerateTaskTimingRequestEnergyZonesInner>}
     * @memberof GenerateTaskTimingRequest
     */
    'energy_zones': Array<GenerateTaskTimingRequestEnergyZonesInner>;
    /**
     * Existing calendar events to work around
     * @type {Array<GenerateTaskTimingRequestPrescheduledEventsInner>}
     * @memberof GenerateTaskTimingRequest
     */
    'prescheduled_events'?: Array<GenerateTaskTimingRequestPrescheduledEventsInner>;
    /**
     * List of todo items to schedule
     * @type {Array<GenerateTaskTimingRequestTodosInner>}
     * @memberof GenerateTaskTimingRequest
     */
    'todos': Array<GenerateTaskTimingRequestTodosInner>;
    /**
     * Enable Redis-based chat history for conversation continuity (defaults to true)
     * @type {boolean}
     * @memberof GenerateTaskTimingRequest
     */
    'use_redis_history'?: boolean;
    /**
     * Optional user identifier for Redis-based chat history and cross-session memory. Enables conversation continuity and personalized task timing advice by accessing stored user preferences, scheduling patterns, and productivity insights.
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'user_id'?: string;
    /**
     * Time format preference for explanation text. \'ampm\' displays times as \"9:45 AM\", \'24h\' displays as \"09:45\"
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'user_time_format'?: GenerateTaskTimingRequestUserTimeFormatEnum;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\')
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'user_tz'?: string;
    /**
     * Work day end time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'work_end'?: string;
    /**
     * Work day start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequest
     */
    'work_start'?: string;
}

export const GenerateTaskTimingRequestEndDayOffsetEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type GenerateTaskTimingRequestEndDayOffsetEnum = typeof GenerateTaskTimingRequestEndDayOffsetEnum[keyof typeof GenerateTaskTimingRequestEndDayOffsetEnum];
export const GenerateTaskTimingRequestUserTimeFormatEnum = {
    Ampm: 'ampm',
    _24h: '24h'
} as const;

export type GenerateTaskTimingRequestUserTimeFormatEnum = typeof GenerateTaskTimingRequestUserTimeFormatEnum[keyof typeof GenerateTaskTimingRequestUserTimeFormatEnum];

/**
 * Unified context input object containing all context data. Used when enable_unified_input=true for enhanced context generation with CalendarEventModel fields and structured prompt sections.
 * @export
 * @interface GenerateTaskTimingRequestContextInput
 */
export interface GenerateTaskTimingRequestContextInput {
    /**
     * Existing calendar events to work around
     * @type {Array<GenerateTaskTimingRequestContextInputCurrentScheduleInner>}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'current_schedule'?: Array<GenerateTaskTimingRequestContextInputCurrentScheduleInner>;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'current_time'?: string;
    /**
     * User\'s energy patterns (peak/dip zones)
     * @type {Array<GenerateTaskTimingRequestContextInputEnergyZonesInner>}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'energy_zones'?: Array<GenerateTaskTimingRequestContextInputEnergyZonesInner>;
    /**
     * Todo items (maps to todos parameter)
     * @type {Array<GenerateTaskTimingRequestContextInputTodoListInner>}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'todo_list'?: Array<GenerateTaskTimingRequestContextInputTodoListInner>;
    /**
     * Enable Redis-based chat history
     * @type {boolean}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based memory and chat history
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'user_id'?: string;
    /**
     * Time format preference for explanation text. \'ampm\' displays times as \"9:45 AM\", \'24h\' displays as \"09:45\"
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'user_time_format'?: GenerateTaskTimingRequestContextInputUserTimeFormatEnum;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\')
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInput
     */
    'user_tz'?: string;
}

export const GenerateTaskTimingRequestContextInputUserTimeFormatEnum = {
    Ampm: 'ampm',
    _24h: '24h'
} as const;

export type GenerateTaskTimingRequestContextInputUserTimeFormatEnum = typeof GenerateTaskTimingRequestContextInputUserTimeFormatEnum[keyof typeof GenerateTaskTimingRequestContextInputUserTimeFormatEnum];

/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestContextInputCurrentScheduleInner
 */
export interface GenerateTaskTimingRequestContextInputCurrentScheduleInner {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'duration'?: number | null;
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'end_time': string;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'event_id'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'name': string;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputCurrentScheduleInner
     */
    'start_time': string;
}
/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestContextInputEnergyZonesInner
 */
export interface GenerateTaskTimingRequestContextInputEnergyZonesInner {
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputEnergyZonesInner
     */
    'end_time': string;
    /**
     * Type of energy zone
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputEnergyZonesInner
     */
    'phase_category': GenerateTaskTimingRequestContextInputEnergyZonesInnerPhaseCategoryEnum;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputEnergyZonesInner
     */
    'start_time': string;
}

export const GenerateTaskTimingRequestContextInputEnergyZonesInnerPhaseCategoryEnum = {
    Peak: 'peak',
    Dip: 'dip'
} as const;

export type GenerateTaskTimingRequestContextInputEnergyZonesInnerPhaseCategoryEnum = typeof GenerateTaskTimingRequestContextInputEnergyZonesInnerPhaseCategoryEnum[keyof typeof GenerateTaskTimingRequestContextInputEnergyZonesInnerPhaseCategoryEnum];

/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestContextInputTodoListInner
 */
export interface GenerateTaskTimingRequestContextInputTodoListInner {
    /**
     * Task category for energy alignment
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'category'?: GenerateTaskTimingRequestContextInputTodoListInnerCategoryEnum;
    /**
     * Whether the todo item is completed
     * @type {boolean}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'completed'?: boolean;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'duration': number;
    /**
     * Earliest start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'earliest_start'?: string;
    /**
     * Latest finish time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'latest_finish'?: string;
    /**
     * Whether the task can be moved/rescheduled
     * @type {boolean}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'movable'?: boolean;
    /**
     * Name of the task
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'name': string;
    /**
     * Priority of the task (lower = higher priority)
     * @type {number}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'priority'?: number;
    /**
     * Unique identifier for the todo
     * @type {string}
     * @memberof GenerateTaskTimingRequestContextInputTodoListInner
     */
    'todo_id'?: string;
}

export const GenerateTaskTimingRequestContextInputTodoListInnerCategoryEnum = {
    DeepWork: 'deep_work',
    LightTask: 'light_task',
    Meal: 'meal',
    Exercise: 'exercise',
    Social: 'social',
    Personal: 'personal',
    Break: 'break',
    Other: 'other',
    Meeting: 'meeting'
} as const;

export type GenerateTaskTimingRequestContextInputTodoListInnerCategoryEnum = typeof GenerateTaskTimingRequestContextInputTodoListInnerCategoryEnum[keyof typeof GenerateTaskTimingRequestContextInputTodoListInnerCategoryEnum];

/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestEnergyZonesInner
 */
export interface GenerateTaskTimingRequestEnergyZonesInner {
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestEnergyZonesInner
     */
    'end_time': string;
    /**
     * Type of energy zone
     * @type {string}
     * @memberof GenerateTaskTimingRequestEnergyZonesInner
     */
    'phase_category': GenerateTaskTimingRequestEnergyZonesInnerPhaseCategoryEnum;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestEnergyZonesInner
     */
    'start_time': string;
}

export const GenerateTaskTimingRequestEnergyZonesInnerPhaseCategoryEnum = {
    Peak: 'peak',
    Dip: 'dip'
} as const;

export type GenerateTaskTimingRequestEnergyZonesInnerPhaseCategoryEnum = typeof GenerateTaskTimingRequestEnergyZonesInnerPhaseCategoryEnum[keyof typeof GenerateTaskTimingRequestEnergyZonesInnerPhaseCategoryEnum];

/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestPrescheduledEventsInner
 */
export interface GenerateTaskTimingRequestPrescheduledEventsInner {
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'category'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'description'?: string | null;
    /**
     * Duration of the event in minutes
     * @type {number}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'duration'?: number | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'end_date'?: string | null;
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'end_time': string;
    /**
     * Source of the event
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'event_from'?: string;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {GenerateIdealMealsRequestCalendarEventsInnerEventMetrics}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'event_metrics'?: GenerateIdealMealsRequestCalendarEventsInnerEventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'event_type'?: GenerateTaskTimingRequestPrescheduledEventsInnerEventTypeEnum | null;
    /**
     * A brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'name': string;
    /**
     * Original todo ID if event was created from a todo
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'origin_todo_id'?: string | null;
    /**
     * The date of the event, if applicable
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'start_date'?: string | null;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'start_time': string;
    /**
     * The status of the event
     * @type {string}
     * @memberof GenerateTaskTimingRequestPrescheduledEventsInner
     */
    'status'?: GenerateTaskTimingRequestPrescheduledEventsInnerStatusEnum | null;
}

export const GenerateTaskTimingRequestPrescheduledEventsInnerEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type GenerateTaskTimingRequestPrescheduledEventsInnerEventTypeEnum = typeof GenerateTaskTimingRequestPrescheduledEventsInnerEventTypeEnum[keyof typeof GenerateTaskTimingRequestPrescheduledEventsInnerEventTypeEnum];
export const GenerateTaskTimingRequestPrescheduledEventsInnerStatusEnum = {
    Confirmed: 'confirmed',
    Tentative: 'tentative',
    Cancelled: 'cancelled'
} as const;

export type GenerateTaskTimingRequestPrescheduledEventsInnerStatusEnum = typeof GenerateTaskTimingRequestPrescheduledEventsInnerStatusEnum[keyof typeof GenerateTaskTimingRequestPrescheduledEventsInnerStatusEnum];

/**
 * 
 * @export
 * @interface GenerateTaskTimingRequestTodosInner
 */
export interface GenerateTaskTimingRequestTodosInner {
    /**
     * Task category for energy alignment. If not provided, will be automatically categorized using AI based on task name
     * @type {string}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'category'?: GenerateTaskTimingRequestTodosInnerCategoryEnum;
    /**
     * Whether the todo item is completed
     * @type {boolean}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'completed'?: boolean;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'duration': number;
    /**
     * Earliest start time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'earliest_start'?: string;
    /**
     * Latest finish time in HH:MM format
     * @type {string}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'latest_finish'?: string;
    /**
     * Whether the task can be moved/rescheduled
     * @type {boolean}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'movable'?: boolean;
    /**
     * Name of the task (used for AI categorization if category not provided)
     * @type {string}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'name': string;
    /**
     * Priority of the task (lower = higher priority, e.g. 1 is highest)
     * @type {number}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'priority'?: number;
    /**
     * Unique identifier for the todo
     * @type {string}
     * @memberof GenerateTaskTimingRequestTodosInner
     */
    'todo_id'?: string;
}

export const GenerateTaskTimingRequestTodosInnerCategoryEnum = {
    DeepWork: 'deep_work',
    LightTask: 'light_task',
    Meal: 'meal',
    Exercise: 'exercise',
    Social: 'social',
    Personal: 'personal',
    Break: 'break',
    Other: 'other',
    Meeting: 'meeting'
} as const;

export type GenerateTaskTimingRequestTodosInnerCategoryEnum = typeof GenerateTaskTimingRequestTodosInnerCategoryEnum[keyof typeof GenerateTaskTimingRequestTodosInnerCategoryEnum];

/**
 * 
 * @export
 * @interface GenerateWeeklyPlanRequest
 */
export interface GenerateWeeklyPlanRequest {
    /**
     * Today\'s actual date in YYYY-MM-DD format (used to determine overdue tasks and current_time defaulting)
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'current_date'?: string;
    /**
     * Current time in HH:MM format. For future days, defaults to the user\'s work_start time.
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'current_time'?: string;
    /**
     * Metric identifier for context loading
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'metric_id'?: string;
    /**
     * Number of consecutive days to plan starting from week_start
     * @type {number}
     * @memberof GenerateWeeklyPlanRequest
     */
    'num_days'?: number;
    /**
     * Preference document identifier for scheduler preferences
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'preference_id'?: string;
    /**
     * Routine document identifier for meal/preference context
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'routine_id'?: string;
    /**
     * List of routine activities. Routines recur daily and are passed to every day\'s planning call — they are not affected by task allocation. 
     * @type {Array<RoutineActivity>}
     * @memberof GenerateWeeklyPlanRequest
     */
    'routines'?: Array<RoutineActivity>;
    /**
     * Optional initial status_text message to emit at stream start
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'status_text'?: string;
    /**
     * Full list of tasks to distribute across the week. Tasks are allocated to specific days based on due_date, overdue flag, and priority — each task appears on exactly one day. 
     * @type {Array<TodoItem>}
     * @memberof GenerateWeeklyPlanRequest
     */
    'tasks'?: Array<TodoItem>;
    /**
     * Unique user identifier
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'user_id': string;
    /**
     * Optional user instructions applied to each day\'s schedule generation
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'user_input'?: string;
    /**
     * User\'s IANA timezone string
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'user_tz'?: string;
    /**
     * First day of the week to plan in YYYY-MM-DD format (typically a Monday)
     * @type {string}
     * @memberof GenerateWeeklyPlanRequest
     */
    'week_start': string;
}
/**
 * 
 * @export
 * @interface GetCircadianSineWaveV212Request
 */
export interface GetCircadianSineWaveV212Request {
    /**
     * Chronotype
     * @type {string}
     * @memberof GetCircadianSineWaveV212Request
     */
    'chronotype': GetCircadianSineWaveV212RequestChronotypeEnum;
    /**
     * Sleep score
     * @type {number}
     * @memberof GetCircadianSineWaveV212Request
     */
    'sleep_score': number;
    /**
     * Total minutes for the circadian cycle
     * @type {number}
     * @memberof GetCircadianSineWaveV212Request
     */
    'total_minutes': number;
}

export const GetCircadianSineWaveV212RequestChronotypeEnum = {
    Morning: 'morning',
    Night: 'night',
    Hybrid: 'hybrid'
} as const;

export type GetCircadianSineWaveV212RequestChronotypeEnum = typeof GetCircadianSineWaveV212RequestChronotypeEnum[keyof typeof GetCircadianSineWaveV212RequestChronotypeEnum];

/**
 * 
 * @export
 * @interface GymExercise
 */
export interface GymExercise {
    /**
     * 
     * @type {number}
     * @memberof GymExercise
     */
    'duration_sec'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GymExercise
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GymExercise
     */
    'reps'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GymExercise
     */
    'rest_sec'?: number;
    /**
     * 
     * @type {number}
     * @memberof GymExercise
     */
    'sets'?: number;
}
/**
 * 
 * @export
 * @interface HRSummaryPayload
 */
export interface HRSummaryPayload {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof HRSummaryPayload
     */
    'avg_hr_bpm'?: number;
    /**
     * 
     * @type {string}
     * @memberof HRSummaryPayload
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof HRSummaryPayload
     */
    'max_hr_bpm'?: number;
    /**
     * 
     * @type {number}
     * @memberof HRSummaryPayload
     */
    'min_hr_bpm'?: number;
    /**
     * 
     * @type {Array<HeartRatePoint>}
     * @memberof HRSummaryPayload
     */
    'timeline'?: Array<HeartRatePoint>;
}
/**
 * Heart rate data for an event
 * @export
 * @interface HeartRate
 */
export interface HeartRate {
    /**
     * Heart rate at the end of the event in BPM
     * @type {number}
     * @memberof HeartRate
     */
    'endHRbpm'?: number | null;
    /**
     * Heart rate at the start of the event in BPM
     * @type {number}
     * @memberof HeartRate
     */
    'startHRbpm'?: number | null;
}
/**
 * 
 * @export
 * @interface HeartRatePoint
 */
export interface HeartRatePoint {
    /**
     * 
     * @type {string}
     * @memberof HeartRatePoint
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof HeartRatePoint
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface HeartRateSummary
 */
export interface HeartRateSummary {
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'avg_hr_bpm'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'avg_hrv_rmssd'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'avg_hrv_sdnn'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'max_hr_bpm'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'min_hr_bpm'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeartRateSummary
     */
    'resting_hr_bpm'?: number;
}
/**
 * 
 * @export
 * @interface JournalPromptsPayload
 */
export interface JournalPromptsPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof JournalPromptsPayload
     */
    'label'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalPromptsPayload
     */
    'prompts'?: Array<string>;
}
/**
 * User\'s current or home location used for map/place enrichment
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * Human-readable location label
     * @type {string}
     * @memberof Location
     */
    'label'?: string | null;
    /**
     * Latitude
     * @type {number}
     * @memberof Location
     */
    'lat': number;
    /**
     * Longitude
     * @type {number}
     * @memberof Location
     */
    'lng': number;
}
/**
 * A meal timing entry
 * @export
 * @interface Meal
 */
export interface Meal {
    /**
     * 
     * @type {MealContentPayload}
     * @memberof Meal
     */
    'content'?: MealContentPayload;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof Meal
     */
    'end_time': string;
    /**
     * Brief explanation of why this meal timing was chosen
     * @type {string}
     * @memberof Meal
     */
    'explanation'?: string | null;
    /**
     * Meal name (e.g., \"Breakfast\", \"Lunch\", \"Dinner\")
     * @type {string}
     * @memberof Meal
     */
    'name': string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof Meal
     */
    'start_time': string;
}
/**
 * Meal timing adjustment (add, update, or remove). In v3, each entry may include a server-injected `rich_context` block (meal_suggestion content card, nearby-restaurant action, signals). 
 * @export
 * @interface MealAdjustment
 */
export interface MealAdjustment {
    /**
     * 
     * @type {MealContentPayload}
     * @memberof MealAdjustment
     */
    'content'?: MealContentPayload;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof MealAdjustment
     */
    'end_time': string;
    /**
     * Brief explanation of why this meal timing was chosen
     * @type {string}
     * @memberof MealAdjustment
     */
    'explanation'?: string | null;
    /**
     * Meal name (e.g., \"Breakfast\", \"Lunch\", \"Dinner\")
     * @type {string}
     * @memberof MealAdjustment
     */
    'name': string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof MealAdjustment
     */
    'start_time': string;
    /**
     * Action to perform on the meal: - \"add\": Schedule a new meal time - \"update\": Modify an existing meal time - \"remove\": Remove a meal from the schedule 
     * @type {string}
     * @memberof MealAdjustment
     */
    'action': MealAdjustmentActionEnum;
    /**
     * 
     * @type {RichContext}
     * @memberof MealAdjustment
     */
    'rich_context'?: RichContext | null;
}

export const MealAdjustmentActionEnum = {
    Add: 'add',
    Update: 'update',
    Remove: 'remove'
} as const;

export type MealAdjustmentActionEnum = typeof MealAdjustmentActionEnum[keyof typeof MealAdjustmentActionEnum];

/**
 * 
 * @export
 * @interface MealContentItem
 */
export interface MealContentItem {
    /**
     * Food item name
     * @type {string}
     * @memberof MealContentItem
     */
    'name': string;
    /**
     * Suggested serving size
     * @type {string}
     * @memberof MealContentItem
     */
    'portion'?: string | null;
    /**
     * Why this item is suggested
     * @type {string}
     * @memberof MealContentItem
     */
    'reason'?: string | null;
}
/**
 * Alias of MealSuggestionPayload for adjustment-path meal content (`adjustments.meals[].content`). 
 * @export
 * @interface MealContentPayload
 */
export interface MealContentPayload {
    /**
     * 
     * @type {string}
     * @memberof MealContentPayload
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealContentPayload
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {Array<MealFoodAmount>}
     * @memberof MealContentPayload
     */
    'food_items'?: Array<MealFoodAmount> | null;
    /**
     * 
     * @type {MetricMealDetailMacros}
     * @memberof MealContentPayload
     */
    'macros'?: MetricMealDetailMacros | null;
    /**
     * 
     * @type {MetricMealDetailMicros}
     * @memberof MealContentPayload
     */
    'micros'?: MetricMealDetailMicros | null;
    /**
     * 
     * @type {string}
     * @memberof MealContentPayload
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealContentPayload
     */
    'title'?: string | null;
    /**
     * 
     * @type {MealType}
     * @memberof MealContentPayload
     */
    'type'?: MealType;
}


/**
 * Structured food item amount.
 * @export
 * @interface MealFoodAmount
 */
export interface MealFoodAmount {
    /**
     * Numeric amount for this food item
     * @type {number}
     * @memberof MealFoodAmount
     */
    'amount': number;
    /**
     * Food item name
     * @type {string}
     * @memberof MealFoodAmount
     */
    'name': string;
    /**
     * Unit of measurement
     * @type {string}
     * @memberof MealFoodAmount
     */
    'unit'?: string;
}
/**
 * Existing meal data returned on the query path (e.g. \"what are my meals today\"). Populated synchronously from the meal signal — no enrichment_pending is set. 
 * @export
 * @interface MealQueryContent
 */
export interface MealQueryContent {
    /**
     * Logged meal detail entries (food/foodItem/foodItems, macros, micros) from meal signal
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MealQueryContent
     */
    'meal_details'?: Array<{ [key: string]: any; }>;
    /**
     * Scheduled meals from suggested_meals signal
     * @type {Array<MealQueryContentMealsInner>}
     * @memberof MealQueryContent
     */
    'meals'?: Array<MealQueryContentMealsInner>;
}
/**
 * 
 * @export
 * @interface MealQueryContentMealsInner
 */
export interface MealQueryContentMealsInner {
    /**
     * 
     * @type {string}
     * @memberof MealQueryContentMealsInner
     */
    'end_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof MealQueryContentMealsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MealQueryContentMealsInner
     */
    'start_time'?: string;
}
/**
 * Same interface as `MealSuggestionPayload`. 
 * @export
 * @interface MealSignalData
 */
export interface MealSignalData {
    /**
     * 
     * @type {string}
     * @memberof MealSignalData
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealSignalData
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {Array<MealFoodAmount>}
     * @memberof MealSignalData
     */
    'food_items'?: Array<MealFoodAmount> | null;
    /**
     * 
     * @type {MetricMealDetailMacros}
     * @memberof MealSignalData
     */
    'macros'?: MetricMealDetailMacros | null;
    /**
     * 
     * @type {MetricMealDetailMicros}
     * @memberof MealSignalData
     */
    'micros'?: MetricMealDetailMicros | null;
    /**
     * 
     * @type {string}
     * @memberof MealSignalData
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealSignalData
     */
    'title'?: string | null;
    /**
     * 
     * @type {MealType}
     * @memberof MealSignalData
     */
    'type'?: MealType;
}


/**
 * 
 * @export
 * @interface MealSuggestionPayload
 */
export interface MealSuggestionPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof MealSuggestionPayload
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealSuggestionPayload
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {Array<MealFoodAmount>}
     * @memberof MealSuggestionPayload
     */
    'food_items'?: Array<MealFoodAmount> | null;
    /**
     * 
     * @type {MetricMealDetailMacros}
     * @memberof MealSuggestionPayload
     */
    'macros'?: MetricMealDetailMacros | null;
    /**
     * 
     * @type {MetricMealDetailMicros}
     * @memberof MealSuggestionPayload
     */
    'micros'?: MetricMealDetailMicros | null;
    /**
     * 
     * @type {string}
     * @memberof MealSuggestionPayload
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MealSuggestionPayload
     */
    'title'?: string | null;
    /**
     * 
     * @type {MealType}
     * @memberof MealSuggestionPayload
     */
    'type'?: MealType;
}


/**
 * Canonical meal slot type
 * @export
 * @enum {string}
 */

export const MealType = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner'
} as const;

export type MealType = typeof MealType[keyof typeof MealType];


/**
 * 
 * @export
 * @interface MedicationSignalData
 */
export interface MedicationSignalData {
    /**
     * 
     * @type {string}
     * @memberof MedicationSignalData
     */
    'dose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicationSignalData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicationSignalData
     */
    'next_due_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MedicationSignalData
     */
    'taken_today'?: boolean | null;
}
/**
 * 
 * @export
 * @interface MenstrualCycleSignalData
 */
export interface MenstrualCycleSignalData {
    /**
     * 
     * @type {number}
     * @memberof MenstrualCycleSignalData
     */
    'day_in_cycle'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MenstrualCycleSignalData
     */
    'energy_modifier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MenstrualCycleSignalData
     */
    'phase'?: string | null;
}
/**
 * 
 * @export
 * @interface MetaExerciseItem
 */
export interface MetaExerciseItem {
    /**
     * 
     * @type {number}
     * @memberof MetaExerciseItem
     */
    'estimated_calories': number;
    /**
     * 
     * @type {string}
     * @memberof MetaExerciseItem
     */
    'type': MetaExerciseItemTypeEnum;
}

export const MetaExerciseItemTypeEnum = {
    Meta: 'meta'
} as const;

export type MetaExerciseItemTypeEnum = typeof MetaExerciseItemTypeEnum[keyof typeof MetaExerciseItemTypeEnum];

/**
 * 
 * @export
 * @interface MetricBarPayload
 */
export interface MetricBarPayload {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof MetricBarPayload
     */
    'baseline'?: number;
    /**
     * 
     * @type {MetricBarPayloadColorRamp}
     * @memberof MetricBarPayload
     */
    'color_ramp'?: MetricBarPayloadColorRamp;
    /**
     * 
     * @type {string}
     * @memberof MetricBarPayload
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetricBarPayload
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricBarPayload
     */
    'min'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetricBarPayload
     */
    'unit'?: string;
    /**
     * 
     * @type {number}
     * @memberof MetricBarPayload
     */
    'value'?: number;
}
/**
 * @type MetricBarPayloadColorRamp
 * @export
 */
export type MetricBarPayloadColorRamp = Array<string> | string;

/**
 * Macro nutrient values for a meal detail.
 * @export
 * @interface MetricMealDetailMacros
 */
export interface MetricMealDetailMacros {
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'alcohol_g'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'calories'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'carbohydrates_g'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'cholesterol_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'fat_g'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'fiber_g'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'protein_g'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'sodium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'sugar_g'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMacros
     */
    'trans_fat_g'?: number;
}
/**
 * Micro nutrient values for a meal detail.
 * @export
 * @interface MetricMealDetailMicros
 */
export interface MetricMealDetailMicros {
    [key: string]: number | any;

    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'biotin_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'caffeine_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'calcium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'chloride_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'chromium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'copper_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'folate_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'folic_acid_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'iodine_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'iron_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'magnesium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'manganese_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'molybdenum_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'niacin_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'pantothenic_acid_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'phosphorus_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'potassium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'riboflavin_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'selenium_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'thiamin_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_A_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_B12_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_B6_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_C_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_D_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_E_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'vitamin_K_mg'?: number;
    /**
     * 
     * @type {number}
     * @memberof MetricMealDetailMicros
     */
    'zinc_mg'?: number;
}
/**
 * SSE payload for `event: navigate` (v4 only). Emitted at most once per turn, after the assistant text and before `stream_end`. Never replay it from history. 
 * @export
 * @interface NavigateEvent
 */
export interface NavigateEvent {
    /**
     * true when the user explicitly asked to be taken there right now, so the client may navigate immediately; false means show a tappable button. 
     * @type {boolean}
     * @memberof NavigateEvent
     */
    'auto': boolean;
    /**
     * Button text for the tap-to-open CTA.
     * @type {string}
     * @memberof NavigateEvent
     */
    'label': string;
    /**
     * 
     * @type {NavigationTarget}
     * @memberof NavigateEvent
     */
    'target': NavigationTarget;
}


/**
 * Semantic in-app destination for the v4 `navigate` SSE event. The backend sends a target name; each client maps it to its own screen or modal and must ignore targets it does not recognise. - `calendar_settings`: connect or manage calendars - `todo_integrations`: connect or manage to-do apps - `health_settings`: connect wearables and health data sources - `daily_preview`: the Daily Preview (today\'s energy forecast) - `end_of_day_summary`: end-of-day summary / daily reflection - `ai_settings`: AI assistant settings - `subscription`: plan, billing, upgrade - `notification_settings`: reminder and notification settings - `energy_preferences`: chronotype, work hours, energy tuning - `location_preferences`: saved locations and location preferences 
 * @export
 * @enum {string}
 */

export const NavigationTarget = {
    CalendarSettings: 'calendar_settings',
    TodoIntegrations: 'todo_integrations',
    HealthSettings: 'health_settings',
    DailyPreview: 'daily_preview',
    EndOfDaySummary: 'end_of_day_summary',
    AiSettings: 'ai_settings',
    Subscription: 'subscription',
    NotificationSettings: 'notification_settings',
    EnergyPreferences: 'energy_preferences',
    LocationPreferences: 'location_preferences'
} as const;

export type NavigationTarget = typeof NavigationTarget[keyof typeof NavigationTarget];


/**
 * Place card emitted by location enrichment.
 * @export
 * @interface NearbyPlace
 */
export interface NearbyPlace {
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof NearbyPlace
     */
    'distance_m': number;
    /**
     * 
     * @type {number}
     * @memberof NearbyPlace
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof NearbyPlace
     */
    'lng': number;
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'map_url': string;
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'opening_hours'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'phone'?: string | null;
    /**
     * Google Places ID.
     * @type {string}
     * @memberof NearbyPlace
     */
    'place_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof NearbyPlace
     */
    'walk_min': number;
    /**
     * 
     * @type {string}
     * @memberof NearbyPlace
     */
    'website'?: string | null;
}
/**
 * 
 * @export
 * @interface NextEnergyZone
 */
export interface NextEnergyZone {
    [key: string]: any;

    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof NextEnergyZone
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextEnergyZone
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextEnergyZone
     */
    'level'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof NextEnergyZone
     */
    'start'?: string;
}
/**
 * 
 * @export
 * @interface NoteExerciseItem
 */
export interface NoteExerciseItem {
    /**
     * 
     * @type {string}
     * @memberof NoteExerciseItem
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof NoteExerciseItem
     */
    'type': NoteExerciseItemTypeEnum;
}

export const NoteExerciseItemTypeEnum = {
    Note: 'note'
} as const;

export type NoteExerciseItemTypeEnum = typeof NoteExerciseItemTypeEnum[keyof typeof NoteExerciseItemTypeEnum];

/**
 * 
 * @export
 * @interface PredictEventCategory200Response
 */
export interface PredictEventCategory200Response {
    /**
     * Predicted category
     * @type {string}
     * @memberof PredictEventCategory200Response
     */
    'category'?: string;
    /**
     * Confidence level of the prediction.
     * @type {number}
     * @memberof PredictEventCategory200Response
     */
    'confidence'?: number;
}
/**
 * 
 * @export
 * @interface PredictEventCategoryRequest
 */
export interface PredictEventCategoryRequest {
    /**
     * List of category titles
     * @type {Array<string>}
     * @memberof PredictEventCategoryRequest
     */
    'category_options'?: Array<string>;
    /**
     * Title of the event
     * @type {string}
     * @memberof PredictEventCategoryRequest
     */
    'event_title': string;
    /**
     * User-provided label set
     * @type {object}
     * @memberof PredictEventCategoryRequest
     */
    'user_label_set': object;
    /**
     * User profile from onboarding survey
     * @type {string}
     * @memberof PredictEventCategoryRequest
     */
    'user_profile'?: string;
}
/**
 * 
 * @export
 * @interface PredictTaskCategory200Response
 */
export interface PredictTaskCategory200Response {
    /**
     * Predicted task category
     * @type {string}
     * @memberof PredictTaskCategory200Response
     */
    'category'?: PredictTaskCategory200ResponseCategoryEnum;
    /**
     * Confidence level of the prediction (0.0 to 1.0)
     * @type {number}
     * @memberof PredictTaskCategory200Response
     */
    'confidence'?: number;
    /**
     * Brief explanation of why this category was chosen
     * @type {string}
     * @memberof PredictTaskCategory200Response
     */
    'reasoning'?: string;
}

export const PredictTaskCategory200ResponseCategoryEnum = {
    DeepWork: 'deep_work',
    LightTask: 'light_task',
    Meal: 'meal',
    Exercise: 'exercise',
    Social: 'social'
} as const;

export type PredictTaskCategory200ResponseCategoryEnum = typeof PredictTaskCategory200ResponseCategoryEnum[keyof typeof PredictTaskCategory200ResponseCategoryEnum];

/**
 * 
 * @export
 * @interface PredictTaskCategory400Response
 */
export interface PredictTaskCategory400Response {
    /**
     * Error message
     * @type {string}
     * @memberof PredictTaskCategory400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PredictTaskCategoryRequest
 */
export interface PredictTaskCategoryRequest {
    /**
     * List of available task categories
     * @type {Array<string>}
     * @memberof PredictTaskCategoryRequest
     */
    'category_options': Array<PredictTaskCategoryRequestCategoryOptionsEnum>;
    /**
     * Title of the task
     * @type {string}
     * @memberof PredictTaskCategoryRequest
     */
    'task_title': string;
    /**
     * User-provided label set for training/context
     * @type {object}
     * @memberof PredictTaskCategoryRequest
     */
    'user_label_set': object;
    /**
     * User profile from onboarding survey
     * @type {string}
     * @memberof PredictTaskCategoryRequest
     */
    'user_profile'?: string;
}

export const PredictTaskCategoryRequestCategoryOptionsEnum = {
    DeepWork: 'deep_work',
    LightTask: 'light_task',
    Meal: 'meal',
    Exercise: 'exercise',
    Social: 'social'
} as const;

export type PredictTaskCategoryRequestCategoryOptionsEnum = typeof PredictTaskCategoryRequestCategoryOptionsEnum[keyof typeof PredictTaskCategoryRequestCategoryOptionsEnum];

/**
 * Present on a response entry when the LLM produced no adjustments (pure query path). e.g. \"Any cafe around me\", \"How was my sleep?\", \"What\'s my energy now?\" 
 * @export
 * @interface QueryResult
 */
export interface QueryResult {
    /**
     * 
     * @type {RichContext}
     * @memberof QueryResult
     */
    'rich_context': RichContext | null;
}
/**
 * 
 * @export
 * @interface RecommendationNow200Response
 */
export interface RecommendationNow200Response {
    /**
     * 
     * @type {Adjustments}
     * @memberof RecommendationNow200Response
     */
    'adjustments'?: Adjustments;
    /**
     * A comprehensive, user-facing response explaining what was scheduled and why it\'s optimal for their current context.
     * @type {string}
     * @memberof RecommendationNow200Response
     */
    'chat_response'?: string;
}
/**
 * 
 * @export
 * @interface RecommendationNowRequest
 */
export interface RecommendationNowRequest {
    /**
     * 
     * @type {RecommendationNowRequestContextInput}
     * @memberof RecommendationNowRequest
     */
    'context_input'?: RecommendationNowRequestContextInput | null;
    /**
     * The user\'s current meal plan.
     * @type {Array<Meal>}
     * @memberof RecommendationNowRequest
     */
    'current_meals': Array<Meal>;
    /**
     * The user\'s current list of calendar events for the day.
     * @type {Array<ScheduleEvent>}
     * @memberof RecommendationNowRequest
     */
    'current_schedule': Array<ScheduleEvent>;
    /**
     * 
     * @type {SleepSchedule}
     * @memberof RecommendationNowRequest
     */
    'current_sleep': SleepSchedule;
    /**
     * Current time in HH:MM format (24-hour). Used to ensure suggestions happen after the current time.
     * @type {string}
     * @memberof RecommendationNowRequest
     */
    'current_time': string;
    /**
     * Enable unified context input system. When true, allows using context_input for enhanced prompt generation with structured context sections.
     * @type {boolean}
     * @memberof RecommendationNowRequest
     */
    'enable_unified_input'?: boolean;
    /**
     * User\'s energy zones for context
     * @type {Array<EnergyZone>}
     * @memberof RecommendationNowRequest
     */
    'energy_zones'?: Array<EnergyZone>;
    /**
     * List of pending todos for context
     * @type {Array<TodoItem>}
     * @memberof RecommendationNowRequest
     */
    'todo_list'?: Array<TodoItem>;
    /**
     * Enable Redis-based chat history for conversation continuity and personalized recommendations (defaults to true)
     * @type {boolean}
     * @memberof RecommendationNowRequest
     */
    'use_redis_history'?: boolean;
    /**
     * Optional user identifier for Redis-based chat history and cross-session memory. Enables conversation continuity and personalized recommendations by accessing stored user preferences, activity patterns, and interaction history.
     * @type {string}
     * @memberof RecommendationNowRequest
     */
    'user_id'?: string;
    /**
     * The user\'s message asking what to do now, which can include their current mood, energy level, or specific preferences.
     * @type {string}
     * @memberof RecommendationNowRequest
     */
    'user_message': string;
}
/**
 * Unified context input object containing all context data. Used when enable_unified_input=true for enhanced context generation with CalendarEventModel fields and structured prompt sections.
 * @export
 * @interface RecommendationNowRequestContextInput
 */
export interface RecommendationNowRequestContextInput {
    /**
     * Meal events
     * @type {Array<Meal>}
     * @memberof RecommendationNowRequestContextInput
     */
    'current_meals'?: Array<Meal>;
    /**
     * Enhanced calendar events with full CalendarEventModel fields
     * @type {Array<ScheduleEvent>}
     * @memberof RecommendationNowRequestContextInput
     */
    'current_schedule'?: Array<ScheduleEvent>;
    /**
     * 
     * @type {SleepSchedule}
     * @memberof RecommendationNowRequestContextInput
     */
    'current_sleep'?: SleepSchedule;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof RecommendationNowRequestContextInput
     */
    'current_time'?: string;
    /**
     * User\'s energy patterns
     * @type {Array<EnergyZone>}
     * @memberof RecommendationNowRequestContextInput
     */
    'energy_zones'?: Array<EnergyZone>;
    /**
     * User\'s pending todo items
     * @type {Array<TodoItem>}
     * @memberof RecommendationNowRequestContextInput
     */
    'todo_list'?: Array<TodoItem>;
    /**
     * Enable Redis-based chat history
     * @type {boolean}
     * @memberof RecommendationNowRequestContextInput
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based memory and chat history
     * @type {string}
     * @memberof RecommendationNowRequestContextInput
     */
    'user_id'?: string;
    /**
     * User\'s message or request
     * @type {string}
     * @memberof RecommendationNowRequestContextInput
     */
    'user_message'?: string;
}
/**
 * Rich context block attached to each `unified_chat_responses` entry in v3. Null in v2 responses (backwards-compatible). Always non-null in v3 — built server-side via `get_rich_context`; the LLM only populates `adjustments`.  **Routing logic (`get_rich_context`):** - If `adjustments` contains any schedule/meals/todo_list/routine data →   `build_rich_context_from_adjustments`: derives content from what the LLM wrote. - Otherwise (pure query, e.g. \"suggest cafes around me\") →   `build_rich_context_from_query`: derives content from intent + signals + location alone.   `reminder_min` is always null on this path (no scheduled event to remind about).  **enrichment_pending** lifecycle: 1. `result_json` emitted with `enrichment_pending: true` → frontend shows skeleton slots 2. Async skills fire (Google Places, OpenWeather, etc.) 3. `enrichment_patch` SSE events patch individual fields 4. Final patch sets `enrichment_pending: false` → skeleton disappears 
 * @export
 * @interface RichContext
 */
export interface RichContext {
    /**
     * 
     * @type {RichContextAction}
     * @memberof RichContext
     */
    'action'?: RichContextAction;
    /**
     * 
     * @type {RichContextContent}
     * @memberof RichContext
     */
    'content'?: RichContextContent;
    /**
     * True while async skill enrichment (Places, Weather, Commute) is still running. Frontend shows skeleton shimmer on null content fields while this is true. 
     * @type {boolean}
     * @memberof RichContext
     */
    'enrichment_pending'?: boolean;
    /**
     * 
     * @type {Location}
     * @memberof RichContext
     */
    'location'?: Location;
    /**
     * Minutes before the main event to trigger a local reminder notification. Server-computed from suggestion start time minus current time minus 10 min. 
     * @type {number}
     * @memberof RichContext
     */
    'reminder_min'?: number | null;
    /**
     * Wearable and context signals relevant to this response entry. Rendered as pill row above the content card. 
     * @type {Array<Signal>}
     * @memberof RichContext
     */
    'signals'?: Array<Signal>;
}
/**
 * Primary CTA action button attached to a rich_context entry
 * @export
 * @interface RichContextAction
 */
export interface RichContextAction {
    /**
     * Type of action the button triggers: - `open_map` — opens a map to `destination_name` / lat+lng - `start_timer` — starts an in-app timer for `duration_min` - `log_metric` — logs a metric value (e.g. medication dose) - `dismiss` — user just reads, no further action 
     * @type {string}
     * @memberof RichContextAction
     */
    'action_type': RichContextActionActionTypeEnum;
    /**
     * Short button label shown to the user (max ~30 chars)
     * @type {string}
     * @memberof RichContextAction
     */
    'label': string;
    /**
     * Action-specific payload: - `open_map`: `{destination_name, lat, lng}` - `start_timer`: `{duration_min, session_title}` - `log_metric`: `{metric_type, value, unit}` - `dismiss`: `{}` 
     * @type {{ [key: string]: any; }}
     * @memberof RichContextAction
     */
    'payload'?: { [key: string]: any; } | null;
}

export const RichContextActionActionTypeEnum = {
    OpenMap: 'open_map',
    StartTimer: 'start_timer',
    LogMetric: 'log_metric',
    Dismiss: 'dismiss'
} as const;

export type RichContextActionActionTypeEnum = typeof RichContextActionActionTypeEnum[keyof typeof RichContextActionActionTypeEnum];

/**
 * Domain-specific content card built server-side (no LLM involvement)
 * @export
 * @interface RichContextContent
 */
export interface RichContextContent {
    /**
     * 
     * @type {ContentPayload}
     * @memberof RichContextContent
     */
    'payload': ContentPayload;
    /**
     * Content card type — determines which UI component to render
     * @type {string}
     * @memberof RichContextContent
     */
    'type': RichContextContentTypeEnum;
}

export const RichContextContentTypeEnum = {
    MealSuggestion: 'meal_suggestion',
    FindLocation: 'find_location',
    WorkoutPlan: 'workout_plan',
    TransitRoute: 'transit_route',
    SleepSummary: 'sleep_summary',
    EnergySummary: 'energy_summary',
    HrSummary: 'hr_summary',
    Checklist: 'checklist',
    JournalPrompts: 'journal_prompts',
    AudioPlayer: 'audio_player',
    MetricBar: 'metric_bar'
} as const;

export type RichContextContentTypeEnum = typeof RichContextContentTypeEnum[keyof typeof RichContextContentTypeEnum];

/**
 * 
 * @export
 * @interface RichContextEnergyZone
 */
export interface RichContextEnergyZone {
    /**
     * 
     * @type {string}
     * @memberof RichContextEnergyZone
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof RichContextEnergyZone
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof RichContextEnergyZone
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof RichContextEnergyZone
     */
    'start'?: string;
}
/**
 * A routine activity to schedule (flat array item for daily planning)
 * @export
 * @interface RoutineActivity
 */
export interface RoutineActivity {
    /**
     * Effect on energy levels
     * @type {string}
     * @memberof RoutineActivity
     */
    'activity_effect'?: RoutineActivityActivityEffectEnum | null;
    /**
     * Category of the activity
     * @type {string}
     * @memberof RoutineActivity
     */
    'category'?: string | null;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof RoutineActivity
     */
    'duration': number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof RoutineActivity
     */
    'earliest'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof RoutineActivity
     */
    'latest'?: string;
    /**
     * Name of the routine activity
     * @type {string}
     * @memberof RoutineActivity
     */
    'name': string;
    /**
     * Unique identifier for the routine activity
     * @type {string}
     * @memberof RoutineActivity
     */
    'routine_activity_id'?: string | null;
    /**
     * How the activity should be scheduled
     * @type {string}
     * @memberof RoutineActivity
     */
    'scheduling_method'?: RoutineActivitySchedulingMethodEnum | null;
}

export const RoutineActivityActivityEffectEnum = {
    Peak: 'peak',
    Neutral: 'neutral',
    Dip: 'dip'
} as const;

export type RoutineActivityActivityEffectEnum = typeof RoutineActivityActivityEffectEnum[keyof typeof RoutineActivityActivityEffectEnum];
export const RoutineActivitySchedulingMethodEnum = {
    Fixed: 'fixed',
    Flexible: 'flexible'
} as const;

export type RoutineActivitySchedulingMethodEnum = typeof RoutineActivitySchedulingMethodEnum[keyof typeof RoutineActivitySchedulingMethodEnum];

/**
 * Routine activity adjustment for permanent changes to recurring routines. Unlike schedule/meal adjustments which affect specific dates, routine_adjustments modify the user\'s recurring routines that affect all future days. 
 * @export
 * @interface RoutineAdjustment
 */
export interface RoutineAdjustment {
    /**
     * Action to perform on the routine: - \"add\": Create a new recurring routine - \"remove\": Permanently remove a routine (e.g., due to health conditions) - \"modify\": Change an existing routine\'s timing or duration 
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'action': RoutineAdjustmentActionEnum;
    /**
     * Routine category (e.g., \"exercise\", \"personal\", \"work\")
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'category'?: string | null;
    /**
     * Routine duration in minutes (required for add/modify)
     * @type {number}
     * @memberof RoutineAdjustment
     */
    'durationMin'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'endTime'?: string;
    /**
     * Detailed explanation of why this routine adjustment was made. Should include context about lifestyle changes, health conditions, or user preferences. 
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'explanation': string;
    /**
     * Routine activity name
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'name': string;
    /**
     * 
     * @type {RoutineAdjustmentRecurring}
     * @memberof RoutineAdjustment
     */
    'recurring'?: RoutineAdjustmentRecurring | null;
    /**
     * Unique identifier for the routine activity. Required for \"remove\" and \"modify\" actions. Not required for \"add\" action (will be generated by backend). 
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'routineActivityId'?: string | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof RoutineAdjustment
     */
    'startTime'?: string;
}

export const RoutineAdjustmentActionEnum = {
    Add: 'add',
    Remove: 'remove',
    Modify: 'modify'
} as const;

export type RoutineAdjustmentActionEnum = typeof RoutineAdjustmentActionEnum[keyof typeof RoutineAdjustmentActionEnum];

/**
 * Recurring schedule configuration for each day of the week
 * @export
 * @interface RoutineAdjustmentRecurring
 */
export interface RoutineAdjustmentRecurring {
    /**
     * 
     * @type {RoutineAdjustmentRecurringFriday}
     * @memberof RoutineAdjustmentRecurring
     */
    'friday'?: RoutineAdjustmentRecurringFriday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringMonday}
     * @memberof RoutineAdjustmentRecurring
     */
    'monday'?: RoutineAdjustmentRecurringMonday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringSaturday}
     * @memberof RoutineAdjustmentRecurring
     */
    'saturday'?: RoutineAdjustmentRecurringSaturday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringSunday}
     * @memberof RoutineAdjustmentRecurring
     */
    'sunday'?: RoutineAdjustmentRecurringSunday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringThursday}
     * @memberof RoutineAdjustmentRecurring
     */
    'thursday'?: RoutineAdjustmentRecurringThursday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringTuesday}
     * @memberof RoutineAdjustmentRecurring
     */
    'tuesday'?: RoutineAdjustmentRecurringTuesday;
    /**
     * 
     * @type {RoutineAdjustmentRecurringWednesday}
     * @memberof RoutineAdjustmentRecurring
     */
    'wednesday'?: RoutineAdjustmentRecurringWednesday;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringFriday
 */
export interface RoutineAdjustmentRecurringFriday {
    /**
     * Whether the routine is enabled for Friday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringFriday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringMonday
 */
export interface RoutineAdjustmentRecurringMonday {
    /**
     * Whether the routine is enabled for Monday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringMonday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringSaturday
 */
export interface RoutineAdjustmentRecurringSaturday {
    /**
     * Whether the routine is enabled for Saturday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringSaturday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringSunday
 */
export interface RoutineAdjustmentRecurringSunday {
    /**
     * Whether the routine is enabled for Sunday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringSunday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringThursday
 */
export interface RoutineAdjustmentRecurringThursday {
    /**
     * Whether the routine is enabled for Thursday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringThursday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringTuesday
 */
export interface RoutineAdjustmentRecurringTuesday {
    /**
     * Whether the routine is enabled for Tuesday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringTuesday
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface RoutineAdjustmentRecurringWednesday
 */
export interface RoutineAdjustmentRecurringWednesday {
    /**
     * Whether the routine is enabled for Wednesday
     * @type {boolean}
     * @memberof RoutineAdjustmentRecurringWednesday
     */
    'enabled'?: boolean;
}
/**
 * Calendar event adjustment (add, update, or remove). Extends ScheduleEvent and requires schedule_action to be specified. Note: ScheduleEvent already includes schedule_action as optional; ScheduleAdjustment makes it required to indicate the type of adjustment. In v3, each entry may include a server-injected `rich_context` block (content card, action, signals) specific to this event. 
 * @export
 * @interface ScheduleAdjustment
 */
export interface ScheduleAdjustment {
    /**
     * Unique action identifier for matching events across adjustments (used in scheduler_chat)
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'action_id'?: string | null;
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof ScheduleAdjustment
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category (e.g., \"Meeting\", \"Work\", \"Personal\")
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'category'?: string | null;
    /**
     * Event description
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'description'?: string | null;
    /**
     * Duration in minutes (optional, can be calculated from start_time and end_time)
     * @type {number}
     * @memberof ScheduleAdjustment
     */
    'duration'?: number | null;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'end_date'?: string;
    /**
     * Day offset for event end relative to the response date. Use 0 for same-day end, 1 when the event ends on the next day. 
     * @type {number}
     * @memberof ScheduleAdjustment
     */
    'end_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'end_time'?: string;
    /**
     * Source of the event
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'event_from'?: ScheduleAdjustmentEventFromEnum | null;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {EventMetrics}
     * @memberof ScheduleAdjustment
     */
    'event_metrics'?: EventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'event_type'?: ScheduleAdjustmentEventTypeEnum | null;
    /**
     * Brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'name': string;
    /**
     * Original routine activity ID if event was created from a routine
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'origin_routine_activity_id'?: string | null;
    /**
     * Original todo ID if event was created from a todo
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'origin_todo_id'?: string | null;
    /**
     * 
     * @type {RichContext}
     * @memberof ScheduleAdjustment
     */
    'rich_context'?: RichContext | null;
    /**
     * Action to perform on the event (required in adjustments): - \"add\": Create a new calendar event (only include the added event in adjustments) - \"update\": Modify an existing event (requires event_id or action_id, only include the updated event in adjustments) - \"remove\": Delete an existing event (requires event_id or action_id, only include the removed event in adjustments) 
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'schedule_action': ScheduleAdjustmentScheduleActionEnum;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'start_date'?: string;
    /**
     * Day offset for event start relative to the response date. Use 0 for same-day start, 1 when the event starts on the next day. 
     * @type {number}
     * @memberof ScheduleAdjustment
     */
    'start_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'start_time'?: string;
    /**
     * The status of the event
     * @type {string}
     * @memberof ScheduleAdjustment
     */
    'status'?: ScheduleAdjustmentStatusEnum | null;
}

export const ScheduleAdjustmentEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Calendar: 'calendar',
    Activity: 'activity',
    Todo: 'todo',
    Meal: 'meal',
    Sleep: 'sleep',
    Routine: 'routine',
    Workout: 'workout'
} as const;

export type ScheduleAdjustmentEventFromEnum = typeof ScheduleAdjustmentEventFromEnum[keyof typeof ScheduleAdjustmentEventFromEnum];
export const ScheduleAdjustmentEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type ScheduleAdjustmentEventTypeEnum = typeof ScheduleAdjustmentEventTypeEnum[keyof typeof ScheduleAdjustmentEventTypeEnum];
export const ScheduleAdjustmentScheduleActionEnum = {
    Add: 'add',
    Update: 'update',
    Remove: 'remove'
} as const;

export type ScheduleAdjustmentScheduleActionEnum = typeof ScheduleAdjustmentScheduleActionEnum[keyof typeof ScheduleAdjustmentScheduleActionEnum];
export const ScheduleAdjustmentStatusEnum = {
    Confirmed: 'confirmed',
    Tentative: 'tentative',
    Cancelled: 'cancelled'
} as const;

export type ScheduleAdjustmentStatusEnum = typeof ScheduleAdjustmentStatusEnum[keyof typeof ScheduleAdjustmentStatusEnum];

/**
 * A calendar event or scheduled activity
 * @export
 * @interface ScheduleEvent
 */
export interface ScheduleEvent {
    /**
     * Unique action identifier for matching events across adjustments (used in scheduler_chat)
     * @type {string}
     * @memberof ScheduleEvent
     */
    'action_id'?: string | null;
    /**
     * List of attendee email addresses
     * @type {Array<string>}
     * @memberof ScheduleEvent
     */
    'attendees'?: Array<string> | null;
    /**
     * Event category (e.g., \"Meeting\", \"Work\", \"Personal\")
     * @type {string}
     * @memberof ScheduleEvent
     */
    'category'?: string | null;
    /**
     * Event description
     * @type {string}
     * @memberof ScheduleEvent
     */
    'description'?: string | null;
    /**
     * Duration in minutes (optional, can be calculated from start_time and end_time)
     * @type {number}
     * @memberof ScheduleEvent
     */
    'duration'?: number | null;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ScheduleEvent
     */
    'end_date'?: string;
    /**
     * Day offset for event end relative to the response date. Use 0 for same-day end, 1 when the event ends on the next day. 
     * @type {number}
     * @memberof ScheduleEvent
     */
    'end_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof ScheduleEvent
     */
    'end_time'?: string;
    /**
     * Source of the event
     * @type {string}
     * @memberof ScheduleEvent
     */
    'event_from'?: ScheduleEventEventFromEnum | null;
    /**
     * Unique identifier for the event
     * @type {string}
     * @memberof ScheduleEvent
     */
    'event_id'?: string | null;
    /**
     * 
     * @type {EventMetrics}
     * @memberof ScheduleEvent
     */
    'event_metrics'?: EventMetrics | null;
    /**
     * The type of the event
     * @type {string}
     * @memberof ScheduleEvent
     */
    'event_type'?: ScheduleEventEventTypeEnum | null;
    /**
     * Brief explanation of why this event is scheduled at this time
     * @type {string}
     * @memberof ScheduleEvent
     */
    'explanation'?: string | null;
    /**
     * Event location
     * @type {string}
     * @memberof ScheduleEvent
     */
    'location'?: string | null;
    /**
     * Meeting link URL
     * @type {string}
     * @memberof ScheduleEvent
     */
    'meeting_link'?: string | null;
    /**
     * Event name
     * @type {string}
     * @memberof ScheduleEvent
     */
    'name': string;
    /**
     * Original routine activity ID if event was created from a routine
     * @type {string}
     * @memberof ScheduleEvent
     */
    'origin_routine_activity_id'?: string | null;
    /**
     * Original todo ID if event was created from a todo
     * @type {string}
     * @memberof ScheduleEvent
     */
    'origin_todo_id'?: string | null;
    /**
     * 
     * @type {RichContext}
     * @memberof ScheduleEvent
     */
    'rich_context'?: RichContext | null;
    /**
     * Action to perform on the event when returned in adjustments: - \"add\": Create a new calendar event (requires start_time, end_time, and other event details) - \"update\": Modify an existing event (requires event_id or action_id, start_time, end_time, and updated fields) - \"remove\": Delete an existing event (requires event_id or action_id, name; start_time and end_time are optional) When schedule_action is not specified, start_time and end_time are required (backward compatibility). 
     * @type {string}
     * @memberof ScheduleEvent
     */
    'schedule_action'?: ScheduleEventScheduleActionEnum | null;
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ScheduleEvent
     */
    'start_date'?: string;
    /**
     * Day offset for event start relative to the response date. Use 0 for same-day start, 1 when the event starts on the next day. 
     * @type {number}
     * @memberof ScheduleEvent
     */
    'start_day_offset'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof ScheduleEvent
     */
    'start_time'?: string;
    /**
     * The status of the event
     * @type {string}
     * @memberof ScheduleEvent
     */
    'status'?: ScheduleEventStatusEnum | null;
}

export const ScheduleEventEventFromEnum = {
    ExistingCalendar: 'existing_calendar',
    Calendar: 'calendar',
    Activity: 'activity',
    Todo: 'todo',
    Meal: 'meal',
    Sleep: 'sleep',
    Routine: 'routine',
    Workout: 'workout'
} as const;

export type ScheduleEventEventFromEnum = typeof ScheduleEventEventFromEnum[keyof typeof ScheduleEventEventFromEnum];
export const ScheduleEventEventTypeEnum = {
    Default: 'default',
    OutOfOffice: 'outOfOffice',
    FocusTime: 'focusTime',
    WorkingLocation: 'workingLocation',
    Other: 'other'
} as const;

export type ScheduleEventEventTypeEnum = typeof ScheduleEventEventTypeEnum[keyof typeof ScheduleEventEventTypeEnum];
export const ScheduleEventScheduleActionEnum = {
    Add: 'add',
    Update: 'update',
    Remove: 'remove'
} as const;

export type ScheduleEventScheduleActionEnum = typeof ScheduleEventScheduleActionEnum[keyof typeof ScheduleEventScheduleActionEnum];
export const ScheduleEventStatusEnum = {
    Confirmed: 'confirmed',
    Tentative: 'tentative',
    Cancelled: 'cancelled'
} as const;

export type ScheduleEventStatusEnum = typeof ScheduleEventStatusEnum[keyof typeof ScheduleEventStatusEnum];

/**
 * User\'s scheduling preferences including work hours and constraints
 * @export
 * @interface SchedulerPreferences
 */
export interface SchedulerPreferences {
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SchedulerPreferences
     */
    'work_end': string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SchedulerPreferences
     */
    'work_start': string;
}
/**
 * 
 * @export
 * @interface ScreenTimeSignalData
 */
export interface ScreenTimeSignalData {
    /**
     * 
     * @type {number}
     * @memberof ScreenTimeSignalData
     */
    'last_2h_min'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ScreenTimeSignalData
     */
    'top_app'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScreenTimeSignalData
     */
    'total_min'?: number | null;
}
/**
 * A single actionable wearable or context signal shown to the user
 * @export
 * @interface Signal
 */
export interface Signal {
    /**
     * Human-readable one-liner summary shown as a pill
     * @type {string}
     * @memberof Signal
     */
    'body': string;
    /**
     * 
     * @type {SignalData}
     * @memberof Signal
     */
    'data'?: SignalData | null;
    /**
     * ISO datetime when this signal expires (null = never)
     * @type {string}
     * @memberof Signal
     */
    'expires_at'?: string | null;
    /**
     * Source category of the signal
     * @type {string}
     * @memberof Signal
     */
    'signal_source': SignalSignalSourceEnum;
    /**
     * How time-sensitive this signal is
     * @type {string}
     * @memberof Signal
     */
    'urgency': SignalUrgencyEnum;
}

export const SignalSignalSourceEnum = {
    Meal: 'meal',
    Energy: 'energy',
    Sleep: 'sleep',
    Weather: 'weather',
    ScreenTime: 'screen_time',
    Commute: 'commute',
    Steps: 'steps',
    MenstrualCycle: 'menstrual_cycle',
    Medication: 'medication'
} as const;

export type SignalSignalSourceEnum = typeof SignalSignalSourceEnum[keyof typeof SignalSignalSourceEnum];
export const SignalUrgencyEnum = {
    Now: 'now',
    Soon: 'soon',
    Info: 'info'
} as const;

export type SignalUrgencyEnum = typeof SignalUrgencyEnum[keyof typeof SignalUrgencyEnum];

/**
 * @type SignalData
 * Typed wearable/context payload attached to a Signal. Shape depends on `signal_source` and should match that source\'s schema. 
 * @export
 */
export type SignalData = CommuteSignalData | EnergySignalData | MealSignalData | MedicationSignalData | MenstrualCycleSignalData | ScreenTimeSignalData | SleepSignalData | StepsSignalData | WeatherSignalData;

/**
 * 
 * @export
 * @interface SleepChartPoint
 */
export interface SleepChartPoint {
    /**
     * 
     * @type {number}
     * @memberof SleepChartPoint
     */
    'duration_min'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SleepChartPoint
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SleepChartPoint
     */
    'stage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SleepChartPoint
     */
    'start_time'?: string | null;
}
/**
 * Detailed sleep information for a specific date
 * @export
 * @interface SleepDetail
 */
export interface SleepDetail {
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SleepDetail
     */
    'awake_time'?: string;
    /**
     * Total sleep duration in minutes
     * @type {number}
     * @memberof SleepDetail
     */
    'duration_min'?: number | null;
    /**
     * Sleep efficiency percentage (0-100)
     * @type {number}
     * @memberof SleepDetail
     */
    'efficiency'?: number | null;
    /**
     * Heart rate variability
     * @type {number}
     * @memberof SleepDetail
     */
    'hrv'?: number | null;
    /**
     * Resting heart rate
     * @type {number}
     * @memberof SleepDetail
     */
    'resting_hr'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SleepDetail
     */
    'sleep_time'?: string;
    /**
     * Source of sleep data (e.g., \"Apple Watch\", \"Oura Ring\", \"Manual Entry\")
     * @type {string}
     * @memberof SleepDetail
     */
    'source'?: string | null;
    /**
     * 
     * @type {SleepStages}
     * @memberof SleepDetail
     */
    'stages'?: SleepStages | null;
}
/**
 * 
 * @export
 * @interface SleepHistoryPoint
 */
export interface SleepHistoryPoint {
    /**
     * 
     * @type {string}
     * @memberof SleepHistoryPoint
     */
    'sleep_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SleepHistoryPoint
     */
    'wake_time'?: string | null;
}
/**
 * Sleep schedule with ideal sleep and wake times. In v3, includes a server-injected `rich_context` block (sleep_summary content card, wind-down action, sleep/energy signals). 
 * @export
 * @interface SleepSchedule
 */
export interface SleepSchedule {
    /**
     * Brief explanation of why this sleep schedule was recommended
     * @type {string}
     * @memberof SleepSchedule
     */
    'explanation'?: string | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SleepSchedule
     */
    'ideal_sleep_time': string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof SleepSchedule
     */
    'ideal_wake_time': string;
    /**
     * 
     * @type {RichContext}
     * @memberof SleepSchedule
     */
    'rich_context'?: RichContext | null;
}
/**
 * Same interface as `SleepSummaryPayload`. 
 * @export
 * @interface SleepSignalData
 */
export interface SleepSignalData {
    /**
     * 
     * @type {string}
     * @memberof SleepSignalData
     */
    'awake_time'?: string;
    /**
     * 
     * @type {number}
     * @memberof SleepSignalData
     */
    'duration_h'?: number;
    /**
     * 
     * @type {number}
     * @memberof SleepSignalData
     */
    'efficiency'?: number;
    /**
     * 
     * @type {HeartRateSummary}
     * @memberof SleepSignalData
     */
    'heart_rate_summary'?: HeartRateSummary;
    /**
     * 
     * @type {Array<SleepHistoryPoint>}
     * @memberof SleepSignalData
     */
    'history'?: Array<SleepHistoryPoint>;
    /**
     * 
     * @type {string}
     * @memberof SleepSignalData
     */
    'ideal_sleep_time_tonight'?: string;
    /**
     * 
     * @type {number}
     * @memberof SleepSignalData
     */
    'quality_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof SleepSignalData
     */
    'sleep_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof SleepSignalData
     */
    'sleep_time'?: string;
    /**
     * 
     * @type {{ [key: string]: SleepStageMetrics; }}
     * @memberof SleepSignalData
     */
    'stages'?: { [key: string]: SleepStageMetrics; };
    /**
     * 
     * @type {SleepTimingWindow}
     * @memberof SleepSignalData
     */
    'suggested_sleep'?: SleepTimingWindow;
    /**
     * 
     * @type {number}
     * @memberof SleepSignalData
     */
    'temperature_delta'?: number;
}
/**
 * 
 * @export
 * @interface SleepStageMetrics
 */
export interface SleepStageMetrics {
    /**
     * 
     * @type {number}
     * @memberof SleepStageMetrics
     */
    'duration_min': number;
}
/**
 * Sleep stage breakdown in minutes
 * @export
 * @interface SleepStages
 */
export interface SleepStages {
    /**
     * Awake time during sleep in minutes
     * @type {number}
     * @memberof SleepStages
     */
    'awake'?: number | null;
    /**
     * Deep sleep duration in minutes
     * @type {number}
     * @memberof SleepStages
     */
    'deep'?: number | null;
    /**
     * Light sleep duration in minutes
     * @type {number}
     * @memberof SleepStages
     */
    'light'?: number | null;
    /**
     * REM sleep duration in minutes
     * @type {number}
     * @memberof SleepStages
     */
    'rem'?: number | null;
}
/**
 * 
 * @export
 * @interface SleepSummaryPayload
 */
export interface SleepSummaryPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof SleepSummaryPayload
     */
    'awake_time'?: string;
    /**
     * 
     * @type {number}
     * @memberof SleepSummaryPayload
     */
    'duration_h'?: number;
    /**
     * 
     * @type {number}
     * @memberof SleepSummaryPayload
     */
    'efficiency'?: number;
    /**
     * 
     * @type {HeartRateSummary}
     * @memberof SleepSummaryPayload
     */
    'heart_rate_summary'?: HeartRateSummary;
    /**
     * 
     * @type {Array<SleepHistoryPoint>}
     * @memberof SleepSummaryPayload
     */
    'history'?: Array<SleepHistoryPoint>;
    /**
     * 
     * @type {string}
     * @memberof SleepSummaryPayload
     */
    'ideal_sleep_time_tonight'?: string;
    /**
     * 
     * @type {number}
     * @memberof SleepSummaryPayload
     */
    'quality_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof SleepSummaryPayload
     */
    'sleep_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof SleepSummaryPayload
     */
    'sleep_time'?: string;
    /**
     * 
     * @type {{ [key: string]: SleepStageMetrics; }}
     * @memberof SleepSummaryPayload
     */
    'stages'?: { [key: string]: SleepStageMetrics; };
    /**
     * 
     * @type {SleepTimingWindow}
     * @memberof SleepSummaryPayload
     */
    'suggested_sleep'?: SleepTimingWindow;
    /**
     * 
     * @type {number}
     * @memberof SleepSummaryPayload
     */
    'temperature_delta'?: number;
}
/**
 * 
 * @export
 * @interface SleepTimingWindow
 */
export interface SleepTimingWindow {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof SleepTimingWindow
     */
    'duration_min'?: number;
    /**
     * 
     * @type {string}
     * @memberof SleepTimingWindow
     */
    'end_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof SleepTimingWindow
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof SleepTimingWindow
     */
    'start_time'?: string;
}
/**
 * 
 * @export
 * @interface SmoothEnergyCurveRequest
 */
export interface SmoothEnergyCurveRequest {
    /**
     * Original energy
     * @type {Array<number>}
     * @memberof SmoothEnergyCurveRequest
     */
    'energy'?: Array<number>;
    /**
     * Total minutes
     * @type {number}
     * @memberof SmoothEnergyCurveRequest
     */
    'total_minutes'?: number;
}
/**
 * 
 * @export
 * @interface StartChatSession200Response
 */
export interface StartChatSession200Response {
    /**
     * Session expiration time in seconds (7 days)
     * @type {number}
     * @memberof StartChatSession200Response
     */
    'expires_in'?: number;
    /**
     * Confirmation message
     * @type {string}
     * @memberof StartChatSession200Response
     */
    'message'?: string;
    /**
     * Unique session identifier for subsequent streaming requests. Format - env:user_id:type:timestamp
     * @type {string}
     * @memberof StartChatSession200Response
     */
    'sessionId': string;
    /**
     * Type of session that was created
     * @type {string}
     * @memberof StartChatSession200Response
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface StartChatSession400Response
 */
export interface StartChatSession400Response {
    /**
     * Detailed error message describing the validation issue
     * @type {string}
     * @memberof StartChatSession400Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StartChatSession500Response
 */
export interface StartChatSession500Response {
    /**
     * Internal error message
     * @type {string}
     * @memberof StartChatSession500Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StartChatSessionRequest
 */
export interface StartChatSessionRequest {
    /**
     * 
     * @type {StartChatSessionRequestContextInput}
     * @memberof StartChatSessionRequest
     */
    'context_input': StartChatSessionRequestContextInput;
    /**
     * 
     * @type {StartChatSessionRequestSleepDetailedSummaryInput}
     * @memberof StartChatSessionRequest
     */
    'sleep_detailed_summary_input'?: StartChatSessionRequestSleepDetailedSummaryInput | null;
    /**
     * Type of streaming chat session to initialize
     * @type {string}
     * @memberof StartChatSessionRequest
     */
    'type': StartChatSessionRequestTypeEnum;
    /**
     * Unique user identifier for session management and personalization
     * @type {string}
     * @memberof StartChatSessionRequest
     */
    'user_id': string;
}

export const StartChatSessionRequestTypeEnum = {
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task',
    FreeText: 'freeText',
    RecommendationNow: 'recommendationNow'
} as const;

export type StartChatSessionRequestTypeEnum = typeof StartChatSessionRequestTypeEnum[keyof typeof StartChatSessionRequestTypeEnum];

/**
 * Comprehensive context input object containing all user data and preferences
 * @export
 * @interface StartChatSessionRequestContextInput
 */
export interface StartChatSessionRequestContextInput {
    /**
     * Current date in YYYY-MM-DD format
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'current_date'?: string;
    /**
     * User\'s current meal schedule
     * @type {Array<Meal>}
     * @memberof StartChatSessionRequestContextInput
     */
    'current_meals'?: Array<Meal>;
    /**
     * User\'s current calendar events and appointments
     * @type {Array<ScheduleEvent>}
     * @memberof StartChatSessionRequestContextInput
     */
    'current_schedule'?: Array<ScheduleEvent>;
    /**
     * 
     * @type {SleepSchedule}
     * @memberof StartChatSessionRequestContextInput
     */
    'current_sleep'?: SleepSchedule;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'current_time'?: string;
    /**
     * User\'s natural energy patterns throughout the day
     * @type {Array<EnergyZone>}
     * @memberof StartChatSessionRequestContextInput
     */
    'energy_zones'?: Array<EnergyZone>;
    /**
     * 
     * @type {ScheduleEvent}
     * @memberof StartChatSessionRequestContextInput
     */
    'first_calendar_event'?: ScheduleEvent;
    /**
     * 
     * @type {ScheduleEvent}
     * @memberof StartChatSessionRequestContextInput
     */
    'last_calendar_event'?: ScheduleEvent;
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferences}
     * @memberof StartChatSessionRequestContextInput
     */
    'meal_preferences'?: StartChatSessionRequestContextInputMealPreferences;
    /**
     * Historical sleep and wake time pairs for pattern analysis
     * @type {Array<Array<string>>}
     * @memberof StartChatSessionRequestContextInput
     */
    'sleep_wake_times'?: Array<Array<string>>;
    /**
     * User\'s pending todo items and tasks
     * @type {Array<TodoItem>}
     * @memberof StartChatSessionRequestContextInput
     */
    'todo_list'?: Array<TodoItem>;
    /**
     * Enable Redis-based chat history for conversation continuity
     * @type {boolean}
     * @memberof StartChatSessionRequestContextInput
     */
    'use_redis_history'?: boolean;
    /**
     * User identifier for Redis-based memory and personalization
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'user_id'?: string;
    /**
     * Initial user message or question to start the conversation
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'user_message'?: string;
    /**
     * User\'s time format (e.g., \'ampm\', \'24h\')
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'user_time_format'?: string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\'). Used to convert timestamps between user\'s local time and UTC for database operations.
     * @type {string}
     * @memberof StartChatSessionRequestContextInput
     */
    'user_tz'?: string;
}
/**
 * User\'s meal preferences including optional start/end times and durations
 * @export
 * @interface StartChatSessionRequestContextInputMealPreferences
 */
export interface StartChatSessionRequestContextInputMealPreferences {
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesBreakfast}
     * @memberof StartChatSessionRequestContextInputMealPreferences
     */
    'breakfast'?: StartChatSessionRequestContextInputMealPreferencesBreakfast;
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesDinner}
     * @memberof StartChatSessionRequestContextInputMealPreferences
     */
    'dinner'?: StartChatSessionRequestContextInputMealPreferencesDinner;
    /**
     * 
     * @type {StartChatSessionRequestContextInputMealPreferencesLunch}
     * @memberof StartChatSessionRequestContextInputMealPreferences
     */
    'lunch'?: StartChatSessionRequestContextInputMealPreferencesLunch;
}
/**
 * Breakfast preferences
 * @export
 * @interface StartChatSessionRequestContextInputMealPreferencesBreakfast
 */
export interface StartChatSessionRequestContextInputMealPreferencesBreakfast {
    /**
     * Duration for breakfast in minutes
     * @type {number}
     * @memberof StartChatSessionRequestContextInputMealPreferencesBreakfast
     */
    'duration_min'?: number;
    /**
     * Preferred breakfast end time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesBreakfast
     */
    'end_time'?: string;
    /**
     * Whether to skip breakfast recommendation
     * @type {boolean}
     * @memberof StartChatSessionRequestContextInputMealPreferencesBreakfast
     */
    'skip'?: boolean;
    /**
     * Preferred breakfast start time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesBreakfast
     */
    'start_time'?: string;
}
/**
 * Dinner preferences
 * @export
 * @interface StartChatSessionRequestContextInputMealPreferencesDinner
 */
export interface StartChatSessionRequestContextInputMealPreferencesDinner {
    /**
     * Duration for dinner in minutes
     * @type {number}
     * @memberof StartChatSessionRequestContextInputMealPreferencesDinner
     */
    'duration_min'?: number;
    /**
     * Preferred dinner end time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesDinner
     */
    'end_time'?: string;
    /**
     * Whether to skip dinner recommendation
     * @type {boolean}
     * @memberof StartChatSessionRequestContextInputMealPreferencesDinner
     */
    'skip'?: boolean;
    /**
     * Preferred dinner start time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesDinner
     */
    'start_time'?: string;
}
/**
 * Lunch preferences
 * @export
 * @interface StartChatSessionRequestContextInputMealPreferencesLunch
 */
export interface StartChatSessionRequestContextInputMealPreferencesLunch {
    /**
     * Duration for lunch in minutes
     * @type {number}
     * @memberof StartChatSessionRequestContextInputMealPreferencesLunch
     */
    'duration_min'?: number;
    /**
     * Preferred lunch end time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesLunch
     */
    'end_time'?: string;
    /**
     * Whether to skip lunch recommendation
     * @type {boolean}
     * @memberof StartChatSessionRequestContextInputMealPreferencesLunch
     */
    'skip'?: boolean;
    /**
     * Preferred lunch start time in HH:MM format
     * @type {string}
     * @memberof StartChatSessionRequestContextInputMealPreferencesLunch
     */
    'start_time'?: string;
}
/**
 * Optional detailed sleep data for enhanced sleep-specific recommendations
 * @export
 * @interface StartChatSessionRequestSleepDetailedSummaryInput
 */
export interface StartChatSessionRequestSleepDetailedSummaryInput {
    /**
     * Historical sleep data for the last two weeks (date as key, sleep detail as value)
     * @type {{ [key: string]: StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue; }}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInput
     */
    'historical_sleep_detail'?: { [key: string]: StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue; } | null;
    /**
     * 
     * @type {StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInput
     */
    'today_sleep_detail'?: StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail | null;
}
/**
 * Sleep detail for a specific date
 * @export
 * @interface StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
 */
export interface StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue {
    /**
     * Time when user woke up
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'awake_time'?: string;
    /**
     * Total sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'duration_min'?: number;
    /**
     * Sleep efficiency percentage (0-100)
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'efficiency'?: number;
    /**
     * Time when user went to sleep
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'sleep_time'?: string;
    /**
     * Source of sleep data
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'source'?: string;
    /**
     * 
     * @type {StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValue
     */
    'stages'?: StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages;
}
/**
 * Sleep stage breakdown in minutes
 * @export
 * @interface StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages
 */
export interface StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages {
    /**
     * Time awake during sleep in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages
     */
    'awake'?: number;
    /**
     * Deep sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages
     */
    'deep'?: number;
    /**
     * Light sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages
     */
    'light'?: number;
    /**
     * REM sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputHistoricalSleepDetailValueStages
     */
    'rem'?: number;
}
/**
 * Today\'s detailed sleep metrics and analysis
 * @export
 * @interface StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
 */
export interface StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail {
    /**
     * Time when user woke up
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'awake_time'?: string;
    /**
     * Total sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'duration_min'?: number;
    /**
     * Sleep efficiency percentage (0-100)
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'efficiency'?: number;
    /**
     * Time when user went to sleep
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'sleep_time'?: string;
    /**
     * Source of sleep data
     * @type {string}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'source'?: string;
    /**
     * 
     * @type {StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetail
     */
    'stages'?: StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages;
}
/**
 * Sleep stage breakdown in minutes
 * @export
 * @interface StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages
 */
export interface StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages {
    /**
     * Time awake during sleep in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages
     */
    'awake'?: number;
    /**
     * Deep sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages
     */
    'deep'?: number;
    /**
     * Light sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages
     */
    'light'?: number;
    /**
     * REM sleep duration in minutes
     * @type {number}
     * @memberof StartChatSessionRequestSleepDetailedSummaryInputTodaySleepDetailStages
     */
    'rem'?: number;
}
/**
 * 
 * @export
 * @interface StartChatSessionV2200Response
 */
export interface StartChatSessionV2200Response {
    /**
     * Unique session identifier for subsequent streaming requests. Format - env:user_id:session_type:timestamp
     * @type {string}
     * @memberof StartChatSessionV2200Response
     */
    'sessionId': string;
    /**
     * Type of session that was created
     * @type {string}
     * @memberof StartChatSessionV2200Response
     */
    'session_type': string;
}
/**
 * 
 * @export
 * @interface StartChatSessionV2400Response
 */
export interface StartChatSessionV2400Response {
    /**
     * Detailed error message describing the validation issue
     * @type {string}
     * @memberof StartChatSessionV2400Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StartChatSessionV2Request
 */
export interface StartChatSessionV2Request {
    /**
     * Current date in YYYY-MM-DD format
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'current_date': string;
    /**
     * Current time in HH:MM format (24-hour)
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'current_time': string;
    /**
     * Unique metric identifier for session management and personalization
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'metric_id': string;
    /**
     * Unique preference identifier for session management and personalization
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'preference_id': string;
    /**
     * Unique routine identifier for session management and personalization
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'routine_id': string;
    /**
     * Type of streaming chat session to initialize
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'session_type': StartChatSessionV2RequestSessionTypeEnum;
    /**
     * Unique user identifier for session management and personalization
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'user_id': string;
    /**
     * Initial user message or question to start the conversation
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'user_message': string;
    /**
     * User\'s time format (\'ampm\' or \'24h\')
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'user_time_format': string;
    /**
     * User\'s timezone for proper date/time handling and Firebase queries (e.g., \'America/New_York\', \'UTC\'). Used to convert timestamps between user\'s local time and UTC for database operations.
     * @type {string}
     * @memberof StartChatSessionV2Request
     */
    'user_tz': string;
}

export const StartChatSessionV2RequestSessionTypeEnum = {
    Sleep: 'sleep',
    Meal: 'meal',
    Task: 'task',
    FreeText: 'freeText',
    RecommendationNow: 'recommendationNow'
} as const;

export type StartChatSessionV2RequestSessionTypeEnum = typeof StartChatSessionV2RequestSessionTypeEnum[keyof typeof StartChatSessionV2RequestSessionTypeEnum];

/**
 * 
 * @export
 * @interface StepsSignalData
 */
export interface StepsSignalData {
    /**
     * 
     * @type {number}
     * @memberof StepsSignalData
     */
    'goal'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StepsSignalData
     */
    'percent_complete'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StepsSignalData
     */
    'today'?: number | null;
}
/**
 * 
 * @export
 * @interface StreamChatResponse400Response
 */
export interface StreamChatResponse400Response {
    /**
     * Detailed error message describing the specific validation issue
     * @type {string}
     * @memberof StreamChatResponse400Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StreamChatResponse404Response
 */
export interface StreamChatResponse404Response {
    /**
     * Session not found error with helpful context
     * @type {string}
     * @memberof StreamChatResponse404Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface StreamChatResponse500Response
 */
export interface StreamChatResponse500Response {
    /**
     * Internal error message with context for debugging
     * @type {string}
     * @memberof StreamChatResponse500Response
     */
    'error': string;
}
/**
 * Task adjustment (add, update, or remove)
 * @export
 * @interface TodoAdjustment
 */
export interface TodoAdjustment {
    /**
     * Task category
     * @type {string}
     * @memberof TodoAdjustment
     */
    'category'?: string | null;
    /**
     * Whether the task is completed
     * @type {boolean}
     * @memberof TodoAdjustment
     */
    'completed'?: boolean | null;
    /**
     * Whether the task should be deleted
     * @type {boolean}
     * @memberof TodoAdjustment
     */
    'deleted'?: boolean | null;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof TodoAdjustment
     */
    'duration'?: number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoAdjustment
     */
    'earliest_start'?: string;
    /**
     * Brief explanation of why this task adjustment was made
     * @type {string}
     * @memberof TodoAdjustment
     */
    'explanation'?: string | null;
    /**
     * Labels associated with the task (used for category inference)
     * @type {Array<string>}
     * @memberof TodoAdjustment
     */
    'labels'?: Array<string> | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoAdjustment
     */
    'latest_finish'?: string;
    /**
     * Whether the task can be rescheduled
     * @type {boolean}
     * @memberof TodoAdjustment
     */
    'movable'?: boolean | null;
    /**
     * Task name
     * @type {string}
     * @memberof TodoAdjustment
     */
    'name': string;
    /**
     * Priority level (lower = higher priority)
     * @type {number}
     * @memberof TodoAdjustment
     */
    'priority'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoAdjustment
     */
    'suggested_end_time'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoAdjustment
     */
    'suggested_start_time'?: string;
    /**
     * Unique identifier for the todo item
     * @type {string}
     * @memberof TodoAdjustment
     */
    'todo_id'?: string | null;
    /**
     * Action to perform on the task: - \"add\": Add a new task to the todo list - \"update\": Modify an existing task (requires todo_id) - \"remove\": Remove a task from the todo list (requires todo_id) 
     * @type {string}
     * @memberof TodoAdjustment
     */
    'action': TodoAdjustmentActionEnum;
}

export const TodoAdjustmentActionEnum = {
    Add: 'add',
    Update: 'update',
    Remove: 'remove'
} as const;

export type TodoAdjustmentActionEnum = typeof TodoAdjustmentActionEnum[keyof typeof TodoAdjustmentActionEnum];

/**
 * A task or todo item
 * @export
 * @interface TodoItem
 */
export interface TodoItem {
    /**
     * Task category
     * @type {string}
     * @memberof TodoItem
     */
    'category'?: string | null;
    /**
     * Whether the task is completed
     * @type {boolean}
     * @memberof TodoItem
     */
    'completed'?: boolean | null;
    /**
     * Whether the task should be deleted
     * @type {boolean}
     * @memberof TodoItem
     */
    'deleted'?: boolean | null;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof TodoItem
     */
    'duration'?: number;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoItem
     */
    'earliest_start'?: string;
    /**
     * Brief explanation of why this task adjustment was made
     * @type {string}
     * @memberof TodoItem
     */
    'explanation'?: string | null;
    /**
     * Labels associated with the task (used for category inference)
     * @type {Array<string>}
     * @memberof TodoItem
     */
    'labels'?: Array<string> | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoItem
     */
    'latest_finish'?: string;
    /**
     * Whether the task can be rescheduled
     * @type {boolean}
     * @memberof TodoItem
     */
    'movable'?: boolean | null;
    /**
     * Task name
     * @type {string}
     * @memberof TodoItem
     */
    'name': string;
    /**
     * Priority level (lower = higher priority)
     * @type {number}
     * @memberof TodoItem
     */
    'priority'?: number | null;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoItem
     */
    'suggested_end_time'?: string;
    /**
     * Time in HH:MM format (24-hour)
     * @type {string}
     * @memberof TodoItem
     */
    'suggested_start_time'?: string;
    /**
     * Unique identifier for the todo item
     * @type {string}
     * @memberof TodoItem
     */
    'todo_id'?: string | null;
}
/**
 * 
 * @export
 * @interface TransitRoutePayload
 */
export interface TransitRoutePayload {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof TransitRoutePayload
     */
    'distance_km'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransitRoutePayload
     */
    'duration_min'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransitRoutePayload
     */
    'route_name'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof TransitRoutePayload
     */
    'steps'?: Array<{ [key: string]: any; }>;
}
/**
 * A single unified chat response item for a specific date
 * @export
 * @interface UnifiedChatResponseItem
 */
export interface UnifiedChatResponseItem {
    /**
     * 
     * @type {Adjustments}
     * @memberof UnifiedChatResponseItem
     */
    'adjustments'?: Adjustments;
    /**
     * Date in YYYYMMDD format
     * @type {string}
     * @memberof UnifiedChatResponseItem
     */
    'date'?: string;
}
/**
 * A single unified chat response entry in v3.  **rich_context placement (v3):** - Has adjustment items → `rich_context` is attached directly on each item inside   `adjustments.schedule[i]`, `adjustments.meals[i]`, `adjustments.sleep`,   `adjustments.todo_list[i]`, `adjustments.routine_adjustments[i]`. - No adjustment items (pure query) → `query.rich_context` is set; `adjustments` fields are all null.  The entry-level `rich_context` field is removed in v3. 
 * @export
 * @interface UnifiedChatResponseItemV3
 */
export interface UnifiedChatResponseItemV3 {
    /**
     * 
     * @type {Adjustments}
     * @memberof UnifiedChatResponseItemV3
     */
    'adjustments'?: Adjustments;
    /**
     * Date in YYYY-MM-DD format (always ISO in v3; YYYYMMDD in v2)
     * @type {string}
     * @memberof UnifiedChatResponseItemV3
     */
    'date'?: string;
    /**
     * 
     * @type {QueryResult}
     * @memberof UnifiedChatResponseItemV3
     */
    'query'?: QueryResult;
}
/**
 * Complete unified chat response with adjustments
 * @export
 * @interface UnifiedChatResponseV2
 */
export interface UnifiedChatResponseV2 {
    /**
     * Direct answer to user question or summary of actions taken
     * @type {string}
     * @memberof UnifiedChatResponseV2
     */
    'chat_response'?: string;
    /**
     * Session identifier
     * @type {string}
     * @memberof UnifiedChatResponseV2
     */
    'session_id'?: string | null;
    /**
     * Array of adjustments for different dates
     * @type {Array<UnifiedChatResponseItem>}
     * @memberof UnifiedChatResponseV2
     */
    'unified_chat_responses'?: Array<UnifiedChatResponseItem>;
}
/**
 * v3 complete response. Strict superset of v2 — same `unified_chat_responses` structure with rich_context moved inside adjustment items or into `query`. 
 * @export
 * @interface UnifiedChatResponseV3
 */
export interface UnifiedChatResponseV3 {
    /**
     * Session identifier
     * @type {string}
     * @memberof UnifiedChatResponseV3
     */
    'session_id'?: string | null;
    /**
     * Array of per-date adjustments, sorted by date ascending
     * @type {Array<UnifiedChatResponseItemV3>}
     * @memberof UnifiedChatResponseV3
     */
    'unified_chat_responses'?: Array<UnifiedChatResponseItemV3>;
}
/**
 * 
 * @export
 * @interface WeatherSignalData
 */
export interface WeatherSignalData {
    /**
     * 
     * @type {string}
     * @memberof WeatherSignalData
     */
    'condition'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WeatherSignalData
     */
    'feels_like_c'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WeatherSignalData
     */
    'rain_probability'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WeatherSignalData
     */
    'temp_c'?: number | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof WeatherSignalData
     */
    'timeline'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof WeatherSignalData
     */
    'uv_index'?: number | null;
}
/**
 * 
 * @export
 * @interface WorkoutPlanPayload
 */
export interface WorkoutPlanPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof WorkoutPlanPayload
     */
    'difficulty'?: WorkoutPlanPayloadDifficultyEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkoutPlanPayload
     */
    'duration_min'?: number;
    /**
     * 
     * @type {Array<ExerciseItem>}
     * @memberof WorkoutPlanPayload
     */
    'exercises'?: Array<ExerciseItem>;
    /**
     * 
     * @type {Array<NearbyPlace>}
     * @memberof WorkoutPlanPayload
     */
    'nearby_places'?: Array<NearbyPlace> | null;
    /**
     * Suggested local end time for the workout. Can be HH:mm or ISO datetime.
     * @type {string}
     * @memberof WorkoutPlanPayload
     */
    'scheduled_end_time'?: string;
    /**
     * Suggested local start time for the workout. Can be HH:mm or ISO datetime.
     * @type {string}
     * @memberof WorkoutPlanPayload
     */
    'scheduled_start_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkoutPlanPayload
     */
    'plan_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkoutPlanPayload
     */
    'workout_type'?: WorkoutPlanPayloadWorkoutTypeEnum;
}

export const WorkoutPlanPayloadDifficultyEnum = {
    Beginner: 'beginner',
    Intermediate: 'intermediate',
    Advanced: 'advanced'
} as const;

export type WorkoutPlanPayloadDifficultyEnum = typeof WorkoutPlanPayloadDifficultyEnum[keyof typeof WorkoutPlanPayloadDifficultyEnum];
export const WorkoutPlanPayloadWorkoutTypeEnum = {
    Gym: 'gym',
    Running: 'running',
    Walking: 'walking',
    Cycling: 'cycling',
    Swimming: 'swimming',
    Rowing: 'rowing',
    Hiking: 'hiking',
    Yoga: 'yoga',
    Other: 'other'
} as const;

export type WorkoutPlanPayloadWorkoutTypeEnum = typeof WorkoutPlanPayloadWorkoutTypeEnum[keyof typeof WorkoutPlanPayloadWorkoutTypeEnum];


/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Provides conversational responses to user questions, with optional context from sleep, meal, and task recommendations. Use the chat_context parameter to explicitly focus the conversation on a specific domain, or omit it for general health advice.
         * @summary General chat assistant for contextual conversations about lifestack data
         * @param {GeneralChatRequest} generalChatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalChat: async (generalChatRequest: GeneralChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generalChatRequest' is not null or undefined
            assertParamExists('generalChat', 'generalChatRequest', generalChatRequest)
            const localVarPath = `/api/v1/chat/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analyzes user\'s current context (mood, energy, schedule, todos) and automatically schedules the best next activity in their calendar. Returns unified response with scheduled activities in adjustments.
         * @summary Intelligent \"what to do now\" assistant that schedules optimal next activities.
         * @param {RecommendationNowRequest} recommendationNowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationNow: async (recommendationNowRequest: RecommendationNowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationNowRequest' is not null or undefined
            assertParamExists('recommendationNow', 'recommendationNowRequest', recommendationNowRequest)
            const localVarPath = `/api/v1/recommendations/now`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recommendationNowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * Provides conversational responses to user questions, with optional context from sleep, meal, and task recommendations. Use the chat_context parameter to explicitly focus the conversation on a specific domain, or omit it for general health advice.
         * @summary General chat assistant for contextual conversations about lifestack data
         * @param {GeneralChatRequest} generalChatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalChat(generalChatRequest: GeneralChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralChat200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalChat(generalChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.generalChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Analyzes user\'s current context (mood, energy, schedule, todos) and automatically schedules the best next activity in their calendar. Returns unified response with scheduled activities in adjustments.
         * @summary Intelligent \"what to do now\" assistant that schedules optimal next activities.
         * @param {RecommendationNowRequest} recommendationNowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationNow(recommendationNowRequest: RecommendationNowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendationNow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationNow(recommendationNowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.recommendationNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantApiFp(configuration)
    return {
        /**
         * Provides conversational responses to user questions, with optional context from sleep, meal, and task recommendations. Use the chat_context parameter to explicitly focus the conversation on a specific domain, or omit it for general health advice.
         * @summary General chat assistant for contextual conversations about lifestack data
         * @param {GeneralChatRequest} generalChatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalChat(generalChatRequest: GeneralChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralChat200Response> {
            return localVarFp.generalChat(generalChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Analyzes user\'s current context (mood, energy, schedule, todos) and automatically schedules the best next activity in their calendar. Returns unified response with scheduled activities in adjustments.
         * @summary Intelligent \"what to do now\" assistant that schedules optimal next activities.
         * @param {RecommendationNowRequest} recommendationNowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationNow(recommendationNowRequest: RecommendationNowRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecommendationNow200Response> {
            return localVarFp.recommendationNow(recommendationNowRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
    /**
     * Provides conversational responses to user questions, with optional context from sleep, meal, and task recommendations. Use the chat_context parameter to explicitly focus the conversation on a specific domain, or omit it for general health advice.
     * @summary General chat assistant for contextual conversations about lifestack data
     * @param {GeneralChatRequest} generalChatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public generalChat(generalChatRequest: GeneralChatRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).generalChat(generalChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analyzes user\'s current context (mood, energy, schedule, todos) and automatically schedules the best next activity in their calendar. Returns unified response with scheduled activities in adjustments.
     * @summary Intelligent \"what to do now\" assistant that schedules optimal next activities.
     * @param {RecommendationNowRequest} recommendationNowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public recommendationNow(recommendationNowRequest: RecommendationNowRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).recommendationNow(recommendationNowRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatStreamingApi - axios parameter creator
 * @export
 */
export const ChatStreamingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Combined endpoint that creates a streaming chat session and immediately streams the AI response using Server-Sent Events (SSE). This endpoint combines the functionality of `/chat/start-session/v2` and `/chat/stream` into a single call.  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date` parameter to specify which scheduled date to discuss) 
         * @summary Create session and stream response in a single call
         * @param {EndToEndStreamingRequest} endToEndStreamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreaming: async (endToEndStreamingRequest: EndToEndStreamingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endToEndStreamingRequest' is not null or undefined
            assertParamExists('endToEndStreaming', 'endToEndStreamingRequest', endToEndStreamingRequest)
            const localVarPath = `/api/v1/chat/end_to_end_streaming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endToEndStreamingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * v2 streaming endpoint with pre-flight conflict detection and CTA enrichment. Compared to `/api/v1/chat/end_to_end_streaming`, this endpoint adds:  - Conflict detection before the LLM call (zero tokens). If a conflict is found,   a `question` SSE event is emitted and the stream ends without calling the LLM. - `hidden_context` support for CTA resolution (user taps an option and the   client posts the resolution payload).  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date`) - `recommendationNow`: Instant recommendation mode - `sleep`: Sleep advisor (context from MCP: schedule, sleep history, etc.) - `meal`: Meal timing advisor (context from MCP: schedule, meals, preferences) - `task`: Task timing advisor (context from MCP: tasks, schedule, energy zones; runs scheduler) 
         * @summary Create session and stream response in a single call (v2)
         * @param {EndToEndStreamingV2Request} endToEndStreamingV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreamingV2: async (endToEndStreamingV2Request: EndToEndStreamingV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endToEndStreamingV2Request' is not null or undefined
            assertParamExists('endToEndStreamingV2', 'endToEndStreamingV2Request', endToEndStreamingV2Request)
            const localVarPath = `/api/v1/chat/end_to_end_streaming/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endToEndStreamingV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * v3 streaming endpoint with intent pre-pass and rich_context output.  Compared to `/api/v1/chat/end_to_end_streaming/v2`, v3 adds:  - **Intent pre-pass** — `gpt-4o-mini` classifies `domain` and `action_type` (~200 tokens)   in parallel with memory fetch. The main agent receives the intent as a given instead of   self-classifying mid-generation. - **Signals + location/weather via MCP/App API** — `SignalBundle` is derived from MCP-fetched   App API context (Firebase source of truth). Location and weather snapshots are also fetched   via MCP (not Redis). - **Focused agent job** — Claude streams plain text + emits `adjustments` only.   Does NOT populate `content`, `nearby_places`, or `action` — the server builds those. - **rich_context** — each `unified_chat_responses` entry now includes a `rich_context`   field with `signals`, `content` (card), `action` (CTA button), and `reminder_min`.   Built deterministically server-side via `get_rich_context`; no extra LLM tokens.   Always non-null in v3 — two paths:   (a) **Adjustment path** (`build_rich_context_from_adjustments`): fires when the LLM       emitted any schedule/meals/todo_list/routine data. Derives timing and card content       from the adjustments themselves (e.g. meal reminder_min from start_time).   (b) **Query path** (`build_rich_context_from_query`): fires when there are no       adjustments (pure queries like \"suggest cafes around me\"). Builds content from       intent + signals + location only; `reminder_min` is always null. - **enrichment_patch SSE** — emitted when async skills (Google Places, OpenWeather) complete.   Frontend merges patches into existing cards in-place. - **signal_update SSE** — pushed when a wearable signal changes during the session   (e.g. energy zone transition). Frontend updates signal pills without re-fetching.  **Session Types:** Same as v2 — `freeText`, `scheduler_chat`, `recommendationNow`, `sleep`, `meal`, `task`.  **Backwards compatibility:** The v2 endpoint is untouched. v3 runs on the same session infrastructure (same session store, same MCP tools). Responses are a strict superset of v2 — `rich_context` is null in v2 responses and non-null in v3 responses.  **Token budget:** ~2,700 tokens cold / ~1,350 warm (vs v2 ~5,500+ / ~3,500+). 
         * @summary Create session and stream response in a single call (v3)
         * @param {EndToEndStreamingV3Request} endToEndStreamingV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreamingV3: async (endToEndStreamingV3Request: EndToEndStreamingV3Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endToEndStreamingV3Request' is not null or undefined
            assertParamExists('endToEndStreamingV3', 'endToEndStreamingV3Request', endToEndStreamingV3Request)
            const localVarPath = `/api/v1/chat/end_to_end_streaming/v3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endToEndStreamingV3Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new streaming chat session with comprehensive context data and returns a session ID for subsequent streaming interactions.  **Supported Session Types:** - **sleep**: Sleep optimization and schedule recommendations - **meal**: Meal timing and nutrition scheduling - **task**: Task scheduling and productivity optimization - **freeText**: General unified lifestyle optimization chat - **recommendationNow**: Recommendation now chat  **Workflow:** 1. Submit this request with user context and preferences 2. Receive a unique session ID for streaming 3. Use the session ID with `/chat/stream` for real-time responses 4. Session persists for continued conversation and context retention 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionRequest} startChatSessionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        startChatSession: async (startChatSessionRequest: StartChatSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startChatSessionRequest' is not null or undefined
            assertParamExists('startChatSession', 'startChatSessionRequest', startChatSessionRequest)
            const localVarPath = `/api/v1/chat/start-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startChatSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new streaming chat session by using direct id to fetch necessary context from Backend MCP Server. 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionV2Request} startChatSessionV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatSessionV2: async (startChatSessionV2Request: StartChatSessionV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startChatSessionV2Request' is not null or undefined
            assertParamExists('startChatSessionV2', 'startChatSessionV2Request', startChatSessionV2Request)
            const localVarPath = `/api/v1/chat/start-session/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startChatSessionV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams a comprehensive AI response for an existing session using Server-Sent Events (SSE). Provides real-time token-by-token text delivery followed by structured JSON results. 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier returned from &#x60;/chat/start-session/v2&#x60; endpoint.  **Format**: &#x60;environment:user_id:session_type:timestamp&#x60; - **environment**: Current deployment environment (development, staging, production) - **user_id**: Unique user identifier for personalization and memory - **session_type**: Type of optimization (sleep, meal, task, freeText, recommendationNow) - **timestamp**: Daily timestamp (YYYYMMDD) for session reuse within the same day  **Examples:** - &#x60;development:user_exec_001:sleep:20241225&#x60; - Sleep optimization session - &#x60;production:user_prof_002:meal:20241225&#x60; - Meal timing session - &#x60;development:user_dev_003:task:20241225&#x60; - Task scheduling session - &#x60;development:user_dev_004:recommendationNow:20241225&#x60; - Recommendation Now session 
         * @param {string} [prompt] Optional additional prompt to extend or modify the conversation within the same session.  **Use Cases:** - Add follow-up questions: \&quot;Can you also consider my gym schedule?\&quot; - Request specific adjustments: \&quot;Move my dinner earlier due to a late meeting\&quot; - Clarify preferences: \&quot;I prefer lighter meals before workouts\&quot; - Request alternative options: \&quot;What if I need to wake up 30 minutes earlier?\&quot;  **Note**: This prompt will be added to the existing session context, maintaining conversation continuity and user preferences. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamChatResponse: async (sessionId: string, prompt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('streamChatResponse', 'sessionId', sessionId)
            const localVarPath = `/api/v1/chat/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (prompt !== undefined) {
                localVarQueryParameter['prompt'] = prompt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatStreamingApi - functional programming interface
 * @export
 */
export const ChatStreamingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatStreamingApiAxiosParamCreator(configuration)
    return {
        /**
         * Combined endpoint that creates a streaming chat session and immediately streams the AI response using Server-Sent Events (SSE). This endpoint combines the functionality of `/chat/start-session/v2` and `/chat/stream` into a single call.  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date` parameter to specify which scheduled date to discuss) 
         * @summary Create session and stream response in a single call
         * @param {EndToEndStreamingRequest} endToEndStreamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endToEndStreaming(endToEndStreamingRequest: EndToEndStreamingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endToEndStreaming(endToEndStreamingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.endToEndStreaming']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * v2 streaming endpoint with pre-flight conflict detection and CTA enrichment. Compared to `/api/v1/chat/end_to_end_streaming`, this endpoint adds:  - Conflict detection before the LLM call (zero tokens). If a conflict is found,   a `question` SSE event is emitted and the stream ends without calling the LLM. - `hidden_context` support for CTA resolution (user taps an option and the   client posts the resolution payload).  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date`) - `recommendationNow`: Instant recommendation mode - `sleep`: Sleep advisor (context from MCP: schedule, sleep history, etc.) - `meal`: Meal timing advisor (context from MCP: schedule, meals, preferences) - `task`: Task timing advisor (context from MCP: tasks, schedule, energy zones; runs scheduler) 
         * @summary Create session and stream response in a single call (v2)
         * @param {EndToEndStreamingV2Request} endToEndStreamingV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endToEndStreamingV2(endToEndStreamingV2Request: EndToEndStreamingV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endToEndStreamingV2(endToEndStreamingV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.endToEndStreamingV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * v3 streaming endpoint with intent pre-pass and rich_context output.  Compared to `/api/v1/chat/end_to_end_streaming/v2`, v3 adds:  - **Intent pre-pass** — `gpt-4o-mini` classifies `domain` and `action_type` (~200 tokens)   in parallel with memory fetch. The main agent receives the intent as a given instead of   self-classifying mid-generation. - **Signals + location/weather via MCP/App API** — `SignalBundle` is derived from MCP-fetched   App API context (Firebase source of truth). Location and weather snapshots are also fetched   via MCP (not Redis). - **Focused agent job** — Claude streams plain text + emits `adjustments` only.   Does NOT populate `content`, `nearby_places`, or `action` — the server builds those. - **rich_context** — each `unified_chat_responses` entry now includes a `rich_context`   field with `signals`, `content` (card), `action` (CTA button), and `reminder_min`.   Built deterministically server-side via `get_rich_context`; no extra LLM tokens.   Always non-null in v3 — two paths:   (a) **Adjustment path** (`build_rich_context_from_adjustments`): fires when the LLM       emitted any schedule/meals/todo_list/routine data. Derives timing and card content       from the adjustments themselves (e.g. meal reminder_min from start_time).   (b) **Query path** (`build_rich_context_from_query`): fires when there are no       adjustments (pure queries like \"suggest cafes around me\"). Builds content from       intent + signals + location only; `reminder_min` is always null. - **enrichment_patch SSE** — emitted when async skills (Google Places, OpenWeather) complete.   Frontend merges patches into existing cards in-place. - **signal_update SSE** — pushed when a wearable signal changes during the session   (e.g. energy zone transition). Frontend updates signal pills without re-fetching.  **Session Types:** Same as v2 — `freeText`, `scheduler_chat`, `recommendationNow`, `sleep`, `meal`, `task`.  **Backwards compatibility:** The v2 endpoint is untouched. v3 runs on the same session infrastructure (same session store, same MCP tools). Responses are a strict superset of v2 — `rich_context` is null in v2 responses and non-null in v3 responses.  **Token budget:** ~2,700 tokens cold / ~1,350 warm (vs v2 ~5,500+ / ~3,500+). 
         * @summary Create session and stream response in a single call (v3)
         * @param {EndToEndStreamingV3Request} endToEndStreamingV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endToEndStreamingV3(endToEndStreamingV3Request: EndToEndStreamingV3Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endToEndStreamingV3(endToEndStreamingV3Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.endToEndStreamingV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new streaming chat session with comprehensive context data and returns a session ID for subsequent streaming interactions.  **Supported Session Types:** - **sleep**: Sleep optimization and schedule recommendations - **meal**: Meal timing and nutrition scheduling - **task**: Task scheduling and productivity optimization - **freeText**: General unified lifestyle optimization chat - **recommendationNow**: Recommendation now chat  **Workflow:** 1. Submit this request with user context and preferences 2. Receive a unique session ID for streaming 3. Use the session ID with `/chat/stream` for real-time responses 4. Session persists for continued conversation and context retention 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionRequest} startChatSessionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async startChatSession(startChatSessionRequest: StartChatSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartChatSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatSession(startChatSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.startChatSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new streaming chat session by using direct id to fetch necessary context from Backend MCP Server. 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionV2Request} startChatSessionV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatSessionV2(startChatSessionV2Request: StartChatSessionV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartChatSessionV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatSessionV2(startChatSessionV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.startChatSessionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streams a comprehensive AI response for an existing session using Server-Sent Events (SSE). Provides real-time token-by-token text delivery followed by structured JSON results. 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier returned from &#x60;/chat/start-session/v2&#x60; endpoint.  **Format**: &#x60;environment:user_id:session_type:timestamp&#x60; - **environment**: Current deployment environment (development, staging, production) - **user_id**: Unique user identifier for personalization and memory - **session_type**: Type of optimization (sleep, meal, task, freeText, recommendationNow) - **timestamp**: Daily timestamp (YYYYMMDD) for session reuse within the same day  **Examples:** - &#x60;development:user_exec_001:sleep:20241225&#x60; - Sleep optimization session - &#x60;production:user_prof_002:meal:20241225&#x60; - Meal timing session - &#x60;development:user_dev_003:task:20241225&#x60; - Task scheduling session - &#x60;development:user_dev_004:recommendationNow:20241225&#x60; - Recommendation Now session 
         * @param {string} [prompt] Optional additional prompt to extend or modify the conversation within the same session.  **Use Cases:** - Add follow-up questions: \&quot;Can you also consider my gym schedule?\&quot; - Request specific adjustments: \&quot;Move my dinner earlier due to a late meeting\&quot; - Clarify preferences: \&quot;I prefer lighter meals before workouts\&quot; - Request alternative options: \&quot;What if I need to wake up 30 minutes earlier?\&quot;  **Note**: This prompt will be added to the existing session context, maintaining conversation continuity and user preferences. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamChatResponse(sessionId, prompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatStreamingApi.streamChatResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatStreamingApi - factory interface
 * @export
 */
export const ChatStreamingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatStreamingApiFp(configuration)
    return {
        /**
         * Combined endpoint that creates a streaming chat session and immediately streams the AI response using Server-Sent Events (SSE). This endpoint combines the functionality of `/chat/start-session/v2` and `/chat/stream` into a single call.  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date` parameter to specify which scheduled date to discuss) 
         * @summary Create session and stream response in a single call
         * @param {EndToEndStreamingRequest} endToEndStreamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreaming(endToEndStreamingRequest: EndToEndStreamingRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.endToEndStreaming(endToEndStreamingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * v2 streaming endpoint with pre-flight conflict detection and CTA enrichment. Compared to `/api/v1/chat/end_to_end_streaming`, this endpoint adds:  - Conflict detection before the LLM call (zero tokens). If a conflict is found,   a `question` SSE event is emitted and the stream ends without calling the LLM. - `hidden_context` support for CTA resolution (user taps an option and the   client posts the resolution payload).  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date`) - `recommendationNow`: Instant recommendation mode - `sleep`: Sleep advisor (context from MCP: schedule, sleep history, etc.) - `meal`: Meal timing advisor (context from MCP: schedule, meals, preferences) - `task`: Task timing advisor (context from MCP: tasks, schedule, energy zones; runs scheduler) 
         * @summary Create session and stream response in a single call (v2)
         * @param {EndToEndStreamingV2Request} endToEndStreamingV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreamingV2(endToEndStreamingV2Request: EndToEndStreamingV2Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.endToEndStreamingV2(endToEndStreamingV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * v3 streaming endpoint with intent pre-pass and rich_context output.  Compared to `/api/v1/chat/end_to_end_streaming/v2`, v3 adds:  - **Intent pre-pass** — `gpt-4o-mini` classifies `domain` and `action_type` (~200 tokens)   in parallel with memory fetch. The main agent receives the intent as a given instead of   self-classifying mid-generation. - **Signals + location/weather via MCP/App API** — `SignalBundle` is derived from MCP-fetched   App API context (Firebase source of truth). Location and weather snapshots are also fetched   via MCP (not Redis). - **Focused agent job** — Claude streams plain text + emits `adjustments` only.   Does NOT populate `content`, `nearby_places`, or `action` — the server builds those. - **rich_context** — each `unified_chat_responses` entry now includes a `rich_context`   field with `signals`, `content` (card), `action` (CTA button), and `reminder_min`.   Built deterministically server-side via `get_rich_context`; no extra LLM tokens.   Always non-null in v3 — two paths:   (a) **Adjustment path** (`build_rich_context_from_adjustments`): fires when the LLM       emitted any schedule/meals/todo_list/routine data. Derives timing and card content       from the adjustments themselves (e.g. meal reminder_min from start_time).   (b) **Query path** (`build_rich_context_from_query`): fires when there are no       adjustments (pure queries like \"suggest cafes around me\"). Builds content from       intent + signals + location only; `reminder_min` is always null. - **enrichment_patch SSE** — emitted when async skills (Google Places, OpenWeather) complete.   Frontend merges patches into existing cards in-place. - **signal_update SSE** — pushed when a wearable signal changes during the session   (e.g. energy zone transition). Frontend updates signal pills without re-fetching.  **Session Types:** Same as v2 — `freeText`, `scheduler_chat`, `recommendationNow`, `sleep`, `meal`, `task`.  **Backwards compatibility:** The v2 endpoint is untouched. v3 runs on the same session infrastructure (same session store, same MCP tools). Responses are a strict superset of v2 — `rich_context` is null in v2 responses and non-null in v3 responses.  **Token budget:** ~2,700 tokens cold / ~1,350 warm (vs v2 ~5,500+ / ~3,500+). 
         * @summary Create session and stream response in a single call (v3)
         * @param {EndToEndStreamingV3Request} endToEndStreamingV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endToEndStreamingV3(endToEndStreamingV3Request: EndToEndStreamingV3Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.endToEndStreamingV3(endToEndStreamingV3Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new streaming chat session with comprehensive context data and returns a session ID for subsequent streaming interactions.  **Supported Session Types:** - **sleep**: Sleep optimization and schedule recommendations - **meal**: Meal timing and nutrition scheduling - **task**: Task scheduling and productivity optimization - **freeText**: General unified lifestyle optimization chat - **recommendationNow**: Recommendation now chat  **Workflow:** 1. Submit this request with user context and preferences 2. Receive a unique session ID for streaming 3. Use the session ID with `/chat/stream` for real-time responses 4. Session persists for continued conversation and context retention 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionRequest} startChatSessionRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        startChatSession(startChatSessionRequest: StartChatSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartChatSession200Response> {
            return localVarFp.startChatSession(startChatSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new streaming chat session by using direct id to fetch necessary context from Backend MCP Server. 
         * @summary Initialize a new streaming chat session
         * @param {StartChatSessionV2Request} startChatSessionV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatSessionV2(startChatSessionV2Request: StartChatSessionV2Request, options?: RawAxiosRequestConfig): AxiosPromise<StartChatSessionV2200Response> {
            return localVarFp.startChatSessionV2(startChatSessionV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Streams a comprehensive AI response for an existing session using Server-Sent Events (SSE). Provides real-time token-by-token text delivery followed by structured JSON results. 
         * @summary Stream real-time chat responses using Server-Sent Events
         * @param {string} sessionId Unique session identifier returned from &#x60;/chat/start-session/v2&#x60; endpoint.  **Format**: &#x60;environment:user_id:session_type:timestamp&#x60; - **environment**: Current deployment environment (development, staging, production) - **user_id**: Unique user identifier for personalization and memory - **session_type**: Type of optimization (sleep, meal, task, freeText, recommendationNow) - **timestamp**: Daily timestamp (YYYYMMDD) for session reuse within the same day  **Examples:** - &#x60;development:user_exec_001:sleep:20241225&#x60; - Sleep optimization session - &#x60;production:user_prof_002:meal:20241225&#x60; - Meal timing session - &#x60;development:user_dev_003:task:20241225&#x60; - Task scheduling session - &#x60;development:user_dev_004:recommendationNow:20241225&#x60; - Recommendation Now session 
         * @param {string} [prompt] Optional additional prompt to extend or modify the conversation within the same session.  **Use Cases:** - Add follow-up questions: \&quot;Can you also consider my gym schedule?\&quot; - Request specific adjustments: \&quot;Move my dinner earlier due to a late meeting\&quot; - Clarify preferences: \&quot;I prefer lighter meals before workouts\&quot; - Request alternative options: \&quot;What if I need to wake up 30 minutes earlier?\&quot;  **Note**: This prompt will be added to the existing session context, maintaining conversation continuity and user preferences. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.streamChatResponse(sessionId, prompt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatStreamingApi - object-oriented interface
 * @export
 * @class ChatStreamingApi
 * @extends {BaseAPI}
 */
export class ChatStreamingApi extends BaseAPI {
    /**
     * Combined endpoint that creates a streaming chat session and immediately streams the AI response using Server-Sent Events (SSE). This endpoint combines the functionality of `/chat/start-session/v2` and `/chat/stream` into a single call.  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date` parameter to specify which scheduled date to discuss) 
     * @summary Create session and stream response in a single call
     * @param {EndToEndStreamingRequest} endToEndStreamingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public endToEndStreaming(endToEndStreamingRequest: EndToEndStreamingRequest, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).endToEndStreaming(endToEndStreamingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * v2 streaming endpoint with pre-flight conflict detection and CTA enrichment. Compared to `/api/v1/chat/end_to_end_streaming`, this endpoint adds:  - Conflict detection before the LLM call (zero tokens). If a conflict is found,   a `question` SSE event is emitted and the stream ends without calling the LLM. - `hidden_context` support for CTA resolution (user taps an option and the   client posts the resolution payload).  **Session Types:** - `freeText`: General lifestyle optimization chat - `scheduler_chat`: Chat about a previously generated schedule (requires `date`) - `recommendationNow`: Instant recommendation mode - `sleep`: Sleep advisor (context from MCP: schedule, sleep history, etc.) - `meal`: Meal timing advisor (context from MCP: schedule, meals, preferences) - `task`: Task timing advisor (context from MCP: tasks, schedule, energy zones; runs scheduler) 
     * @summary Create session and stream response in a single call (v2)
     * @param {EndToEndStreamingV2Request} endToEndStreamingV2Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public endToEndStreamingV2(endToEndStreamingV2Request: EndToEndStreamingV2Request, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).endToEndStreamingV2(endToEndStreamingV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * v3 streaming endpoint with intent pre-pass and rich_context output.  Compared to `/api/v1/chat/end_to_end_streaming/v2`, v3 adds:  - **Intent pre-pass** — `gpt-4o-mini` classifies `domain` and `action_type` (~200 tokens)   in parallel with memory fetch. The main agent receives the intent as a given instead of   self-classifying mid-generation. - **Signals + location/weather via MCP/App API** — `SignalBundle` is derived from MCP-fetched   App API context (Firebase source of truth). Location and weather snapshots are also fetched   via MCP (not Redis). - **Focused agent job** — Claude streams plain text + emits `adjustments` only.   Does NOT populate `content`, `nearby_places`, or `action` — the server builds those. - **rich_context** — each `unified_chat_responses` entry now includes a `rich_context`   field with `signals`, `content` (card), `action` (CTA button), and `reminder_min`.   Built deterministically server-side via `get_rich_context`; no extra LLM tokens.   Always non-null in v3 — two paths:   (a) **Adjustment path** (`build_rich_context_from_adjustments`): fires when the LLM       emitted any schedule/meals/todo_list/routine data. Derives timing and card content       from the adjustments themselves (e.g. meal reminder_min from start_time).   (b) **Query path** (`build_rich_context_from_query`): fires when there are no       adjustments (pure queries like \"suggest cafes around me\"). Builds content from       intent + signals + location only; `reminder_min` is always null. - **enrichment_patch SSE** — emitted when async skills (Google Places, OpenWeather) complete.   Frontend merges patches into existing cards in-place. - **signal_update SSE** — pushed when a wearable signal changes during the session   (e.g. energy zone transition). Frontend updates signal pills without re-fetching.  **Session Types:** Same as v2 — `freeText`, `scheduler_chat`, `recommendationNow`, `sleep`, `meal`, `task`.  **Backwards compatibility:** The v2 endpoint is untouched. v3 runs on the same session infrastructure (same session store, same MCP tools). Responses are a strict superset of v2 — `rich_context` is null in v2 responses and non-null in v3 responses.  **Token budget:** ~2,700 tokens cold / ~1,350 warm (vs v2 ~5,500+ / ~3,500+). 
     * @summary Create session and stream response in a single call (v3)
     * @param {EndToEndStreamingV3Request} endToEndStreamingV3Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public endToEndStreamingV3(endToEndStreamingV3Request: EndToEndStreamingV3Request, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).endToEndStreamingV3(endToEndStreamingV3Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new streaming chat session with comprehensive context data and returns a session ID for subsequent streaming interactions.  **Supported Session Types:** - **sleep**: Sleep optimization and schedule recommendations - **meal**: Meal timing and nutrition scheduling - **task**: Task scheduling and productivity optimization - **freeText**: General unified lifestyle optimization chat - **recommendationNow**: Recommendation now chat  **Workflow:** 1. Submit this request with user context and preferences 2. Receive a unique session ID for streaming 3. Use the session ID with `/chat/stream` for real-time responses 4. Session persists for continued conversation and context retention 
     * @summary Initialize a new streaming chat session
     * @param {StartChatSessionRequest} startChatSessionRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public startChatSession(startChatSessionRequest: StartChatSessionRequest, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).startChatSession(startChatSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new streaming chat session by using direct id to fetch necessary context from Backend MCP Server. 
     * @summary Initialize a new streaming chat session
     * @param {StartChatSessionV2Request} startChatSessionV2Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public startChatSessionV2(startChatSessionV2Request: StartChatSessionV2Request, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).startChatSessionV2(startChatSessionV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streams a comprehensive AI response for an existing session using Server-Sent Events (SSE). Provides real-time token-by-token text delivery followed by structured JSON results. 
     * @summary Stream real-time chat responses using Server-Sent Events
     * @param {string} sessionId Unique session identifier returned from &#x60;/chat/start-session/v2&#x60; endpoint.  **Format**: &#x60;environment:user_id:session_type:timestamp&#x60; - **environment**: Current deployment environment (development, staging, production) - **user_id**: Unique user identifier for personalization and memory - **session_type**: Type of optimization (sleep, meal, task, freeText, recommendationNow) - **timestamp**: Daily timestamp (YYYYMMDD) for session reuse within the same day  **Examples:** - &#x60;development:user_exec_001:sleep:20241225&#x60; - Sleep optimization session - &#x60;production:user_prof_002:meal:20241225&#x60; - Meal timing session - &#x60;development:user_dev_003:task:20241225&#x60; - Task scheduling session - &#x60;development:user_dev_004:recommendationNow:20241225&#x60; - Recommendation Now session 
     * @param {string} [prompt] Optional additional prompt to extend or modify the conversation within the same session.  **Use Cases:** - Add follow-up questions: \&quot;Can you also consider my gym schedule?\&quot; - Request specific adjustments: \&quot;Move my dinner earlier due to a late meeting\&quot; - Clarify preferences: \&quot;I prefer lighter meals before workouts\&quot; - Request alternative options: \&quot;What if I need to wake up 30 minutes earlier?\&quot;  **Note**: This prompt will be added to the existing session context, maintaining conversation continuity and user preferences. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatStreamingApi
     */
    public streamChatResponse(sessionId: string, prompt?: string, options?: RawAxiosRequestConfig) {
        return ChatStreamingApiFp(this.configuration).streamChatResponse(sessionId, prompt, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CircadianApi - axios parameter creator
 * @export
 */
export const CircadianApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Combine energy EMA curve.
         * @param {CombineEnergyEMARequest} combineEnergyEMARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineEnergyEMA: async (combineEnergyEMARequest: CombineEnergyEMARequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'combineEnergyEMARequest' is not null or undefined
            assertParamExists('combineEnergyEMA', 'combineEnergyEMARequest', combineEnergyEMARequest)
            const localVarPath = `/api/v1/circadian/combine_energy_ema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(combineEnergyEMARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate Circadian Sine Wave (V2_1_2).
         * @param {GetCircadianSineWaveV212Request} getCircadianSineWaveV212Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircadianSineWaveV212: async (getCircadianSineWaveV212Request: GetCircadianSineWaveV212Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCircadianSineWaveV212Request' is not null or undefined
            assertParamExists('getCircadianSineWaveV212', 'getCircadianSineWaveV212Request', getCircadianSineWaveV212Request)
            const localVarPath = `/api/v1/circadian/v2_1_2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCircadianSineWaveV212Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smooth energy curve.
         * @param {SmoothEnergyCurveRequest} smoothEnergyCurveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smoothEnergyCurve: async (smoothEnergyCurveRequest: SmoothEnergyCurveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smoothEnergyCurveRequest' is not null or undefined
            assertParamExists('smoothEnergyCurve', 'smoothEnergyCurveRequest', smoothEnergyCurveRequest)
            const localVarPath = `/api/v1/circadian/smooth_curve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smoothEnergyCurveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CircadianApi - functional programming interface
 * @export
 */
export const CircadianApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CircadianApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Combine energy EMA curve.
         * @param {CombineEnergyEMARequest} combineEnergyEMARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async combineEnergyEMA(combineEnergyEMARequest: CombineEnergyEMARequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CombineEnergyEMA200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.combineEnergyEMA(combineEnergyEMARequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CircadianApi.combineEnergyEMA']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate Circadian Sine Wave (V2_1_2).
         * @param {GetCircadianSineWaveV212Request} getCircadianSineWaveV212Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCircadianSineWaveV212(getCircadianSineWaveV212Request: GetCircadianSineWaveV212Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCircadianSineWaveV212(getCircadianSineWaveV212Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CircadianApi.getCircadianSineWaveV212']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smooth energy curve.
         * @param {SmoothEnergyCurveRequest} smoothEnergyCurveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smoothEnergyCurve(smoothEnergyCurveRequest: SmoothEnergyCurveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smoothEnergyCurve(smoothEnergyCurveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CircadianApi.smoothEnergyCurve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CircadianApi - factory interface
 * @export
 */
export const CircadianApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CircadianApiFp(configuration)
    return {
        /**
         * 
         * @summary Combine energy EMA curve.
         * @param {CombineEnergyEMARequest} combineEnergyEMARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineEnergyEMA(combineEnergyEMARequest: CombineEnergyEMARequest, options?: RawAxiosRequestConfig): AxiosPromise<CombineEnergyEMA200Response> {
            return localVarFp.combineEnergyEMA(combineEnergyEMARequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate Circadian Sine Wave (V2_1_2).
         * @param {GetCircadianSineWaveV212Request} getCircadianSineWaveV212Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircadianSineWaveV212(getCircadianSineWaveV212Request: GetCircadianSineWaveV212Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getCircadianSineWaveV212(getCircadianSineWaveV212Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smooth energy curve.
         * @param {SmoothEnergyCurveRequest} smoothEnergyCurveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smoothEnergyCurve(smoothEnergyCurveRequest: SmoothEnergyCurveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.smoothEnergyCurve(smoothEnergyCurveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CircadianApi - object-oriented interface
 * @export
 * @class CircadianApi
 * @extends {BaseAPI}
 */
export class CircadianApi extends BaseAPI {
    /**
     * 
     * @summary Combine energy EMA curve.
     * @param {CombineEnergyEMARequest} combineEnergyEMARequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircadianApi
     */
    public combineEnergyEMA(combineEnergyEMARequest: CombineEnergyEMARequest, options?: RawAxiosRequestConfig) {
        return CircadianApiFp(this.configuration).combineEnergyEMA(combineEnergyEMARequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate Circadian Sine Wave (V2_1_2).
     * @param {GetCircadianSineWaveV212Request} getCircadianSineWaveV212Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircadianApi
     */
    public getCircadianSineWaveV212(getCircadianSineWaveV212Request: GetCircadianSineWaveV212Request, options?: RawAxiosRequestConfig) {
        return CircadianApiFp(this.configuration).getCircadianSineWaveV212(getCircadianSineWaveV212Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smooth energy curve.
     * @param {SmoothEnergyCurveRequest} smoothEnergyCurveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircadianApi
     */
    public smoothEnergyCurve(smoothEnergyCurveRequest: SmoothEnergyCurveRequest, options?: RawAxiosRequestConfig) {
        return CircadianApiFp(this.configuration).smoothEnergyCurve(smoothEnergyCurveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MealsApi - axios parameter creator
 * @export
 */
export const MealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Analyzes sleep/wake patterns and calendar events to provide personalized meal timing recommendations (breakfast, lunch, dinner) using Huberman\'s protocols. Automatically resolves calendar conflicts and provides explanations.
         * @summary Generate optimal meal timing recommendations based on circadian rhythm and calendar constraints
         * @param {GenerateIdealMealsRequest} generateIdealMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateIdealMeals: async (generateIdealMealsRequest: GenerateIdealMealsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateIdealMealsRequest' is not null or undefined
            assertParamExists('generateIdealMeals', 'generateIdealMealsRequest', generateIdealMealsRequest)
            const localVarPath = `/api/v1/meals/ideal_meals/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateIdealMealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MealsApi - functional programming interface
 * @export
 */
export const MealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MealsApiAxiosParamCreator(configuration)
    return {
        /**
         * Analyzes sleep/wake patterns and calendar events to provide personalized meal timing recommendations (breakfast, lunch, dinner) using Huberman\'s protocols. Automatically resolves calendar conflicts and provides explanations.
         * @summary Generate optimal meal timing recommendations based on circadian rhythm and calendar constraints
         * @param {GenerateIdealMealsRequest} generateIdealMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateIdealMeals(generateIdealMealsRequest: GenerateIdealMealsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateIdealMeals200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateIdealMeals(generateIdealMealsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MealsApi.generateIdealMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MealsApi - factory interface
 * @export
 */
export const MealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MealsApiFp(configuration)
    return {
        /**
         * Analyzes sleep/wake patterns and calendar events to provide personalized meal timing recommendations (breakfast, lunch, dinner) using Huberman\'s protocols. Automatically resolves calendar conflicts and provides explanations.
         * @summary Generate optimal meal timing recommendations based on circadian rhythm and calendar constraints
         * @param {GenerateIdealMealsRequest} generateIdealMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateIdealMeals(generateIdealMealsRequest: GenerateIdealMealsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateIdealMeals200Response> {
            return localVarFp.generateIdealMeals(generateIdealMealsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MealsApi - object-oriented interface
 * @export
 * @class MealsApi
 * @extends {BaseAPI}
 */
export class MealsApi extends BaseAPI {
    /**
     * Analyzes sleep/wake patterns and calendar events to provide personalized meal timing recommendations (breakfast, lunch, dinner) using Huberman\'s protocols. Automatically resolves calendar conflicts and provides explanations.
     * @summary Generate optimal meal timing recommendations based on circadian rhythm and calendar constraints
     * @param {GenerateIdealMealsRequest} generateIdealMealsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealsApi
     */
    public generateIdealMeals(generateIdealMealsRequest: GenerateIdealMealsRequest, options?: RawAxiosRequestConfig) {
        return MealsApiFp(this.configuration).generateIdealMeals(generateIdealMealsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint uses an LLM agent to adjust or generate a schedule based on user input, chat history, and current schedule state. It supports iterative, chat-based schedule refinement. 
         * @summary Agentic AI Scheduler
         * @param {GenerateAISchedulerAgentRequest} generateAISchedulerAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateAISchedulerAgent: async (generateAISchedulerAgentRequest: GenerateAISchedulerAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAISchedulerAgentRequest' is not null or undefined
            assertParamExists('generateAISchedulerAgent', 'generateAISchedulerAgentRequest', generateAISchedulerAgentRequest)
            const localVarPath = `/api/v1/scheduler/ai_scheduler_agent/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAISchedulerAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint uses Claude Agent SDK to generate a comprehensive daily plan. It loads context from MCP servers (calendar events, tasks, energy zones, sleep patterns, etc.) and uses Claude Agent SDK with MCP integration to create an optimal schedule considering: 1. No scheduling conflicts with existing calendar events 2. Maximum todo list integration (prioritizing by priority value) 3. Work-life balance (user preferences and scheduler rules) 4. Energy and sleep scores for optimal timing  The endpoint automatically routes to either Claude Agent SDK (for complex requests) or a simple scheduler (for simpler requests) based on complexity analysis. The routing decision is included in the response.  All request fields except `user_id` are optional and have defaults. 
         * @summary Generate Daily Plan with Claude Agent SDK
         * @param {GenerateDailyPlanClaudeAgentRequest} generateDailyPlanClaudeAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateDailyPlanClaudeAgent: async (generateDailyPlanClaudeAgentRequest: GenerateDailyPlanClaudeAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateDailyPlanClaudeAgentRequest' is not null or undefined
            assertParamExists('generateDailyPlanClaudeAgent', 'generateDailyPlanClaudeAgentRequest', generateDailyPlanClaudeAgentRequest)
            const localVarPath = `/api/v1/scheduler/daily_plan_claude_agent/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDailyPlanClaudeAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streaming version of the daily plan generation endpoint. Returns Server-Sent Events (SSE) with progress updates and final result.  Event types: - status_text: User-facing progress updates - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Status messages: 1. \"Preparing your schedule...\" - Initial setup 2. \"Creating your optimal day plan...\" - Main processing 3. \"Finalizing your schedule...\" - Final processing 
         * @summary Generate Daily Plan with Claude Agent SDK (Streaming)
         * @param {GenerateDailyPlanClaudeAgentStreamingRequest} generateDailyPlanClaudeAgentStreamingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateDailyPlanClaudeAgentStreaming: async (generateDailyPlanClaudeAgentStreamingRequest: GenerateDailyPlanClaudeAgentStreamingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateDailyPlanClaudeAgentStreamingRequest' is not null or undefined
            assertParamExists('generateDailyPlanClaudeAgentStreaming', 'generateDailyPlanClaudeAgentStreamingRequest', generateDailyPlanClaudeAgentStreamingRequest)
            const localVarPath = `/api/v1/scheduler/daily_plan_claude_agent/generate_streaming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDailyPlanClaudeAgentStreamingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * v2 daily plan endpoint. Supports both streaming (SSE) and non-streaming (JSON) modes via the `streaming` field.  When `streaming: true`, emits per-item plan events: - status_text: User-facing progress updates - plan_action: Per-item scheduling decision - plan_done: Final per-item summary (scheduled/skipped counts) - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  When `streaming: false` (or omitted), returns a plain JSON response. 
         * @summary Generate Daily Plan v2
         * @param {GenerateDailyPlanV2Request} generateDailyPlanV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV2: async (generateDailyPlanV2Request: GenerateDailyPlanV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateDailyPlanV2Request' is not null or undefined
            assertParamExists('generateDailyPlanV2', 'generateDailyPlanV2Request', generateDailyPlanV2Request)
            const localVarPath = `/api/v1/scheduler/daily_plan/generate/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDailyPlanV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * v3 daily plan endpoint.  Replaces the single large Claude agent call (v2) with a 3-phase pipeline:  **Phase 1 — Slot Finder** (pure Python, zero AI tokens) Parses existing calendar events, merges busy blocks expanded by buffer_mins, and returns free slots.  **Phase 2 — Anchor Planner** (one small Claude call) Places Breakfast, Lunch, Dinner, and Sleep anchors into available slots.  **Phase 3a — Task Placer** (pure Python, energy-aware bin-packing) Schedules tasks and routines into remaining slots, preferring peak energy zones for high-priority deep-work items.  **Phase 3b — Content Enricher** (concurrent Claude micro-calls) Adds a one-sentence explanation to each event. Meal, sleep, and workout events receive a rich_context card (same builder as chat_streaming_v3) with enrichment_pending=True. plan_action SSE events are emitted progressively as each item completes — the client sees the plan being built in real time.  SSE event sequence: - status_text: User-facing progress updates (one per pipeline phase) - plan_action: Emitted progressively per item as enrichment completes - plan_done: Final summary with scheduled/skipped counts - result_json: Complete schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Request body is identical to v2.  Pass `streaming: true` to receive an SSE stream. Pass `streaming: false` (or omit) to receive a plain JSON response. 
         * @summary Generate Daily Plan v3
         * @param {GenerateDailyPlanV3Request} generateDailyPlanV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV3: async (generateDailyPlanV3Request: GenerateDailyPlanV3Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateDailyPlanV3Request' is not null or undefined
            assertParamExists('generateDailyPlanV3', 'generateDailyPlanV3Request', generateDailyPlanV3Request)
            const localVarPath = `/api/v1/scheduler/daily_plan/generate/v3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDailyPlanV3Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight onboarding-only daily plan stream.  This endpoint preserves the v3 SSE contract while skipping full daily planning. It fetches only: - get_sleep - get_preferences  Then emits mocked onboarding items: - Tasks: \"Check out the lifestack web app\" - Routine: \"Nap\" - Sleep/meal anchors  SSE event sequence: - status_text - plan_action - plan_done - result_json - stream_end 
         * @summary Generate Daily Plan v3 Mock
         * @param {GenerateDailyPlanV3MockRequest} generateDailyPlanV3MockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV3Mock: async (generateDailyPlanV3MockRequest: GenerateDailyPlanV3MockRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateDailyPlanV3MockRequest' is not null or undefined
            assertParamExists('generateDailyPlanV3Mock', 'generateDailyPlanV3MockRequest', generateDailyPlanV3MockRequest)
            const localVarPath = `/api/v1/scheduler/daily_plan/generate/v3/mock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDailyPlanV3MockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find the best time to place a single routine activity while avoiding existing calendar events. If an earliest/latest window is provided, the activity is scheduled within that window and shortened to fit if necessary. If no window is provided, the scheduler favors matching energy zones based on category/effect, then falls back to the first open slot. 
         * @summary Generate timing for a routine activity
         * @param {GenerateRoutineTimingRequest} generateRoutineTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoutineTiming: async (generateRoutineTimingRequest: GenerateRoutineTimingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateRoutineTimingRequest' is not null or undefined
            assertParamExists('generateRoutineTiming', 'generateRoutineTimingRequest', generateRoutineTimingRequest)
            const localVarPath = `/api/v1/scheduler/routine_timing/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateRoutineTimingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analyzes todos and energy patterns to suggest optimal timing for tasks without timeboxing constraints. Uses energy-aware scheduling with LLM-powered insights. Tasks are automatically categorized using AI if no category is provided.
         * @summary Find the best time for tasks
         * @param {GenerateTaskTimingRequest} generateTaskTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTaskTiming: async (generateTaskTimingRequest: GenerateTaskTimingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTaskTimingRequest' is not null or undefined
            assertParamExists('generateTaskTiming', 'generateTaskTimingRequest', generateTaskTimingRequest)
            const localVarPath = `/api/v1/scheduler/task_timing/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTaskTimingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a complete weekly plan as a Server-Sent Events (SSE) stream. Tasks are pre-allocated across the requested days before planning begins, so each Claude call receives only the subset of tasks assigned to that day. Routines are passed to every day since they recur daily.  Event flow: 1. `status_text`   — \"Preparing your weekly plan...\" (once at the start) 2. Per day (repeated for each day):    a. `status_text`  — \"Planning {DayName} (N/M)...\"    b. `day_start`    — emitted before each day is planned    c. `day_complete` — emitted after each day is planned (includes events or error) 3. `status_text`   — \"Finalizing your weekly plan...\" (before final summary) 4. `week_complete` — emitted once all days are done (summary counts)  SSE event payloads:  **day_start** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"total_days\": 5,   \"current_index\": 0 } ```  **day_complete** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"events\": [...],   \"summary\": \"Planned Monday with 6 scheduled item(s).\",   \"suggestions\": [],   \"error\": null } ```  **week_complete** ```json {   \"week_start\": \"2025-11-03\",   \"total_events\": 28,   \"success_days\": 5,   \"failed_days\": [],   \"summary\": \"Planned 5/5 days successfully.\" } ``` 
         * @summary Generate Weekly Plan (Streaming)
         * @param {GenerateWeeklyPlanRequest} generateWeeklyPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyPlan: async (generateWeeklyPlanRequest: GenerateWeeklyPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateWeeklyPlanRequest' is not null or undefined
            assertParamExists('generateWeeklyPlan', 'generateWeeklyPlanRequest', generateWeeklyPlanRequest)
            const localVarPath = `/api/v1/scheduler/weekly_plan/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateWeeklyPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Predict Event Category using rule-based logic and GPT. - application/json
         * @param {PredictEventCategoryRequest} predictEventCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictEventCategory: async (predictEventCategoryRequest: PredictEventCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'predictEventCategoryRequest' is not null or undefined
            assertParamExists('predictEventCategory', 'predictEventCategoryRequest', predictEventCategoryRequest)
            const localVarPath = `/api/v1/scheduler/event_category/predict`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predictEventCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Predict Task Category using rule-based logic and GPT.
         * @param {PredictTaskCategoryRequest} predictTaskCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictTaskCategory: async (predictTaskCategoryRequest: PredictTaskCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'predictTaskCategoryRequest' is not null or undefined
            assertParamExists('predictTaskCategory', 'predictTaskCategoryRequest', predictTaskCategoryRequest)
            const localVarPath = `/api/v1/scheduler/task_category/predict`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predictTaskCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint uses an LLM agent to adjust or generate a schedule based on user input, chat history, and current schedule state. It supports iterative, chat-based schedule refinement. 
         * @summary Agentic AI Scheduler
         * @param {GenerateAISchedulerAgentRequest} generateAISchedulerAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateAISchedulerAgent(generateAISchedulerAgentRequest: GenerateAISchedulerAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAISchedulerAgent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAISchedulerAgent(generateAISchedulerAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateAISchedulerAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint uses Claude Agent SDK to generate a comprehensive daily plan. It loads context from MCP servers (calendar events, tasks, energy zones, sleep patterns, etc.) and uses Claude Agent SDK with MCP integration to create an optimal schedule considering: 1. No scheduling conflicts with existing calendar events 2. Maximum todo list integration (prioritizing by priority value) 3. Work-life balance (user preferences and scheduler rules) 4. Energy and sleep scores for optimal timing  The endpoint automatically routes to either Claude Agent SDK (for complex requests) or a simple scheduler (for simpler requests) based on complexity analysis. The routing decision is included in the response.  All request fields except `user_id` are optional and have defaults. 
         * @summary Generate Daily Plan with Claude Agent SDK
         * @param {GenerateDailyPlanClaudeAgentRequest} generateDailyPlanClaudeAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest: GenerateDailyPlanClaudeAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDailyPlanClaudeAgent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanClaudeAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streaming version of the daily plan generation endpoint. Returns Server-Sent Events (SSE) with progress updates and final result.  Event types: - status_text: User-facing progress updates - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Status messages: 1. \"Preparing your schedule...\" - Initial setup 2. \"Creating your optimal day plan...\" - Main processing 3. \"Finalizing your schedule...\" - Final processing 
         * @summary Generate Daily Plan with Claude Agent SDK (Streaming)
         * @param {GenerateDailyPlanClaudeAgentStreamingRequest} generateDailyPlanClaudeAgentStreamingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest: GenerateDailyPlanClaudeAgentStreamingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanClaudeAgentStreaming']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * v2 daily plan endpoint. Supports both streaming (SSE) and non-streaming (JSON) modes via the `streaming` field.  When `streaming: true`, emits per-item plan events: - status_text: User-facing progress updates - plan_action: Per-item scheduling decision - plan_done: Final per-item summary (scheduled/skipped counts) - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  When `streaming: false` (or omitted), returns a plain JSON response. 
         * @summary Generate Daily Plan v2
         * @param {GenerateDailyPlanV2Request} generateDailyPlanV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDailyPlanV2(generateDailyPlanV2Request: GenerateDailyPlanV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDailyPlanV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanV2(generateDailyPlanV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * v3 daily plan endpoint.  Replaces the single large Claude agent call (v2) with a 3-phase pipeline:  **Phase 1 — Slot Finder** (pure Python, zero AI tokens) Parses existing calendar events, merges busy blocks expanded by buffer_mins, and returns free slots.  **Phase 2 — Anchor Planner** (one small Claude call) Places Breakfast, Lunch, Dinner, and Sleep anchors into available slots.  **Phase 3a — Task Placer** (pure Python, energy-aware bin-packing) Schedules tasks and routines into remaining slots, preferring peak energy zones for high-priority deep-work items.  **Phase 3b — Content Enricher** (concurrent Claude micro-calls) Adds a one-sentence explanation to each event. Meal, sleep, and workout events receive a rich_context card (same builder as chat_streaming_v3) with enrichment_pending=True. plan_action SSE events are emitted progressively as each item completes — the client sees the plan being built in real time.  SSE event sequence: - status_text: User-facing progress updates (one per pipeline phase) - plan_action: Emitted progressively per item as enrichment completes - plan_done: Final summary with scheduled/skipped counts - result_json: Complete schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Request body is identical to v2.  Pass `streaming: true` to receive an SSE stream. Pass `streaming: false` (or omit) to receive a plain JSON response. 
         * @summary Generate Daily Plan v3
         * @param {GenerateDailyPlanV3Request} generateDailyPlanV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDailyPlanV3(generateDailyPlanV3Request: GenerateDailyPlanV3Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDailyPlanV3200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanV3(generateDailyPlanV3Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight onboarding-only daily plan stream.  This endpoint preserves the v3 SSE contract while skipping full daily planning. It fetches only: - get_sleep - get_preferences  Then emits mocked onboarding items: - Tasks: \"Check out the lifestack web app\" - Routine: \"Nap\" - Sleep/meal anchors  SSE event sequence: - status_text - plan_action - plan_done - result_json - stream_end 
         * @summary Generate Daily Plan v3 Mock
         * @param {GenerateDailyPlanV3MockRequest} generateDailyPlanV3MockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDailyPlanV3Mock(generateDailyPlanV3MockRequest: GenerateDailyPlanV3MockRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDailyPlanV3Mock(generateDailyPlanV3MockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateDailyPlanV3Mock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find the best time to place a single routine activity while avoiding existing calendar events. If an earliest/latest window is provided, the activity is scheduled within that window and shortened to fit if necessary. If no window is provided, the scheduler favors matching energy zones based on category/effect, then falls back to the first open slot. 
         * @summary Generate timing for a routine activity
         * @param {GenerateRoutineTimingRequest} generateRoutineTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRoutineTiming(generateRoutineTimingRequest: GenerateRoutineTimingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateRoutineTiming200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRoutineTiming(generateRoutineTimingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateRoutineTiming']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Analyzes todos and energy patterns to suggest optimal timing for tasks without timeboxing constraints. Uses energy-aware scheduling with LLM-powered insights. Tasks are automatically categorized using AI if no category is provided.
         * @summary Find the best time for tasks
         * @param {GenerateTaskTimingRequest} generateTaskTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTaskTiming(generateTaskTimingRequest: GenerateTaskTimingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTaskTiming200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTaskTiming(generateTaskTimingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateTaskTiming']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a complete weekly plan as a Server-Sent Events (SSE) stream. Tasks are pre-allocated across the requested days before planning begins, so each Claude call receives only the subset of tasks assigned to that day. Routines are passed to every day since they recur daily.  Event flow: 1. `status_text`   — \"Preparing your weekly plan...\" (once at the start) 2. Per day (repeated for each day):    a. `status_text`  — \"Planning {DayName} (N/M)...\"    b. `day_start`    — emitted before each day is planned    c. `day_complete` — emitted after each day is planned (includes events or error) 3. `status_text`   — \"Finalizing your weekly plan...\" (before final summary) 4. `week_complete` — emitted once all days are done (summary counts)  SSE event payloads:  **day_start** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"total_days\": 5,   \"current_index\": 0 } ```  **day_complete** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"events\": [...],   \"summary\": \"Planned Monday with 6 scheduled item(s).\",   \"suggestions\": [],   \"error\": null } ```  **week_complete** ```json {   \"week_start\": \"2025-11-03\",   \"total_events\": 28,   \"success_days\": 5,   \"failed_days\": [],   \"summary\": \"Planned 5/5 days successfully.\" } ``` 
         * @summary Generate Weekly Plan (Streaming)
         * @param {GenerateWeeklyPlanRequest} generateWeeklyPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWeeklyPlan(generateWeeklyPlanRequest: GenerateWeeklyPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWeeklyPlan(generateWeeklyPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.generateWeeklyPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Predict Event Category using rule-based logic and GPT. - application/json
         * @param {PredictEventCategoryRequest} predictEventCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictEventCategory(predictEventCategoryRequest: PredictEventCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredictEventCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.predictEventCategory(predictEventCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.predictEventCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Predict Task Category using rule-based logic and GPT.
         * @param {PredictTaskCategoryRequest} predictTaskCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictTaskCategory(predictTaskCategoryRequest: PredictTaskCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredictTaskCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.predictTaskCategory(predictTaskCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.predictTaskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * This endpoint uses an LLM agent to adjust or generate a schedule based on user input, chat history, and current schedule state. It supports iterative, chat-based schedule refinement. 
         * @summary Agentic AI Scheduler
         * @param {GenerateAISchedulerAgentRequest} generateAISchedulerAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateAISchedulerAgent(generateAISchedulerAgentRequest: GenerateAISchedulerAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateAISchedulerAgent200Response> {
            return localVarFp.generateAISchedulerAgent(generateAISchedulerAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint uses Claude Agent SDK to generate a comprehensive daily plan. It loads context from MCP servers (calendar events, tasks, energy zones, sleep patterns, etc.) and uses Claude Agent SDK with MCP integration to create an optimal schedule considering: 1. No scheduling conflicts with existing calendar events 2. Maximum todo list integration (prioritizing by priority value) 3. Work-life balance (user preferences and scheduler rules) 4. Energy and sleep scores for optimal timing  The endpoint automatically routes to either Claude Agent SDK (for complex requests) or a simple scheduler (for simpler requests) based on complexity analysis. The routing decision is included in the response.  All request fields except `user_id` are optional and have defaults. 
         * @summary Generate Daily Plan with Claude Agent SDK
         * @param {GenerateDailyPlanClaudeAgentRequest} generateDailyPlanClaudeAgentRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest: GenerateDailyPlanClaudeAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateDailyPlanClaudeAgent200Response> {
            return localVarFp.generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Streaming version of the daily plan generation endpoint. Returns Server-Sent Events (SSE) with progress updates and final result.  Event types: - status_text: User-facing progress updates - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Status messages: 1. \"Preparing your schedule...\" - Initial setup 2. \"Creating your optimal day plan...\" - Main processing 3. \"Finalizing your schedule...\" - Final processing 
         * @summary Generate Daily Plan with Claude Agent SDK (Streaming)
         * @param {GenerateDailyPlanClaudeAgentStreamingRequest} generateDailyPlanClaudeAgentStreamingRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest: GenerateDailyPlanClaudeAgentStreamingRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * v2 daily plan endpoint. Supports both streaming (SSE) and non-streaming (JSON) modes via the `streaming` field.  When `streaming: true`, emits per-item plan events: - status_text: User-facing progress updates - plan_action: Per-item scheduling decision - plan_done: Final per-item summary (scheduled/skipped counts) - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  When `streaming: false` (or omitted), returns a plain JSON response. 
         * @summary Generate Daily Plan v2
         * @param {GenerateDailyPlanV2Request} generateDailyPlanV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV2(generateDailyPlanV2Request: GenerateDailyPlanV2Request, options?: RawAxiosRequestConfig): AxiosPromise<GenerateDailyPlanV2200Response> {
            return localVarFp.generateDailyPlanV2(generateDailyPlanV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * v3 daily plan endpoint.  Replaces the single large Claude agent call (v2) with a 3-phase pipeline:  **Phase 1 — Slot Finder** (pure Python, zero AI tokens) Parses existing calendar events, merges busy blocks expanded by buffer_mins, and returns free slots.  **Phase 2 — Anchor Planner** (one small Claude call) Places Breakfast, Lunch, Dinner, and Sleep anchors into available slots.  **Phase 3a — Task Placer** (pure Python, energy-aware bin-packing) Schedules tasks and routines into remaining slots, preferring peak energy zones for high-priority deep-work items.  **Phase 3b — Content Enricher** (concurrent Claude micro-calls) Adds a one-sentence explanation to each event. Meal, sleep, and workout events receive a rich_context card (same builder as chat_streaming_v3) with enrichment_pending=True. plan_action SSE events are emitted progressively as each item completes — the client sees the plan being built in real time.  SSE event sequence: - status_text: User-facing progress updates (one per pipeline phase) - plan_action: Emitted progressively per item as enrichment completes - plan_done: Final summary with scheduled/skipped counts - result_json: Complete schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Request body is identical to v2.  Pass `streaming: true` to receive an SSE stream. Pass `streaming: false` (or omit) to receive a plain JSON response. 
         * @summary Generate Daily Plan v3
         * @param {GenerateDailyPlanV3Request} generateDailyPlanV3Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV3(generateDailyPlanV3Request: GenerateDailyPlanV3Request, options?: RawAxiosRequestConfig): AxiosPromise<GenerateDailyPlanV3200Response> {
            return localVarFp.generateDailyPlanV3(generateDailyPlanV3Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight onboarding-only daily plan stream.  This endpoint preserves the v3 SSE contract while skipping full daily planning. It fetches only: - get_sleep - get_preferences  Then emits mocked onboarding items: - Tasks: \"Check out the lifestack web app\" - Routine: \"Nap\" - Sleep/meal anchors  SSE event sequence: - status_text - plan_action - plan_done - result_json - stream_end 
         * @summary Generate Daily Plan v3 Mock
         * @param {GenerateDailyPlanV3MockRequest} generateDailyPlanV3MockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDailyPlanV3Mock(generateDailyPlanV3MockRequest: GenerateDailyPlanV3MockRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateDailyPlanV3Mock(generateDailyPlanV3MockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Find the best time to place a single routine activity while avoiding existing calendar events. If an earliest/latest window is provided, the activity is scheduled within that window and shortened to fit if necessary. If no window is provided, the scheduler favors matching energy zones based on category/effect, then falls back to the first open slot. 
         * @summary Generate timing for a routine activity
         * @param {GenerateRoutineTimingRequest} generateRoutineTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoutineTiming(generateRoutineTimingRequest: GenerateRoutineTimingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateRoutineTiming200Response> {
            return localVarFp.generateRoutineTiming(generateRoutineTimingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Analyzes todos and energy patterns to suggest optimal timing for tasks without timeboxing constraints. Uses energy-aware scheduling with LLM-powered insights. Tasks are automatically categorized using AI if no category is provided.
         * @summary Find the best time for tasks
         * @param {GenerateTaskTimingRequest} generateTaskTimingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTaskTiming(generateTaskTimingRequest: GenerateTaskTimingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateTaskTiming200Response> {
            return localVarFp.generateTaskTiming(generateTaskTimingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a complete weekly plan as a Server-Sent Events (SSE) stream. Tasks are pre-allocated across the requested days before planning begins, so each Claude call receives only the subset of tasks assigned to that day. Routines are passed to every day since they recur daily.  Event flow: 1. `status_text`   — \"Preparing your weekly plan...\" (once at the start) 2. Per day (repeated for each day):    a. `status_text`  — \"Planning {DayName} (N/M)...\"    b. `day_start`    — emitted before each day is planned    c. `day_complete` — emitted after each day is planned (includes events or error) 3. `status_text`   — \"Finalizing your weekly plan...\" (before final summary) 4. `week_complete` — emitted once all days are done (summary counts)  SSE event payloads:  **day_start** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"total_days\": 5,   \"current_index\": 0 } ```  **day_complete** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"events\": [...],   \"summary\": \"Planned Monday with 6 scheduled item(s).\",   \"suggestions\": [],   \"error\": null } ```  **week_complete** ```json {   \"week_start\": \"2025-11-03\",   \"total_events\": 28,   \"success_days\": 5,   \"failed_days\": [],   \"summary\": \"Planned 5/5 days successfully.\" } ``` 
         * @summary Generate Weekly Plan (Streaming)
         * @param {GenerateWeeklyPlanRequest} generateWeeklyPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyPlan(generateWeeklyPlanRequest: GenerateWeeklyPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateWeeklyPlan(generateWeeklyPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Predict Event Category using rule-based logic and GPT. - application/json
         * @param {PredictEventCategoryRequest} predictEventCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictEventCategory(predictEventCategoryRequest: PredictEventCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredictEventCategory200Response> {
            return localVarFp.predictEventCategory(predictEventCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Predict Task Category using rule-based logic and GPT.
         * @param {PredictTaskCategoryRequest} predictTaskCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictTaskCategory(predictTaskCategoryRequest: PredictTaskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PredictTaskCategory200Response> {
            return localVarFp.predictTaskCategory(predictTaskCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * This endpoint uses an LLM agent to adjust or generate a schedule based on user input, chat history, and current schedule state. It supports iterative, chat-based schedule refinement. 
     * @summary Agentic AI Scheduler
     * @param {GenerateAISchedulerAgentRequest} generateAISchedulerAgentRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateAISchedulerAgent(generateAISchedulerAgentRequest: GenerateAISchedulerAgentRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateAISchedulerAgent(generateAISchedulerAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint uses Claude Agent SDK to generate a comprehensive daily plan. It loads context from MCP servers (calendar events, tasks, energy zones, sleep patterns, etc.) and uses Claude Agent SDK with MCP integration to create an optimal schedule considering: 1. No scheduling conflicts with existing calendar events 2. Maximum todo list integration (prioritizing by priority value) 3. Work-life balance (user preferences and scheduler rules) 4. Energy and sleep scores for optimal timing  The endpoint automatically routes to either Claude Agent SDK (for complex requests) or a simple scheduler (for simpler requests) based on complexity analysis. The routing decision is included in the response.  All request fields except `user_id` are optional and have defaults. 
     * @summary Generate Daily Plan with Claude Agent SDK
     * @param {GenerateDailyPlanClaudeAgentRequest} generateDailyPlanClaudeAgentRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest: GenerateDailyPlanClaudeAgentRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanClaudeAgent(generateDailyPlanClaudeAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streaming version of the daily plan generation endpoint. Returns Server-Sent Events (SSE) with progress updates and final result.  Event types: - status_text: User-facing progress updates - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Status messages: 1. \"Preparing your schedule...\" - Initial setup 2. \"Creating your optimal day plan...\" - Main processing 3. \"Finalizing your schedule...\" - Final processing 
     * @summary Generate Daily Plan with Claude Agent SDK (Streaming)
     * @param {GenerateDailyPlanClaudeAgentStreamingRequest} generateDailyPlanClaudeAgentStreamingRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest: GenerateDailyPlanClaudeAgentStreamingRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanClaudeAgentStreaming(generateDailyPlanClaudeAgentStreamingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * v2 daily plan endpoint. Supports both streaming (SSE) and non-streaming (JSON) modes via the `streaming` field.  When `streaming: true`, emits per-item plan events: - status_text: User-facing progress updates - plan_action: Per-item scheduling decision - plan_done: Final per-item summary (scheduled/skipped counts) - result_json: Final schedule result - error: Error message if generation failed - stream_end: Stream completion signal  When `streaming: false` (or omitted), returns a plain JSON response. 
     * @summary Generate Daily Plan v2
     * @param {GenerateDailyPlanV2Request} generateDailyPlanV2Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanV2(generateDailyPlanV2Request: GenerateDailyPlanV2Request, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanV2(generateDailyPlanV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * v3 daily plan endpoint.  Replaces the single large Claude agent call (v2) with a 3-phase pipeline:  **Phase 1 — Slot Finder** (pure Python, zero AI tokens) Parses existing calendar events, merges busy blocks expanded by buffer_mins, and returns free slots.  **Phase 2 — Anchor Planner** (one small Claude call) Places Breakfast, Lunch, Dinner, and Sleep anchors into available slots.  **Phase 3a — Task Placer** (pure Python, energy-aware bin-packing) Schedules tasks and routines into remaining slots, preferring peak energy zones for high-priority deep-work items.  **Phase 3b — Content Enricher** (concurrent Claude micro-calls) Adds a one-sentence explanation to each event. Meal, sleep, and workout events receive a rich_context card (same builder as chat_streaming_v3) with enrichment_pending=True. plan_action SSE events are emitted progressively as each item completes — the client sees the plan being built in real time.  SSE event sequence: - status_text: User-facing progress updates (one per pipeline phase) - plan_action: Emitted progressively per item as enrichment completes - plan_done: Final summary with scheduled/skipped counts - result_json: Complete schedule result - error: Error message if generation failed - stream_end: Stream completion signal  Request body is identical to v2.  Pass `streaming: true` to receive an SSE stream. Pass `streaming: false` (or omit) to receive a plain JSON response. 
     * @summary Generate Daily Plan v3
     * @param {GenerateDailyPlanV3Request} generateDailyPlanV3Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanV3(generateDailyPlanV3Request: GenerateDailyPlanV3Request, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanV3(generateDailyPlanV3Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight onboarding-only daily plan stream.  This endpoint preserves the v3 SSE contract while skipping full daily planning. It fetches only: - get_sleep - get_preferences  Then emits mocked onboarding items: - Tasks: \"Check out the lifestack web app\" - Routine: \"Nap\" - Sleep/meal anchors  SSE event sequence: - status_text - plan_action - plan_done - result_json - stream_end 
     * @summary Generate Daily Plan v3 Mock
     * @param {GenerateDailyPlanV3MockRequest} generateDailyPlanV3MockRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateDailyPlanV3Mock(generateDailyPlanV3MockRequest: GenerateDailyPlanV3MockRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateDailyPlanV3Mock(generateDailyPlanV3MockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find the best time to place a single routine activity while avoiding existing calendar events. If an earliest/latest window is provided, the activity is scheduled within that window and shortened to fit if necessary. If no window is provided, the scheduler favors matching energy zones based on category/effect, then falls back to the first open slot. 
     * @summary Generate timing for a routine activity
     * @param {GenerateRoutineTimingRequest} generateRoutineTimingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateRoutineTiming(generateRoutineTimingRequest: GenerateRoutineTimingRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateRoutineTiming(generateRoutineTimingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analyzes todos and energy patterns to suggest optimal timing for tasks without timeboxing constraints. Uses energy-aware scheduling with LLM-powered insights. Tasks are automatically categorized using AI if no category is provided.
     * @summary Find the best time for tasks
     * @param {GenerateTaskTimingRequest} generateTaskTimingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateTaskTiming(generateTaskTimingRequest: GenerateTaskTimingRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateTaskTiming(generateTaskTimingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a complete weekly plan as a Server-Sent Events (SSE) stream. Tasks are pre-allocated across the requested days before planning begins, so each Claude call receives only the subset of tasks assigned to that day. Routines are passed to every day since they recur daily.  Event flow: 1. `status_text`   — \"Preparing your weekly plan...\" (once at the start) 2. Per day (repeated for each day):    a. `status_text`  — \"Planning {DayName} (N/M)...\"    b. `day_start`    — emitted before each day is planned    c. `day_complete` — emitted after each day is planned (includes events or error) 3. `status_text`   — \"Finalizing your weekly plan...\" (before final summary) 4. `week_complete` — emitted once all days are done (summary counts)  SSE event payloads:  **day_start** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"total_days\": 5,   \"current_index\": 0 } ```  **day_complete** ```json {   \"date\": \"2025-11-03\",   \"day_name\": \"Monday\",   \"events\": [...],   \"summary\": \"Planned Monday with 6 scheduled item(s).\",   \"suggestions\": [],   \"error\": null } ```  **week_complete** ```json {   \"week_start\": \"2025-11-03\",   \"total_events\": 28,   \"success_days\": 5,   \"failed_days\": [],   \"summary\": \"Planned 5/5 days successfully.\" } ``` 
     * @summary Generate Weekly Plan (Streaming)
     * @param {GenerateWeeklyPlanRequest} generateWeeklyPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public generateWeeklyPlan(generateWeeklyPlanRequest: GenerateWeeklyPlanRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).generateWeeklyPlan(generateWeeklyPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Predict Event Category using rule-based logic and GPT. - application/json
     * @param {PredictEventCategoryRequest} predictEventCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public predictEventCategory(predictEventCategoryRequest: PredictEventCategoryRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).predictEventCategory(predictEventCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Predict Task Category using rule-based logic and GPT.
     * @param {PredictTaskCategoryRequest} predictTaskCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public predictTaskCategory(predictTaskCategoryRequest: PredictTaskCategoryRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).predictTaskCategory(predictTaskCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerRulesApi - axios parameter creator
 * @export
 */
export const SchedulerRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new scheduler rule for a user. The rule will be stored as a semantic note with the \'scheduler_rule\' tag and can be used by the AI scheduler for personalized scheduling. 
         * @summary Create a new scheduler rule
         * @param {ApiV1SchedulerRulesCreatePostRequest} apiV1SchedulerRulesCreatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesCreatePost: async (apiV1SchedulerRulesCreatePostRequest: ApiV1SchedulerRulesCreatePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1SchedulerRulesCreatePostRequest' is not null or undefined
            assertParamExists('apiV1SchedulerRulesCreatePost', 'apiV1SchedulerRulesCreatePostRequest', apiV1SchedulerRulesCreatePostRequest)
            const localVarPath = `/api/v1/scheduler/rules/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SchedulerRulesCreatePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing scheduler rule by matching the content text. The rule will be permanently removed from the user\'s semantic memory. 
         * @summary Delete a scheduler rule
         * @param {ApiV1SchedulerRulesDeletePostRequest} apiV1SchedulerRulesDeletePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesDeletePost: async (apiV1SchedulerRulesDeletePostRequest: ApiV1SchedulerRulesDeletePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1SchedulerRulesDeletePostRequest' is not null or undefined
            assertParamExists('apiV1SchedulerRulesDeletePost', 'apiV1SchedulerRulesDeletePostRequest', apiV1SchedulerRulesDeletePostRequest)
            const localVarPath = `/api/v1/scheduler/rules/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SchedulerRulesDeletePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all scheduler rules (semantic notes tagged with \'scheduler_rule\') for a specific user. These rules are used by the AI scheduler to personalize scheduling decisions. 
         * @summary List all scheduler rules for a user
         * @param {string} userId The unique identifier for the user
         * @param {number} [limit] Maximum number of rules to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesListGet: async (userId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1SchedulerRulesListGet', 'userId', userId)
            const localVarPath = `/api/v1/scheduler/rules/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing scheduler rule by replacing old content with new content. The rule is identified by matching the old_content text. 
         * @summary Update an existing scheduler rule
         * @param {ApiV1SchedulerRulesUpdatePostRequest} apiV1SchedulerRulesUpdatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesUpdatePost: async (apiV1SchedulerRulesUpdatePostRequest: ApiV1SchedulerRulesUpdatePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1SchedulerRulesUpdatePostRequest' is not null or undefined
            assertParamExists('apiV1SchedulerRulesUpdatePost', 'apiV1SchedulerRulesUpdatePostRequest', apiV1SchedulerRulesUpdatePostRequest)
            const localVarPath = `/api/v1/scheduler/rules/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SchedulerRulesUpdatePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerRulesApi - functional programming interface
 * @export
 */
export const SchedulerRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerRulesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new scheduler rule for a user. The rule will be stored as a semantic note with the \'scheduler_rule\' tag and can be used by the AI scheduler for personalized scheduling. 
         * @summary Create a new scheduler rule
         * @param {ApiV1SchedulerRulesCreatePostRequest} apiV1SchedulerRulesCreatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest: ApiV1SchedulerRulesCreatePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SchedulerRulesCreatePost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerRulesApi.apiV1SchedulerRulesCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing scheduler rule by matching the content text. The rule will be permanently removed from the user\'s semantic memory. 
         * @summary Delete a scheduler rule
         * @param {ApiV1SchedulerRulesDeletePostRequest} apiV1SchedulerRulesDeletePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest: ApiV1SchedulerRulesDeletePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SchedulerRulesDeletePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerRulesApi.apiV1SchedulerRulesDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all scheduler rules (semantic notes tagged with \'scheduler_rule\') for a specific user. These rules are used by the AI scheduler to personalize scheduling decisions. 
         * @summary List all scheduler rules for a user
         * @param {string} userId The unique identifier for the user
         * @param {number} [limit] Maximum number of rules to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SchedulerRulesListGet(userId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SchedulerRulesListGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SchedulerRulesListGet(userId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerRulesApi.apiV1SchedulerRulesListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing scheduler rule by replacing old content with new content. The rule is identified by matching the old_content text. 
         * @summary Update an existing scheduler rule
         * @param {ApiV1SchedulerRulesUpdatePostRequest} apiV1SchedulerRulesUpdatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest: ApiV1SchedulerRulesUpdatePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SchedulerRulesUpdatePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerRulesApi.apiV1SchedulerRulesUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerRulesApi - factory interface
 * @export
 */
export const SchedulerRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerRulesApiFp(configuration)
    return {
        /**
         * Create a new scheduler rule for a user. The rule will be stored as a semantic note with the \'scheduler_rule\' tag and can be used by the AI scheduler for personalized scheduling. 
         * @summary Create a new scheduler rule
         * @param {ApiV1SchedulerRulesCreatePostRequest} apiV1SchedulerRulesCreatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest: ApiV1SchedulerRulesCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SchedulerRulesCreatePost201Response> {
            return localVarFp.apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing scheduler rule by matching the content text. The rule will be permanently removed from the user\'s semantic memory. 
         * @summary Delete a scheduler rule
         * @param {ApiV1SchedulerRulesDeletePostRequest} apiV1SchedulerRulesDeletePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest: ApiV1SchedulerRulesDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SchedulerRulesDeletePost200Response> {
            return localVarFp.apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all scheduler rules (semantic notes tagged with \'scheduler_rule\') for a specific user. These rules are used by the AI scheduler to personalize scheduling decisions. 
         * @summary List all scheduler rules for a user
         * @param {string} userId The unique identifier for the user
         * @param {number} [limit] Maximum number of rules to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesListGet(userId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SchedulerRulesListGet200Response> {
            return localVarFp.apiV1SchedulerRulesListGet(userId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing scheduler rule by replacing old content with new content. The rule is identified by matching the old_content text. 
         * @summary Update an existing scheduler rule
         * @param {ApiV1SchedulerRulesUpdatePostRequest} apiV1SchedulerRulesUpdatePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest: ApiV1SchedulerRulesUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SchedulerRulesUpdatePost200Response> {
            return localVarFp.apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerRulesApi - object-oriented interface
 * @export
 * @class SchedulerRulesApi
 * @extends {BaseAPI}
 */
export class SchedulerRulesApi extends BaseAPI {
    /**
     * Create a new scheduler rule for a user. The rule will be stored as a semantic note with the \'scheduler_rule\' tag and can be used by the AI scheduler for personalized scheduling. 
     * @summary Create a new scheduler rule
     * @param {ApiV1SchedulerRulesCreatePostRequest} apiV1SchedulerRulesCreatePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerRulesApi
     */
    public apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest: ApiV1SchedulerRulesCreatePostRequest, options?: RawAxiosRequestConfig) {
        return SchedulerRulesApiFp(this.configuration).apiV1SchedulerRulesCreatePost(apiV1SchedulerRulesCreatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing scheduler rule by matching the content text. The rule will be permanently removed from the user\'s semantic memory. 
     * @summary Delete a scheduler rule
     * @param {ApiV1SchedulerRulesDeletePostRequest} apiV1SchedulerRulesDeletePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerRulesApi
     */
    public apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest: ApiV1SchedulerRulesDeletePostRequest, options?: RawAxiosRequestConfig) {
        return SchedulerRulesApiFp(this.configuration).apiV1SchedulerRulesDeletePost(apiV1SchedulerRulesDeletePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all scheduler rules (semantic notes tagged with \'scheduler_rule\') for a specific user. These rules are used by the AI scheduler to personalize scheduling decisions. 
     * @summary List all scheduler rules for a user
     * @param {string} userId The unique identifier for the user
     * @param {number} [limit] Maximum number of rules to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerRulesApi
     */
    public apiV1SchedulerRulesListGet(userId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return SchedulerRulesApiFp(this.configuration).apiV1SchedulerRulesListGet(userId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing scheduler rule by replacing old content with new content. The rule is identified by matching the old_content text. 
     * @summary Update an existing scheduler rule
     * @param {ApiV1SchedulerRulesUpdatePostRequest} apiV1SchedulerRulesUpdatePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerRulesApi
     */
    public apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest: ApiV1SchedulerRulesUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return SchedulerRulesApiFp(this.configuration).apiV1SchedulerRulesUpdatePost(apiV1SchedulerRulesUpdatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SleepApi - axios parameter creator
 * @export
 */
export const SleepApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This API calculates the sleep score using REM, deep, light sleep durations, and sleep/wake times.
         * @summary Calculates the sleep score based on the provided sleep stage durations and sleep/wake times
         * @param {CalcSleepScoreRequest} calcSleepScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcSleepScore: async (calcSleepScoreRequest: CalcSleepScoreRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calcSleepScoreRequest' is not null or undefined
            assertParamExists('calcSleepScore', 'calcSleepScoreRequest', calcSleepScoreRequest)
            const localVarPath = `/api/v1/sleep/calc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calcSleepScoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API calculates the sleep score using sleep and wake time without stage values.
         * @summary Calculates the sleep score based on the provided sleep in case no stage values are provided.
         * @param {CalcSleepScoreSimpleRequest} calcSleepScoreSimpleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcSleepScoreSimple: async (calcSleepScoreSimpleRequest: CalcSleepScoreSimpleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calcSleepScoreSimpleRequest' is not null or undefined
            assertParamExists('calcSleepScoreSimple', 'calcSleepScoreSimpleRequest', calcSleepScoreSimpleRequest)
            const localVarPath = `/api/v1/sleep/calc_simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calcSleepScoreSimpleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analyzes 2 weeks of historical sleep data to determine chronotype (morning, hybrid, or night) based on mid-sleep timing. Uses Roenneberg et al. (2015) research methodology with percentile bands for chronotype classification. Handles sleep times that cross midnight correctly using modulo arithmetic.
         * @summary Diagnose chronotype from historical sleep data
         * @param {DiagnoseChronotypeRequest} diagnoseChronotypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseChronotype: async (diagnoseChronotypeRequest: DiagnoseChronotypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'diagnoseChronotypeRequest' is not null or undefined
            assertParamExists('diagnoseChronotype', 'diagnoseChronotypeRequest', diagnoseChronotypeRequest)
            const localVarPath = `/api/v1/sleep/chronotype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diagnoseChronotypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analyzes historical sleep/wake times and calendar events to provide personalized sleep recommendations using Andrew Huberman\'s principles via LLM. Uses default schedule (11:30 PM - 7:30 AM) when no historical data is provided.
         * @summary Generate ideal sleep recommendations based on historical sleep patterns and calendar constraints
         * @param {GenerateIdealSleepRequest} generateIdealSleepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateIdealSleep: async (generateIdealSleepRequest: GenerateIdealSleepRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateIdealSleepRequest' is not null or undefined
            assertParamExists('generateIdealSleep', 'generateIdealSleepRequest', generateIdealSleepRequest)
            const localVarPath = `/api/v1/sleep/ideal_sleep/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateIdealSleepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SleepApi - functional programming interface
 * @export
 */
export const SleepApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SleepApiAxiosParamCreator(configuration)
    return {
        /**
         * This API calculates the sleep score using REM, deep, light sleep durations, and sleep/wake times.
         * @summary Calculates the sleep score based on the provided sleep stage durations and sleep/wake times
         * @param {CalcSleepScoreRequest} calcSleepScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calcSleepScore(calcSleepScoreRequest: CalcSleepScoreRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calcSleepScore(calcSleepScoreRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepApi.calcSleepScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This API calculates the sleep score using sleep and wake time without stage values.
         * @summary Calculates the sleep score based on the provided sleep in case no stage values are provided.
         * @param {CalcSleepScoreSimpleRequest} calcSleepScoreSimpleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calcSleepScoreSimple(calcSleepScoreSimpleRequest: CalcSleepScoreSimpleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calcSleepScoreSimple(calcSleepScoreSimpleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepApi.calcSleepScoreSimple']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Analyzes 2 weeks of historical sleep data to determine chronotype (morning, hybrid, or night) based on mid-sleep timing. Uses Roenneberg et al. (2015) research methodology with percentile bands for chronotype classification. Handles sleep times that cross midnight correctly using modulo arithmetic.
         * @summary Diagnose chronotype from historical sleep data
         * @param {DiagnoseChronotypeRequest} diagnoseChronotypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async diagnoseChronotype(diagnoseChronotypeRequest: DiagnoseChronotypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnoseChronotype200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.diagnoseChronotype(diagnoseChronotypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepApi.diagnoseChronotype']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Analyzes historical sleep/wake times and calendar events to provide personalized sleep recommendations using Andrew Huberman\'s principles via LLM. Uses default schedule (11:30 PM - 7:30 AM) when no historical data is provided.
         * @summary Generate ideal sleep recommendations based on historical sleep patterns and calendar constraints
         * @param {GenerateIdealSleepRequest} generateIdealSleepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateIdealSleep(generateIdealSleepRequest: GenerateIdealSleepRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateIdealSleep200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateIdealSleep(generateIdealSleepRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SleepApi.generateIdealSleep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SleepApi - factory interface
 * @export
 */
export const SleepApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SleepApiFp(configuration)
    return {
        /**
         * This API calculates the sleep score using REM, deep, light sleep durations, and sleep/wake times.
         * @summary Calculates the sleep score based on the provided sleep stage durations and sleep/wake times
         * @param {CalcSleepScoreRequest} calcSleepScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcSleepScore(calcSleepScoreRequest: CalcSleepScoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.calcSleepScore(calcSleepScoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This API calculates the sleep score using sleep and wake time without stage values.
         * @summary Calculates the sleep score based on the provided sleep in case no stage values are provided.
         * @param {CalcSleepScoreSimpleRequest} calcSleepScoreSimpleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcSleepScoreSimple(calcSleepScoreSimpleRequest: CalcSleepScoreSimpleRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.calcSleepScoreSimple(calcSleepScoreSimpleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Analyzes 2 weeks of historical sleep data to determine chronotype (morning, hybrid, or night) based on mid-sleep timing. Uses Roenneberg et al. (2015) research methodology with percentile bands for chronotype classification. Handles sleep times that cross midnight correctly using modulo arithmetic.
         * @summary Diagnose chronotype from historical sleep data
         * @param {DiagnoseChronotypeRequest} diagnoseChronotypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnoseChronotype(diagnoseChronotypeRequest: DiagnoseChronotypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiagnoseChronotype200Response> {
            return localVarFp.diagnoseChronotype(diagnoseChronotypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Analyzes historical sleep/wake times and calendar events to provide personalized sleep recommendations using Andrew Huberman\'s principles via LLM. Uses default schedule (11:30 PM - 7:30 AM) when no historical data is provided.
         * @summary Generate ideal sleep recommendations based on historical sleep patterns and calendar constraints
         * @param {GenerateIdealSleepRequest} generateIdealSleepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateIdealSleep(generateIdealSleepRequest: GenerateIdealSleepRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateIdealSleep200Response> {
            return localVarFp.generateIdealSleep(generateIdealSleepRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SleepApi - object-oriented interface
 * @export
 * @class SleepApi
 * @extends {BaseAPI}
 */
export class SleepApi extends BaseAPI {
    /**
     * This API calculates the sleep score using REM, deep, light sleep durations, and sleep/wake times.
     * @summary Calculates the sleep score based on the provided sleep stage durations and sleep/wake times
     * @param {CalcSleepScoreRequest} calcSleepScoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepApi
     */
    public calcSleepScore(calcSleepScoreRequest: CalcSleepScoreRequest, options?: RawAxiosRequestConfig) {
        return SleepApiFp(this.configuration).calcSleepScore(calcSleepScoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API calculates the sleep score using sleep and wake time without stage values.
     * @summary Calculates the sleep score based on the provided sleep in case no stage values are provided.
     * @param {CalcSleepScoreSimpleRequest} calcSleepScoreSimpleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepApi
     */
    public calcSleepScoreSimple(calcSleepScoreSimpleRequest: CalcSleepScoreSimpleRequest, options?: RawAxiosRequestConfig) {
        return SleepApiFp(this.configuration).calcSleepScoreSimple(calcSleepScoreSimpleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analyzes 2 weeks of historical sleep data to determine chronotype (morning, hybrid, or night) based on mid-sleep timing. Uses Roenneberg et al. (2015) research methodology with percentile bands for chronotype classification. Handles sleep times that cross midnight correctly using modulo arithmetic.
     * @summary Diagnose chronotype from historical sleep data
     * @param {DiagnoseChronotypeRequest} diagnoseChronotypeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepApi
     */
    public diagnoseChronotype(diagnoseChronotypeRequest: DiagnoseChronotypeRequest, options?: RawAxiosRequestConfig) {
        return SleepApiFp(this.configuration).diagnoseChronotype(diagnoseChronotypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analyzes historical sleep/wake times and calendar events to provide personalized sleep recommendations using Andrew Huberman\'s principles via LLM. Uses default schedule (11:30 PM - 7:30 AM) when no historical data is provided.
     * @summary Generate ideal sleep recommendations based on historical sleep patterns and calendar constraints
     * @param {GenerateIdealSleepRequest} generateIdealSleepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SleepApi
     */
    public generateIdealSleep(generateIdealSleepRequest: GenerateIdealSleepRequest, options?: RawAxiosRequestConfig) {
        return SleepApiFp(this.configuration).generateIdealSleep(generateIdealSleepRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


